
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebc30"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebc30"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $c96d6338d84b7110$exports = {};
$parcel$extendImportMap({
    "ctuFy": "catalogue.6e1558be.png",
    "9s4Us": "pentest.2a84e418.png",
    "h32ee": "sfe.455ac0e5.png",
    "3Ag3a": "bell.31c30657.svg",
    "1pAQF": "bell_dark.540c7795.svg"
});

function $d0d8c87c315c20c8$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $b62be182d8770687$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $d0d8c87c315c20c8$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $f7cf469f0d5164c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f7cf469f0d5164c0$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f7cf469f0d5164c0$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $06484a9711eaa5fc$var$e(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
    }
    return n;
}
"function" == typeof SuppressedError && SuppressedError;
const $06484a9711eaa5fc$var$t = {
    timeoutInSeconds: 60
}, $06484a9711eaa5fc$var$n = {
    name: "auth0-spa-js",
    version: "2.17.0"
}, $06484a9711eaa5fc$var$o = ()=>Date.now();
class $06484a9711eaa5fc$export$7d465be8efa67280 extends Error {
    static fromPayload(e) {
        let { error: t, error_description: n } = e;
        return new $06484a9711eaa5fc$export$7d465be8efa67280(t, n);
    }
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$7d465be8efa67280.prototype);
    }
}
class $06484a9711eaa5fc$export$cf0c46b07324e9c5 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e, t, n){
        let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        super(e, t), this.state = n, this.appState = o, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$cf0c46b07324e9c5.prototype);
    }
}
class $06484a9711eaa5fc$export$aaa3fc6bdea78d4d extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
        super(e, t), this.connection = n, this.state = o, this.appState = r, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$aaa3fc6bdea78d4d.prototype);
    }
}
class $06484a9711eaa5fc$export$66d311bf29d5c89c extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$66d311bf29d5c89c.prototype);
    }
}
class $06484a9711eaa5fc$export$ebbb83fe03f719a4 extends $06484a9711eaa5fc$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$ebbb83fe03f719a4.prototype);
    }
}
class $06484a9711eaa5fc$export$f1f681f0fb26bb55 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$f1f681f0fb26bb55.prototype);
    }
}
class $06484a9711eaa5fc$export$d52312082b7f6392 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(){
        super("popup_open", "Unable to open a popup for loginWithPopup - window.open returned `null`"), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$d52312082b7f6392.prototype);
    }
}
class $06484a9711eaa5fc$export$c59494f4dae44ada extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        super(e, t), this.mfa_token = n, this.mfa_requirements = o, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$c59494f4dae44ada.prototype);
    }
}
class $06484a9711eaa5fc$export$ac1d2a00f8e0a046 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", "Missing Refresh Token (audience: '".concat($06484a9711eaa5fc$var$m(e, [
            "default"
        ]), "', scope: '").concat($06484a9711eaa5fc$var$m(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$ac1d2a00f8e0a046.prototype);
    }
}
class $06484a9711eaa5fc$var$p extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_scopes", "Missing requested scopes after refresh (audience: '".concat($06484a9711eaa5fc$var$m(e, [
            "default"
        ]), "', missing scope: '").concat($06484a9711eaa5fc$var$m(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $06484a9711eaa5fc$var$p.prototype);
    }
}
class $06484a9711eaa5fc$export$ffb710231177fce3 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    constructor(e){
        super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = e, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$ffb710231177fce3.prototype);
    }
}
function $06484a9711eaa5fc$var$m(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    return e && !t.includes(e) ? e : "";
}
const $06484a9711eaa5fc$var$y = ()=>window.crypto, $06484a9711eaa5fc$var$w = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($06484a9711eaa5fc$var$y().getRandomValues(new Uint8Array(43))).forEach((n)=>t += e[n % e.length]), t;
}, $06484a9711eaa5fc$var$g = (e)=>btoa(e), $06484a9711eaa5fc$var$v = [
    {
        key: "name",
        type: [
            "string"
        ]
    },
    {
        key: "version",
        type: [
            "string",
            "number"
        ]
    },
    {
        key: "env",
        type: [
            "object"
        ]
    }
], $06484a9711eaa5fc$var$b = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Object.keys(e).reduce((n, o)=>{
        if (t && "env" === o) return n;
        const r = $06484a9711eaa5fc$var$v.find((e)=>e.key === o);
        return r && r.type.includes(typeof e[o]) && (n[o] = e[o]), n;
    }, {});
}, $06484a9711eaa5fc$var$_ = (t)=>{
    var { clientId: n } = t, o = $06484a9711eaa5fc$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, n)=>Object.assign(Object.assign({}, t), {
                [n]: e[n]
            }), {}))(Object.assign({
        client_id: n
    }, o))).toString();
}, $06484a9711eaa5fc$var$k = async (e)=>{
    const t = $06484a9711eaa5fc$var$y().subtle.digest({
        name: "SHA-256"
    }, (new TextEncoder).encode(e));
    return await t;
}, $06484a9711eaa5fc$var$S = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $06484a9711eaa5fc$var$E = (e)=>{
    const t = new Uint8Array(e);
    return ((e)=>{
        const t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, (e)=>t[e]);
    })(window.btoa(String.fromCharCode(...Array.from(t))));
};
var $06484a9711eaa5fc$var$T = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, $06484a9711eaa5fc$var$A = {}, $06484a9711eaa5fc$var$P = {};
Object.defineProperty($06484a9711eaa5fc$var$P, "__esModule", {
    value: !0
});
var $06484a9711eaa5fc$var$R = function() {
    function e() {
        var e = this;
        this.locked = new Map, this.addToLocked = function(t, n) {
            var o = e.locked.get(t);
            void 0 === o ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [
                n
            ]) : void 0 !== n && (o.unshift(n), e.locked.set(t, o));
        }, this.isLocked = function(t) {
            return e.locked.has(t);
        }, this.lock = function(t) {
            return new Promise(function(n, o) {
                e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
            });
        }, this.unlock = function(t) {
            var n = e.locked.get(t);
            if (void 0 !== n && 0 !== n.length) {
                var o = n.pop();
                e.locked.set(t, n), void 0 !== o && setTimeout(o, 0);
            } else e.locked.delete(t);
        };
    }
    return e.getInstance = function() {
        return void 0 === e.instance && (e.instance = new e), e.instance;
    }, e;
}();
$06484a9711eaa5fc$var$P.default = function() {
    return $06484a9711eaa5fc$var$R.getInstance();
};
var $06484a9711eaa5fc$var$I = $06484a9711eaa5fc$var$T && $06484a9711eaa5fc$var$T.__awaiter || function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                c(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            try {
                c(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            e.done ? r(e.value) : new n(function(t) {
                t(e.value);
            }).then(a, s);
        }
        c((o = o.apply(e, t || [])).next());
    });
}, $06484a9711eaa5fc$var$x = $06484a9711eaa5fc$var$T && $06484a9711eaa5fc$var$T.__generator || function(e, t) {
    var n, o, r, i, a = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(i) {
        return function(s) {
            return function(i) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;
                    switch(o = 0, r && (i = [
                        2 & i[0],
                        r.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            r = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, o = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < r[1]) {
                                a.label = r[1], r = i;
                                break;
                            }
                            if (r && a.label < r[2]) {
                                a.label = r[2], a.ops.push(i);
                                break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = t.call(e, a);
                } catch (e) {
                    i = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                s
            ]);
        };
    }
}, $06484a9711eaa5fc$var$O = $06484a9711eaa5fc$var$T;
Object.defineProperty($06484a9711eaa5fc$var$A, "__esModule", {
    value: !0
});
var $06484a9711eaa5fc$var$C = $06484a9711eaa5fc$var$P, $06484a9711eaa5fc$var$j = {
    key: function(e) {
        return $06484a9711eaa5fc$var$I($06484a9711eaa5fc$var$O, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    getItem: function(e) {
        return $06484a9711eaa5fc$var$I($06484a9711eaa5fc$var$O, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    clear: function() {
        return $06484a9711eaa5fc$var$I($06484a9711eaa5fc$var$O, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(e) {
                return [
                    2,
                    window.localStorage.clear()
                ];
            });
        });
    },
    removeItem: function(e) {
        return $06484a9711eaa5fc$var$I($06484a9711eaa5fc$var$O, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    setItem: function(e, t) {
        return $06484a9711eaa5fc$var$I($06484a9711eaa5fc$var$O, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    keySync: function(e) {
        return window.localStorage.key(e);
    },
    getItemSync: function(e) {
        return window.localStorage.getItem(e);
    },
    clearSync: function() {
        return window.localStorage.clear();
    },
    removeItemSync: function(e) {
        return window.localStorage.removeItem(e);
    },
    setItemSync: function(e, t) {
        return window.localStorage.setItem(e, t);
    }
};
function $06484a9711eaa5fc$var$D(e) {
    return new Promise(function(t) {
        return setTimeout(t, e);
    });
}
function $06484a9711eaa5fc$var$K(e) {
    for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", o = 0; o < e; o++)n += t[Math.floor(Math.random() * t.length)];
    return n;
}
var $06484a9711eaa5fc$var$L = function() {
    function e(t) {
        this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + $06484a9711eaa5fc$var$K(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
    }
    return e.prototype.acquireLock = function(t, n) {
        return void 0 === n && (n = 5e3), $06484a9711eaa5fc$var$I(this, void 0, void 0, function() {
            var o, r, i, a, s, c, u;
            return $06484a9711eaa5fc$var$x(this, function(l) {
                switch(l.label){
                    case 0:
                        o = Date.now() + $06484a9711eaa5fc$var$K(4), r = Date.now() + n, i = "browser-tabs-lock-key-" + t, a = void 0 === this.storageHandler ? $06484a9711eaa5fc$var$j : this.storageHandler, l.label = 1;
                    case 1:
                        return Date.now() < r ? [
                            4,
                            $06484a9711eaa5fc$var$D(30)
                        ] : [
                            3,
                            8
                        ];
                    case 2:
                        return l.sent(), null !== a.getItemSync(i) ? [
                            3,
                            5
                        ] : (s = this.id + "-" + t + "-" + o, [
                            4,
                            $06484a9711eaa5fc$var$D(Math.floor(25 * Math.random()))
                        ]);
                    case 3:
                        return l.sent(), a.setItemSync(i, JSON.stringify({
                            id: this.id,
                            iat: o,
                            timeoutKey: s,
                            timeAcquired: Date.now(),
                            timeRefreshed: Date.now()
                        })), [
                            4,
                            $06484a9711eaa5fc$var$D(30)
                        ];
                    case 4:
                        return l.sent(), null !== (c = a.getItemSync(i)) && (u = JSON.parse(c)).id === this.id && u.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(i, o), [
                            2,
                            !0
                        ]) : [
                            3,
                            7
                        ];
                    case 5:
                        return e.lockCorrector(void 0 === this.storageHandler ? $06484a9711eaa5fc$var$j : this.storageHandler), [
                            4,
                            this.waitForSomethingToChange(r)
                        ];
                    case 6:
                        l.sent(), l.label = 7;
                    case 7:
                        return o = Date.now() + $06484a9711eaa5fc$var$K(4), [
                            3,
                            1
                        ];
                    case 8:
                        return [
                            2,
                            !1
                        ];
                }
            });
        });
    }, e.prototype.refreshLockWhileAcquired = function(e, t) {
        return $06484a9711eaa5fc$var$I(this, void 0, void 0, function() {
            var n = this;
            return $06484a9711eaa5fc$var$x(this, function(o) {
                return setTimeout(function() {
                    return $06484a9711eaa5fc$var$I(n, void 0, void 0, function() {
                        var n, o, r;
                        return $06484a9711eaa5fc$var$x(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return [
                                        4,
                                        $06484a9711eaa5fc$var$C.default().lock(t)
                                    ];
                                case 1:
                                    return i.sent(), this.acquiredIatSet.has(t) ? (n = void 0 === this.storageHandler ? $06484a9711eaa5fc$var$j : this.storageHandler, null === (o = n.getItemSync(e)) ? ($06484a9711eaa5fc$var$C.default().unlock(t), [
                                        2
                                    ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), n.setItemSync(e, JSON.stringify(r)), $06484a9711eaa5fc$var$C.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                        2
                                    ])) : ($06484a9711eaa5fc$var$C.default().unlock(t), [
                                        2
                                    ]);
                            }
                        });
                    });
                }, 1e3), [
                    2
                ];
            });
        });
    }, e.prototype.waitForSomethingToChange = function(t) {
        return $06484a9711eaa5fc$var$I(this, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(n) {
                                var o = !1, r = Date.now(), i = !1;
                                function a() {
                                    if (i || (window.removeEventListener("storage", a), e.removeFromWaiting(a), clearTimeout(s), i = !0), !o) {
                                        o = !0;
                                        var t = 50 - (Date.now() - r);
                                        t > 0 ? setTimeout(n, t) : n(null);
                                    }
                                }
                                window.addEventListener("storage", a), e.addToWaiting(a);
                                var s = setTimeout(a, Math.max(0, t - Date.now()));
                            })
                        ];
                    case 1:
                        return n.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.addToWaiting = function(t) {
        this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
    }, e.removeFromWaiting = function(t) {
        void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
            return e !== t;
        }));
    }, e.notifyWaiters = function() {
        void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
            return e();
        });
    }, e.prototype.releaseLock = function(e) {
        return $06484a9711eaa5fc$var$I(this, void 0, void 0, function() {
            return $06484a9711eaa5fc$var$x(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.releaseLock__private__(e)
                        ];
                    case 1:
                        return [
                            2,
                            t.sent()
                        ];
                }
            });
        });
    }, e.prototype.releaseLock__private__ = function(t) {
        return $06484a9711eaa5fc$var$I(this, void 0, void 0, function() {
            var n, o, r, i;
            return $06484a9711eaa5fc$var$x(this, function(a) {
                switch(a.label){
                    case 0:
                        return n = void 0 === this.storageHandler ? $06484a9711eaa5fc$var$j : this.storageHandler, o = "browser-tabs-lock-key-" + t, null === (r = n.getItemSync(o)) ? [
                            2
                        ] : (i = JSON.parse(r)).id !== this.id ? [
                            3,
                            2
                        ] : [
                            4,
                            $06484a9711eaa5fc$var$C.default().lock(i.iat)
                        ];
                    case 1:
                        a.sent(), this.acquiredIatSet.delete(i.iat), n.removeItemSync(o), $06484a9711eaa5fc$var$C.default().unlock(i.iat), e.notifyWaiters(), a.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.lockCorrector = function(t) {
        for(var n = Date.now() - 5e3, o = t, r = [], i = 0;;){
            var a = o.keySync(i);
            if (null === a) break;
            r.push(a), i++;
        }
        for(var s = !1, c = 0; c < r.length; c++){
            var u = r[c];
            if (u.includes("browser-tabs-lock-key")) {
                var l = o.getItemSync(u);
                if (null !== l) {
                    var d = JSON.parse(l);
                    (void 0 === d.timeRefreshed && d.timeAcquired < n || void 0 !== d.timeRefreshed && d.timeRefreshed < n) && (o.removeItemSync(u), s = !0);
                }
            }
        }
        s && e.notifyWaiters();
    }, e.waiters = void 0, e;
}(), $06484a9711eaa5fc$var$U = $06484a9711eaa5fc$var$A.default = $06484a9711eaa5fc$var$L;
class $06484a9711eaa5fc$var$N {
    async runWithLock(e, t, n) {
        const o = new AbortController, r = setTimeout(()=>o.abort(), t);
        try {
            return await navigator.locks.request(e, {
                mode: "exclusive",
                signal: o.signal
            }, async (e)=>{
                if (clearTimeout(r), !e) throw new Error("Lock not available");
                return await n();
            });
        } catch (e) {
            if (clearTimeout(r), "AbortError" === (null == e ? void 0 : e.name)) throw new $06484a9711eaa5fc$export$66d311bf29d5c89c;
            throw e;
        }
    }
}
class $06484a9711eaa5fc$var$W {
    async runWithLock(e, t, n) {
        let o = !1;
        for(let n = 0; n < 10 && !o; n++)o = await this.lock.acquireLock(e, t);
        if (!o) throw new $06484a9711eaa5fc$export$66d311bf29d5c89c;
        this.activeLocks.add(e), 1 === this.activeLocks.size && "undefined" != typeof window && window.addEventListener("pagehide", this.pagehideHandler);
        try {
            return await n();
        } finally{
            this.activeLocks.delete(e), await this.lock.releaseLock(e), 0 === this.activeLocks.size && "undefined" != typeof window && window.removeEventListener("pagehide", this.pagehideHandler);
        }
    }
    constructor(){
        this.activeLocks = new Set, this.lock = new $06484a9711eaa5fc$var$U, this.pagehideHandler = ()=>{
            this.activeLocks.forEach((e)=>this.lock.releaseLock(e)), this.activeLocks.clear();
        };
    }
}
function $06484a9711eaa5fc$var$z() {
    var e;
    return "undefined" != typeof navigator && "function" == typeof (null === (e = navigator.locks) || void 0 === e ? void 0 : e.request) ? new $06484a9711eaa5fc$var$N : new $06484a9711eaa5fc$var$W;
}
let $06484a9711eaa5fc$var$H = null;
const $06484a9711eaa5fc$var$M = new TextEncoder, $06484a9711eaa5fc$var$J = new TextDecoder;
function $06484a9711eaa5fc$var$V(e) {
    return "string" == typeof e ? $06484a9711eaa5fc$var$M.encode(e) : $06484a9711eaa5fc$var$J.decode(e);
}
function $06484a9711eaa5fc$var$F(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new $06484a9711eaa5fc$var$X(`${e.name} modulusLength must be at least 2048 bits`);
}
async function $06484a9711eaa5fc$var$G(e, t, n) {
    if (!1 === n.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
    const o = `${$06484a9711eaa5fc$var$q($06484a9711eaa5fc$var$V(JSON.stringify(e)))}.${$06484a9711eaa5fc$var$q($06484a9711eaa5fc$var$V(JSON.stringify(t)))}`;
    return `${o}.${$06484a9711eaa5fc$var$q(await crypto.subtle.sign(function(e) {
        switch(e.algorithm.name){
            case "ECDSA":
                return {
                    name: e.algorithm.name,
                    hash: "SHA-256"
                };
            case "RSA-PSS":
                return $06484a9711eaa5fc$var$F(e.algorithm), {
                    name: e.algorithm.name,
                    saltLength: 32
                };
            case "RSASSA-PKCS1-v1_5":
                return $06484a9711eaa5fc$var$F(e.algorithm), {
                    name: e.algorithm.name
                };
            case "Ed25519":
                return {
                    name: e.algorithm.name
                };
        }
        throw new $06484a9711eaa5fc$var$B;
    }(n), n, $06484a9711eaa5fc$var$V(o)))}`;
}
let $06484a9711eaa5fc$var$Z;
if (Uint8Array.prototype.toBase64) $06484a9711eaa5fc$var$Z = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $06484a9711eaa5fc$var$Z = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $06484a9711eaa5fc$var$q(e) {
    return $06484a9711eaa5fc$var$Z(e);
}
class $06484a9711eaa5fc$var$B extends Error {
    constructor(e){
        var t;
        super(null != e ? e : "operation not supported"), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
class $06484a9711eaa5fc$var$X extends Error {
    constructor(e){
        var t;
        super(e), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
function $06484a9711eaa5fc$var$Y(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new $06484a9711eaa5fc$var$B("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new $06484a9711eaa5fc$var$B("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new $06484a9711eaa5fc$var$B("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new $06484a9711eaa5fc$var$B("unsupported CryptoKey algorithm name");
    }
}
function $06484a9711eaa5fc$var$Q(e) {
    return e instanceof CryptoKey;
}
function $06484a9711eaa5fc$var$$(e) {
    return $06484a9711eaa5fc$var$Q(e) && "public" === e.type;
}
async function $06484a9711eaa5fc$var$ee(e, t, n, o, r, i) {
    const a = null == e ? void 0 : e.privateKey, s = null == e ? void 0 : e.publicKey;
    if (!$06484a9711eaa5fc$var$Q(c = a) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
    var c;
    if (!$06484a9711eaa5fc$var$$(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
    if (!0 !== s.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
    if ("string" != typeof n) throw new TypeError('"htm" must be a string');
    if (void 0 !== o && "string" != typeof o) throw new TypeError('"nonce" must be a string or undefined');
    if (void 0 !== r && "string" != typeof r) throw new TypeError('"accessToken" must be a string or undefined');
    if (void 0 !== i && ("object" != typeof i || null === i || Array.isArray(i))) throw new TypeError('"additional" must be an object');
    return $06484a9711eaa5fc$var$G({
        alg: $06484a9711eaa5fc$var$Y(a),
        typ: "dpop+jwt",
        jwk: await $06484a9711eaa5fc$var$te(s)
    }, Object.assign(Object.assign({}, i), {
        iat: Math.floor(Date.now() / 1e3),
        jti: crypto.randomUUID(),
        htm: n,
        nonce: o,
        htu: t,
        ath: r ? $06484a9711eaa5fc$var$q(await crypto.subtle.digest("SHA-256", $06484a9711eaa5fc$var$V(r))) : void 0
    }), a);
}
async function $06484a9711eaa5fc$var$te(e) {
    const { kty: t, e: n, n: o, x: r, y: i, crv: a } = await crypto.subtle.exportKey("jwk", e);
    return {
        kty: t,
        crv: a,
        e: n,
        n: o,
        x: r,
        y: i
    };
}
const $06484a9711eaa5fc$var$ne = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange",
    "http://auth0.com/oauth/grant-type/mfa-oob",
    "http://auth0.com/oauth/grant-type/mfa-otp",
    "http://auth0.com/oauth/grant-type/mfa-recovery-code"
];
function $06484a9711eaa5fc$var$oe() {
    return async function(e, t) {
        var n;
        let o;
        if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
        switch(e){
            case "PS256":
                o = {
                    name: "RSA-PSS",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "RS256":
                o = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "ES256":
                o = {
                    name: "ECDSA",
                    namedCurve: "P-256"
                };
                break;
            case "Ed25519":
                o = {
                    name: "Ed25519"
                };
                break;
            default:
                throw new $06484a9711eaa5fc$var$B;
        }
        return crypto.subtle.generateKey(o, null !== (n = null == t ? void 0 : t.extractable) && void 0 !== n && n, [
            "sign",
            "verify"
        ]);
    }("ES256", {
        extractable: !1
    });
}
function $06484a9711eaa5fc$var$re(e) {
    return async function(e) {
        if (!$06484a9711eaa5fc$var$$(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
        const t = await $06484a9711eaa5fc$var$te(e);
        let n;
        switch(t.kty){
            case "EC":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x,
                    y: t.y
                };
                break;
            case "OKP":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x
                };
                break;
            case "RSA":
                n = {
                    e: t.e,
                    kty: t.kty,
                    n: t.n
                };
                break;
            default:
                throw new $06484a9711eaa5fc$var$B("unsupported JWK kty");
        }
        return $06484a9711eaa5fc$var$q(await crypto.subtle.digest({
            name: "SHA-256"
        }, $06484a9711eaa5fc$var$V(JSON.stringify(n))));
    }(e.publicKey);
}
function $06484a9711eaa5fc$var$ie(e) {
    let { keyPair: t, url: n, method: o, nonce: r, accessToken: i } = e;
    const a = function(e) {
        const t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(n);
    return $06484a9711eaa5fc$var$ee(t, a, o, r, i);
}
const $06484a9711eaa5fc$var$ae = async (e, t)=>{
    const n = await fetch(e, t);
    var o;
    return {
        ok: n.ok,
        json: await n.json(),
        headers: (o = n.headers, [
            ...o
        ].reduce((e, t)=>{
            let [n, o] = t;
            return e[n] = o, e;
        }, {}))
    };
}, $06484a9711eaa5fc$var$se = async (e, t, n)=>{
    const o = new AbortController;
    let r;
    return t.signal = o.signal, Promise.race([
        $06484a9711eaa5fc$var$ae(e, t),
        new Promise((e, t)=>{
            r = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, n);
        })
    ]).finally(()=>{
        clearTimeout(r);
    });
}, $06484a9711eaa5fc$var$ce = async (e, t, n, o, r, i, a, s)=>((e, t)=>new Promise(function(n, o) {
            const r = new MessageChannel;
            r.port1.onmessage = function(e) {
                e.data.error ? o(new Error(e.data.error)) : n(e.data), r.port1.close();
            }, t.postMessage(e, [
                r.port2
            ]);
        }))({
        auth: {
            audience: t,
            scope: n
        },
        timeout: r,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: a,
        useMrrt: s
    }, i), $06484a9711eaa5fc$var$ue = async function(e, t, n, o, r, i) {
    let a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1e4, s = arguments.length > 7 ? arguments[7] : void 0;
    return r ? $06484a9711eaa5fc$var$ce(e, t, n, o, a, r, i, s) : $06484a9711eaa5fc$var$se(e, o, a);
};
async function $06484a9711eaa5fc$var$le(t, n, o, i, a, s, c, u, l, p) {
    if (l) {
        const e = await l.generateProof({
            url: t,
            method: a.method || "GET",
            nonce: await l.getNonce()
        });
        a.headers = Object.assign(Object.assign({}, a.headers), {
            dpop: e
        });
    }
    let m, y = null;
    for(let e = 0; e < 3; e++)try {
        m = await $06484a9711eaa5fc$var$ue(t, o, i, a, s, c, n, u), y = null;
        break;
    } catch (e) {
        y = e;
    }
    if (y) throw y;
    const w = m.json, { error: g, error_description: v } = w, b = $06484a9711eaa5fc$var$e(w, [
        "error",
        "error_description"
    ]), { headers: _, ok: k } = m;
    let S;
    if (l && (S = _["dpop-nonce"], S && await l.setNonce(S)), !k) {
        const e = v || "HTTP error. Unable to fetch ".concat(t);
        if ("mfa_required" === g) throw new $06484a9711eaa5fc$export$c59494f4dae44ada(g, e, b.mfa_token, b.mfa_requirements);
        if ("missing_refresh_token" === g) throw new $06484a9711eaa5fc$export$ac1d2a00f8e0a046(o, i);
        if ("use_dpop_nonce" === g) {
            if (!l || !S || p) throw new $06484a9711eaa5fc$export$ffb710231177fce3(S);
            return $06484a9711eaa5fc$var$le(t, n, o, i, a, s, c, u, l, !0);
        }
        throw new $06484a9711eaa5fc$export$7d465be8efa67280(g || "request_error", e);
    }
    return b;
}
async function $06484a9711eaa5fc$var$de(t, o) {
    var { baseUrl: r, timeout: i, audience: a, scope: s, auth0Client: c, useFormData: u, useMrrt: l, dpop: d } = t, h = $06484a9711eaa5fc$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData",
        "useMrrt",
        "dpop"
    ]);
    const p = "urn:ietf:params:oauth:grant-type:token-exchange" === h.grant_type, f = "refresh_token" === h.grant_type && l, m = Object.assign(Object.assign(Object.assign(Object.assign({}, h), p && a && {
        audience: a
    }), p && s && {
        scope: s
    }), f && {
        audience: a,
        scope: s
    }), y = u ? $06484a9711eaa5fc$var$_(m) : JSON.stringify(m), w = (g = h.grant_type, $06484a9711eaa5fc$var$ne.includes(g));
    var g;
    return await $06484a9711eaa5fc$var$le("".concat(r, "/oauth/token"), i, a || "default", s, {
        method: "POST",
        body: y,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify($06484a9711eaa5fc$var$b(c || $06484a9711eaa5fc$var$n)))
        }
    }, o, u, l, w ? d : void 0);
}
const $06484a9711eaa5fc$var$he = (e)=>Array.from(new Set(e)), $06484a9711eaa5fc$var$pe = function() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return $06484a9711eaa5fc$var$he(t.filter(Boolean).join(" ").trim().split(/\s+/)).join(" ");
}, $06484a9711eaa5fc$var$fe = (e, t, n)=>{
    let o;
    return n && (o = e[n]), o || (o = e.default), $06484a9711eaa5fc$var$pe(o, t);
};
class $06484a9711eaa5fc$export$2cb47d384c8dd787 {
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, n, o, r] = e.split("::");
        return new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            clientId: n,
            scope: r,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: n, client_id: o } = e;
        return new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            scope: t,
            audience: n,
            clientId: o
        });
    }
    constructor(e){
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "@@auth0spajs@@", n = arguments.length > 2 ? arguments[2] : void 0;
        this.prefix = t, this.suffix = n, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
}
class $06484a9711eaa5fc$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $06484a9711eaa5fc$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, n) {
                    e[t] = n;
                },
                get (t) {
                    const n = e[t];
                    if (n) return n;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $06484a9711eaa5fc$var$ge {
    async setIdToken(e, t, n) {
        var o;
        const r = this.getIdTokenCacheKey(e);
        await this.cache.set(r, {
            id_token: t,
            decodedToken: n
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(r));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = arguments.length > 3 ? arguments[3] : void 0;
        var r;
        let i = await this.cache.get(e.toKey());
        if (!i) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const r = this.matchExistingCacheKey(e, t);
            if (r && (i = await this.cache.get(r)), !i && n && "cache-only" !== o) return this.getEntryWithRefreshToken(e, t);
        }
        if (!i) return;
        const a = await this.nowProvider(), s = Math.floor(a / 1e3);
        return i.expiresAt - t < s ? i.body.refresh_token ? this.modifiedCachedEntry(i, e) : (await this.cache.remove(e.toKey()), void await (null === (r = this.keyManifest) || void 0 === r ? void 0 : r.remove(e.toKey()))) : i.body;
    }
    async modifiedCachedEntry(e, t) {
        return e.body = {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        }, await this.cache.set(t.toKey(), e), {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        };
    }
    async set(e) {
        var t;
        const n = new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(n.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey()));
    }
    async remove(e, t, n) {
        const o = new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            clientId: e,
            scope: n,
            audience: t
        });
        await this.cache.remove(o.toKey());
    }
    async clear(e) {
        var t;
        const n = await this.getCacheKeys();
        n && (await n.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var n;
            const o = $06484a9711eaa5fc$export$2cb47d384c8dd787.fromKey(t), r = new Set(o.scope && o.scope.split(" ")), i = (null === (n = e.scope) || void 0 === n ? void 0 : n.split(" ")) || [], a = o.scope && i.reduce((e, t)=>e && r.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && a;
        })[0];
    }
    async getEntryWithRefreshToken(e, t) {
        var n;
        for (const o of t){
            const t = $06484a9711eaa5fc$export$2cb47d384c8dd787.fromKey(o);
            if ("@@auth0spajs@@" === t.prefix && t.clientId === e.clientId) {
                const t = await this.cache.get(o);
                if (null === (n = null == t ? void 0 : t.body) || void 0 === n ? void 0 : n.refresh_token) return this.modifiedCachedEntry(t, e);
            }
        }
    }
    async updateEntry(e, t) {
        var n;
        const o = await this.getCacheKeys();
        if (o) for (const r of o){
            const o = await this.cache.get(r);
            (null === (n = null == o ? void 0 : o.body) || void 0 === n ? void 0 : n.refresh_token) === e && (o.body.refresh_token = t, await this.cache.set(r, o));
        }
    }
    constructor(e, t, n){
        this.cache = e, this.keyManifest = t, this.nowProvider = n || $06484a9711eaa5fc$var$o;
    }
}
class $06484a9711eaa5fc$var$ve {
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
    constructor(e, t, n){
        this.storage = e, this.clientId = t, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
    }
}
const $06484a9711eaa5fc$var$be = (e)=>"number" == typeof e, $06484a9711eaa5fc$var$_e = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $06484a9711eaa5fc$var$ke = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [n, o, r] = t;
        if (3 !== t.length || !n || !o || !r) throw new Error("ID token could not be decoded");
        const i = JSON.parse($06484a9711eaa5fc$var$S(o)), a = {
            __raw: e
        }, s = {};
        return Object.keys(i).forEach((e)=>{
            a[e] = i[e], $06484a9711eaa5fc$var$_e.includes(e) || (s[e] = i[e]);
        }), {
            encoded: {
                header: n,
                payload: o,
                signature: r
            },
            header: JSON.parse($06484a9711eaa5fc$var$S(n)),
            claims: a,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
        }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !$06484a9711eaa5fc$var$be(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$06484a9711eaa5fc$var$be(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$06484a9711eaa5fc$var$be(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const n = e.leeway || 60, o = new Date(e.now || Date.now()), r = new Date(0);
    if (r.setUTCSeconds(t.claims.exp + n), o > r) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(o, ") is after expiration time (").concat(r, ")"));
    if (null != t.claims.nbf && $06484a9711eaa5fc$var$be(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - n), o < e) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(o, ") is before ").concat(e));
    }
    if (null != t.claims.auth_time && $06484a9711eaa5fc$var$be(t.claims.auth_time)) {
        const r = new Date(0);
        if (r.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o > r) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(o, ") is after last auth at ").concat(r));
    }
    if (e.organization) {
        const n = e.organization.trim();
        if (n.startsWith("org_")) {
            const e = n;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_id, '"'));
        } else {
            const e = n.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_name, '"'));
        }
    }
    return t;
};
var $06484a9711eaa5fc$var$Se = $06484a9711eaa5fc$var$T && $06484a9711eaa5fc$var$T.__assign || function() {
    return $06484a9711eaa5fc$var$Se = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $06484a9711eaa5fc$var$Se.apply(this, arguments);
};
function $06484a9711eaa5fc$var$Ee(e, t) {
    if (!t) return "";
    var n = "; " + e;
    return !0 === t ? n : n + "=" + t;
}
function $06484a9711eaa5fc$var$Te(e, t, n) {
    return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
        if ("number" == typeof e.expires) {
            var t = new Date;
            t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
        }
        return $06484a9711eaa5fc$var$Ee("Expires", e.expires ? e.expires.toUTCString() : "") + $06484a9711eaa5fc$var$Ee("Domain", e.domain) + $06484a9711eaa5fc$var$Ee("Path", e.path) + $06484a9711eaa5fc$var$Ee("Secure", e.secure) + $06484a9711eaa5fc$var$Ee("SameSite", e.sameSite);
    }(n);
}
function $06484a9711eaa5fc$var$Ae() {
    return function(e) {
        for(var t = {}, n = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, r = 0; r < n.length; r++){
            var i = n[r].split("="), a = i.slice(1).join("=");
            '"' === a.charAt(0) && (a = a.slice(1, -1));
            try {
                t[i[0].replace(o, decodeURIComponent)] = a.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }(document.cookie);
}
var $06484a9711eaa5fc$var$Pe = function(e) {
    return $06484a9711eaa5fc$var$Ae()[e];
};
function $06484a9711eaa5fc$var$Re(e, t, n) {
    document.cookie = $06484a9711eaa5fc$var$Te(e, t, $06484a9711eaa5fc$var$Se({
        path: "/"
    }, n));
}
var $06484a9711eaa5fc$var$Ie = $06484a9711eaa5fc$var$Re;
var $06484a9711eaa5fc$var$xe = function(e, t) {
    $06484a9711eaa5fc$var$Re(e, "", $06484a9711eaa5fc$var$Se($06484a9711eaa5fc$var$Se({}, t), {
        expires: -1
    }));
};
const $06484a9711eaa5fc$var$Oe = {
    get (e) {
        const t = $06484a9711eaa5fc$var$Pe(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $06484a9711eaa5fc$var$Ie(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $06484a9711eaa5fc$var$xe(e, n);
    }
}, $06484a9711eaa5fc$var$Ce = {
    get (e) {
        const t = $06484a9711eaa5fc$var$Oe.get(e);
        return t || $06484a9711eaa5fc$var$Oe.get("".concat("_legacy_").concat(e));
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $06484a9711eaa5fc$var$Ie("".concat("_legacy_").concat(e), JSON.stringify(t), o), $06484a9711eaa5fc$var$Oe.save(e, t, n);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $06484a9711eaa5fc$var$xe(e, n), $06484a9711eaa5fc$var$Oe.remove(e, t), $06484a9711eaa5fc$var$Oe.remove("".concat("_legacy_").concat(e), t);
    }
}, $06484a9711eaa5fc$var$je = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
var $06484a9711eaa5fc$export$7390b1e457b4cb6f;
!function(e) {
    e.Code = "code", e.ConnectCode = "connect_code";
}($06484a9711eaa5fc$export$7390b1e457b4cb6f || ($06484a9711eaa5fc$export$7390b1e457b4cb6f = {}));
class $06484a9711eaa5fc$export$1f44aaf2ec115b54 {
}
function $06484a9711eaa5fc$var$Le(e, t, n) {
    var o = void 0 === t ? null : t, r = function(e, t) {
        var n = atob(e);
        if (t) {
            for(var o = new Uint8Array(n.length), r = 0, i = n.length; r < i; ++r)o[r] = n.charCodeAt(r);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return n;
    }(e, void 0 !== n && n), i = r.indexOf("\n", 10) + 1, a = r.substring(i) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        a
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $06484a9711eaa5fc$var$Ue, $06484a9711eaa5fc$var$Ne, $06484a9711eaa5fc$var$We, $06484a9711eaa5fc$var$ze, $06484a9711eaa5fc$var$He = ($06484a9711eaa5fc$var$Ue = "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", $06484a9711eaa5fc$var$Ne = null, $06484a9711eaa5fc$var$We = !1, function(e) {
    return $06484a9711eaa5fc$var$ze = $06484a9711eaa5fc$var$ze || $06484a9711eaa5fc$var$Le($06484a9711eaa5fc$var$Ue, $06484a9711eaa5fc$var$Ne, $06484a9711eaa5fc$var$We), new Worker($06484a9711eaa5fc$var$ze, e);
});
const $06484a9711eaa5fc$var$Me = {};
class $06484a9711eaa5fc$var$Je {
    async add(e) {
        var t;
        const n = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        n.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...n
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const n = new Set(t.keys);
            return n.delete(e), n.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...n
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return "".concat("@@auth0spajs@@", "::").concat(e);
    }
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
}
const $06484a9711eaa5fc$var$Ve = {
    memory: ()=>(new $06484a9711eaa5fc$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $06484a9711eaa5fc$export$40ef2cb682e70737
}, $06484a9711eaa5fc$var$Fe = (e)=>$06484a9711eaa5fc$var$Ve[e], $06484a9711eaa5fc$var$Ge = (t)=>{
    const { openUrl: n, onRedirect: o } = t, r = $06484a9711eaa5fc$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, r), {
        openUrl: !1 === n || n ? n : o
    });
}, $06484a9711eaa5fc$var$Ze = (e, t)=>{
    const n = (null == t ? void 0 : t.split(" ")) || [];
    return ((null == e ? void 0 : e.split(" ")) || []).every((e)=>n.includes(e));
}, $06484a9711eaa5fc$var$qe = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
class $06484a9711eaa5fc$var$Be {
    getVersion() {
        return 1;
    }
    createDbHandle() {
        const e = window.indexedDB.open("auth0-spa-js", this.getVersion());
        return new Promise((t, n)=>{
            e.onupgradeneeded = ()=>Object.values($06484a9711eaa5fc$var$qe).forEach((t)=>e.result.createObjectStore(t)), e.onerror = ()=>n(e.error), e.onsuccess = ()=>t(e.result);
        });
    }
    async getDbHandle() {
        return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
    }
    async executeDbRequest(e, t, n) {
        const o = n((await this.getDbHandle()).transaction(e, t).objectStore(e));
        return new Promise((e, t)=>{
            o.onsuccess = ()=>e(o.result), o.onerror = ()=>t(o.error);
        });
    }
    buildKey(e) {
        const t = e ? "_".concat(e) : "auth0";
        return "".concat(this.clientId, "::").concat(t);
    }
    setNonce(e, t) {
        return this.save($06484a9711eaa5fc$var$qe.NONCE, this.buildKey(t), e);
    }
    setKeyPair(e) {
        return this.save($06484a9711eaa5fc$var$qe.KEYPAIR, this.buildKey(), e);
    }
    async save(e, t, n) {
        await this.executeDbRequest(e, "readwrite", (e)=>e.put(n, t));
    }
    findNonce(e) {
        return this.find($06484a9711eaa5fc$var$qe.NONCE, this.buildKey(e));
    }
    findKeyPair() {
        return this.find($06484a9711eaa5fc$var$qe.KEYPAIR, this.buildKey());
    }
    find(e, t) {
        return this.executeDbRequest(e, "readonly", (e)=>e.get(t));
    }
    async deleteBy(e, t) {
        const n = await this.executeDbRequest(e, "readonly", (e)=>e.getAllKeys());
        null == n || n.filter(t).map((t)=>this.executeDbRequest(e, "readwrite", (e)=>e.delete(t)));
    }
    deleteByClientId(e, t) {
        return this.deleteBy(e, (e)=>"string" == typeof e && e.startsWith("".concat(t, "::")));
    }
    clearNonces() {
        return this.deleteByClientId($06484a9711eaa5fc$var$qe.NONCE, this.clientId);
    }
    clearKeyPairs() {
        return this.deleteByClientId($06484a9711eaa5fc$var$qe.KEYPAIR, this.clientId);
    }
    constructor(e){
        this.clientId = e;
    }
}
class $06484a9711eaa5fc$var$Xe {
    getNonce(e) {
        return this.storage.findNonce(e);
    }
    setNonce(e, t) {
        return this.storage.setNonce(e, t);
    }
    async getOrGenerateKeyPair() {
        let e = await this.storage.findKeyPair();
        return e || (e = await $06484a9711eaa5fc$var$oe(), await this.storage.setKeyPair(e)), e;
    }
    async generateProof(e) {
        const t = await this.getOrGenerateKeyPair();
        return $06484a9711eaa5fc$var$ie(Object.assign({
            keyPair: t
        }, e));
    }
    async calculateThumbprint() {
        return $06484a9711eaa5fc$var$re(await this.getOrGenerateKeyPair());
    }
    async clear() {
        await Promise.all([
            this.storage.clearNonces(),
            this.storage.clearKeyPairs()
        ]);
    }
    constructor(e){
        this.storage = new $06484a9711eaa5fc$var$Be(e);
    }
}
var $06484a9711eaa5fc$var$Ye;
!function(e) {
    e.Bearer = "Bearer", e.DPoP = "DPoP";
}($06484a9711eaa5fc$var$Ye || ($06484a9711eaa5fc$var$Ye = {}));
class $06484a9711eaa5fc$var$Qe {
    isAbsoluteUrl(e) {
        return /^(https?:)?\/\//i.test(e);
    }
    buildUrl(e, t) {
        if (t) {
            if (this.isAbsoluteUrl(t)) return t;
            if (e) return "".concat(e.replace(/\/?\/$/, ""), "/").concat(t.replace(/^\/+/, ""));
        }
        throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
    }
    getAccessToken(e) {
        return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
    }
    extractUrl(e) {
        return "string" == typeof e ? e : e instanceof URL ? e.href : e.url;
    }
    buildBaseRequest(e, t) {
        if (!this.config.baseUrl) return new Request(e, t);
        const n = this.buildUrl(this.config.baseUrl, this.extractUrl(e)), o = e instanceof Request ? new Request(n, e) : n;
        return new Request(o, t);
    }
    setAuthorizationHeader(e, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $06484a9711eaa5fc$var$Ye.Bearer;
        e.headers.set("authorization", "".concat(n, " ").concat(t));
    }
    async setDpopProofHeader(e, t) {
        if (!this.config.dpopNonceId) return;
        const n = await this.hooks.getDpopNonce(), o = await this.hooks.generateDpopProof({
            accessToken: t,
            method: e.method,
            nonce: n,
            url: e.url
        });
        e.headers.set("dpop", o);
    }
    async prepareRequest(e, t) {
        const n = await this.getAccessToken(t);
        let o, r;
        "string" == typeof n ? (o = this.config.dpopNonceId ? $06484a9711eaa5fc$var$Ye.DPoP : $06484a9711eaa5fc$var$Ye.Bearer, r = n) : (o = n.token_type, r = n.access_token), this.setAuthorizationHeader(e, r, o), o === $06484a9711eaa5fc$var$Ye.DPoP && await this.setDpopProofHeader(e, r);
    }
    getHeader(e, t) {
        return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
    }
    hasUseDpopNonceError(e) {
        if (401 !== e.status) return !1;
        const t = this.getHeader(e.headers, "www-authenticate");
        return t.includes("invalid_dpop_nonce") || t.includes("use_dpop_nonce");
    }
    async handleResponse(e, t) {
        const n = this.getHeader(e.headers, "dpop-nonce");
        if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(e)) return e;
        if (!n || !t.onUseDpopNonceError) throw new $06484a9711eaa5fc$export$ffb710231177fce3(n);
        return t.onUseDpopNonceError();
    }
    async internalFetchWithAuth(e, t, n, o) {
        const r = this.buildBaseRequest(e, t);
        await this.prepareRequest(r, o);
        const i = await this.config.fetch(r);
        return this.handleResponse(i, n);
    }
    fetchWithAuth(e, t, n) {
        const o = {
            onUseDpopNonceError: ()=>this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, o), {
                    onUseDpopNonceError: void 0
                }), n)
        };
        return this.internalFetchWithAuth(e, t, o, n);
    }
    constructor(e, t){
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
}
class $06484a9711eaa5fc$var$$e {
    async connectAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async completeAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async _handleResponse(e) {
        let t;
        try {
            t = await e.text(), t = JSON.parse(t);
        } catch (n) {
            throw new $06484a9711eaa5fc$export$2c8acf1355a80350({
                type: "invalid_json",
                status: e.status,
                title: "Invalid JSON response",
                detail: t || String(n)
            });
        }
        if (e.ok) return t;
        throw new $06484a9711eaa5fc$export$2c8acf1355a80350(t);
    }
    constructor(e, t){
        this.myAccountFetcher = e, this.apiBase = t;
    }
}
class $06484a9711eaa5fc$export$2c8acf1355a80350 extends Error {
    constructor(e){
        let { type: t, status: n, title: o, detail: r, validation_errors: i } = e;
        super(r), this.name = "MyAccountApiError", this.type = t, this.status = n, this.title = o, this.detail = r, this.validation_errors = i, Object.setPrototypeOf(this, $06484a9711eaa5fc$export$2c8acf1355a80350.prototype);
    }
}
const $06484a9711eaa5fc$var$tt = {
    otp: {
        authenticatorTypes: [
            "otp"
        ]
    },
    sms: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "sms"
        ]
    },
    email: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "email"
        ]
    },
    push: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "auth0"
        ]
    },
    voice: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "voice"
        ]
    }
}, $06484a9711eaa5fc$var$nt = "http://auth0.com/oauth/grant-type/mfa-otp", $06484a9711eaa5fc$var$ot = "http://auth0.com/oauth/grant-type/mfa-oob", $06484a9711eaa5fc$var$rt = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
function $06484a9711eaa5fc$var$it(e, t) {
    this.v = e, this.k = t;
}
function $06484a9711eaa5fc$var$at(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $06484a9711eaa5fc$var$st(e) {
    return new $06484a9711eaa5fc$var$it(e, 0);
}
function $06484a9711eaa5fc$var$ct(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $06484a9711eaa5fc$var$ut(e, t) {
    return e.get($06484a9711eaa5fc$var$at(e, t));
}
function $06484a9711eaa5fc$var$lt(e, t, n) {
    $06484a9711eaa5fc$var$ct(e, t), t.set(e, n);
}
function $06484a9711eaa5fc$var$dt(e, t, n) {
    return e.set($06484a9711eaa5fc$var$at(e, t), n), n;
}
function $06484a9711eaa5fc$var$ht(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $06484a9711eaa5fc$var$pt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
    }
    return n;
}
function $06484a9711eaa5fc$var$ft(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $06484a9711eaa5fc$var$pt(Object(n), !0).forEach(function(t) {
            $06484a9711eaa5fc$var$ht(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $06484a9711eaa5fc$var$pt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $06484a9711eaa5fc$var$mt(e, t) {
    if (null == e) return {};
    var n, o, r = function(e, t) {
        if (null == e) return {};
        var n = {};
        for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
            if (-1 !== t.indexOf(o)) continue;
            n[o] = e[o];
        }
        return n;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)n = i[o], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
}
function $06484a9711eaa5fc$var$yt(e) {
    return function() {
        return new $06484a9711eaa5fc$var$wt(e.apply(this, arguments));
    };
}
function $06484a9711eaa5fc$var$wt(e) {
    var t, n;
    function o(t, n) {
        try {
            var i = e[t](n), a = i.value, s = a instanceof $06484a9711eaa5fc$var$it;
            Promise.resolve(s ? a.v : a).then(function(n) {
                if (s) {
                    var c = "return" === t ? "return" : "next";
                    if (!a.k || n.done) return o(c, n);
                    n = e[c](n).value;
                }
                r(i.done ? "return" : "normal", n);
            }, function(e) {
                o("throw", e);
            });
        } catch (e) {
            r("throw", e);
        }
    }
    function r(e, r) {
        switch(e){
            case "return":
                t.resolve({
                    value: r,
                    done: !0
                });
                break;
            case "throw":
                t.reject(r);
                break;
            default:
                t.resolve({
                    value: r,
                    done: !1
                });
        }
        (t = t.next) ? o(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, r) {
        return new Promise(function(i, a) {
            var s = {
                key: e,
                arg: r,
                resolve: i,
                reject: a,
                next: null
            };
            n ? n = n.next = s : (t = n = s, o(e, r));
        });
    }, "function" != typeof e.return && (this.return = void 0);
}
var $06484a9711eaa5fc$var$gt, $06484a9711eaa5fc$var$vt;
let $06484a9711eaa5fc$var$bt;
if ($06484a9711eaa5fc$var$wt.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $06484a9711eaa5fc$var$wt.prototype.next = function(e) {
    return this._invoke("next", e);
}, $06484a9711eaa5fc$var$wt.prototype.throw = function(e) {
    return this._invoke("throw", e);
}, $06484a9711eaa5fc$var$wt.prototype.return = function(e) {
    return this._invoke("return", e);
}, "undefined" == typeof navigator || null === ($06484a9711eaa5fc$var$gt = navigator.userAgent) || void 0 === $06484a9711eaa5fc$var$gt || null === ($06484a9711eaa5fc$var$vt = $06484a9711eaa5fc$var$gt.startsWith) || void 0 === $06484a9711eaa5fc$var$vt || !$06484a9711eaa5fc$var$vt.call($06484a9711eaa5fc$var$gt, "Mozilla/5.0 ")) {
    const e = "v3.8.3";
    $06484a9711eaa5fc$var$bt = "".concat("oauth4webapi", "/").concat(e);
}
function $06484a9711eaa5fc$var$_t(e, t) {
    if (null == e) return !1;
    try {
        return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
    } catch (e) {
        return !1;
    }
}
function $06484a9711eaa5fc$var$kt(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
const $06484a9711eaa5fc$var$St = Symbol(), $06484a9711eaa5fc$var$Et = Symbol(), $06484a9711eaa5fc$var$Tt = Symbol(), $06484a9711eaa5fc$var$At = Symbol(), $06484a9711eaa5fc$var$Pt = Symbol(), $06484a9711eaa5fc$var$Rt = Symbol(), $06484a9711eaa5fc$var$It = new TextEncoder, $06484a9711eaa5fc$var$xt = new TextDecoder;
function $06484a9711eaa5fc$var$Ot(e) {
    return "string" == typeof e ? $06484a9711eaa5fc$var$It.encode(e) : $06484a9711eaa5fc$var$xt.decode(e);
}
let $06484a9711eaa5fc$var$Ct, $06484a9711eaa5fc$var$jt;
if (Uint8Array.prototype.toBase64) $06484a9711eaa5fc$var$Ct = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $06484a9711eaa5fc$var$Ct = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $06484a9711eaa5fc$var$Dt(e) {
    return "string" == typeof e ? $06484a9711eaa5fc$var$jt(e) : $06484a9711eaa5fc$var$Ct(e);
}
$06484a9711eaa5fc$var$jt = Uint8Array.fromBase64 ? (e)=>{
    try {
        return Uint8Array.fromBase64(e, {
            alphabet: "base64url"
        });
    } catch (e) {
        throw $06484a9711eaa5fc$var$kt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", e);
    }
} : (e)=>{
    try {
        const t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), n = new Uint8Array(t.length);
        for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
        return n;
    } catch (e) {
        throw $06484a9711eaa5fc$var$kt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", e);
    }
};
class $06484a9711eaa5fc$var$Kt extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.name = this.constructor.name, this.code = $06484a9711eaa5fc$var$Kn, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $06484a9711eaa5fc$var$Lt extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.name = this.constructor.name, null != t && t.code && (this.code = null == t ? void 0 : t.code), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $06484a9711eaa5fc$var$Ut(e, t, n) {
    return new $06484a9711eaa5fc$var$Lt(e, {
        code: t,
        cause: n
    });
}
function $06484a9711eaa5fc$var$Nt(e, t) {
    if (function(e, t) {
        if (!(e instanceof CryptoKey)) throw $06484a9711eaa5fc$var$kt("".concat(t, " must be a CryptoKey"), "ERR_INVALID_ARG_TYPE");
    }(e, t), "private" !== e.type) throw $06484a9711eaa5fc$var$kt("".concat(t, " must be a private CryptoKey"), "ERR_INVALID_ARG_VALUE");
}
function $06484a9711eaa5fc$var$Wt(e) {
    return null !== e && "object" == typeof e && !Array.isArray(e);
}
function $06484a9711eaa5fc$var$zt(e) {
    $06484a9711eaa5fc$var$_t(e, Headers) && (e = Object.fromEntries(e.entries()));
    const t = new Headers(null != e ? e : {});
    if ($06484a9711eaa5fc$var$bt && !t.has("user-agent") && t.set("user-agent", $06484a9711eaa5fc$var$bt), t.has("authorization")) throw $06484a9711eaa5fc$var$kt('"options.headers" must not include the "authorization" header name', "ERR_INVALID_ARG_VALUE");
    return t;
}
function $06484a9711eaa5fc$var$Ht(e, t) {
    if (void 0 !== t) {
        if ("function" == typeof t && (t = t(e.href)), !(t instanceof AbortSignal)) throw $06484a9711eaa5fc$var$kt('"options.signal" must return or be an instance of AbortSignal', "ERR_INVALID_ARG_TYPE");
        return t;
    }
}
function $06484a9711eaa5fc$var$Mt(e) {
    return e.includes("//") ? e.replace("//", "/") : e;
}
async function $06484a9711eaa5fc$var$Jt(e, t) {
    return async function(e, t, n, o) {
        if (!(e instanceof URL)) throw $06484a9711eaa5fc$var$kt('"'.concat(t, '" must be an instance of URL'), "ERR_INVALID_ARG_TYPE");
        $06484a9711eaa5fc$var$on(e, !0 !== (null == o ? void 0 : o[$06484a9711eaa5fc$var$St]));
        const r = n(new URL(e.href)), i = $06484a9711eaa5fc$var$zt(null == o ? void 0 : o.headers);
        return i.set("accept", "application/json"), ((null == o ? void 0 : o[$06484a9711eaa5fc$var$At]) || fetch)(r.href, {
            body: void 0,
            headers: Object.fromEntries(i.entries()),
            method: "GET",
            redirect: "manual",
            signal: $06484a9711eaa5fc$var$Ht(r, null == o ? void 0 : o.signal)
        });
    }(e, "issuerIdentifier", (e)=>{
        switch(null == t ? void 0 : t.algorithm){
            case void 0:
            case "oidc":
                !function(e, t) {
                    e.pathname = $06484a9711eaa5fc$var$Mt("".concat(e.pathname, "/").concat(t));
                }(e, ".well-known/openid-configuration");
                break;
            case "oauth2":
                !function(e, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    "/" === e.pathname ? e.pathname = t : e.pathname = $06484a9711eaa5fc$var$Mt("".concat(t, "/").concat(n ? e.pathname : e.pathname.replace(/(\/)$/, "")));
                }(e, ".well-known/oauth-authorization-server");
                break;
            default:
                throw $06484a9711eaa5fc$var$kt('"options.algorithm" must be "oidc" (default), or "oauth2"', "ERR_INVALID_ARG_VALUE");
        }
        return e;
    }, t);
}
function $06484a9711eaa5fc$var$Vt(e, t, n, o, r) {
    try {
        if ("number" != typeof e || !Number.isFinite(e)) throw $06484a9711eaa5fc$var$kt("".concat(n, " must be a number"), "ERR_INVALID_ARG_TYPE", r);
        if (e > 0) return;
        if (t) {
            if (0 !== e) throw $06484a9711eaa5fc$var$kt("".concat(n, " must be a non-negative number"), "ERR_INVALID_ARG_VALUE", r);
            return;
        }
        throw $06484a9711eaa5fc$var$kt("".concat(n, " must be a positive number"), "ERR_INVALID_ARG_VALUE", r);
    } catch (e) {
        if (o) throw $06484a9711eaa5fc$var$Ut(e.message, o, r);
        throw e;
    }
}
function $06484a9711eaa5fc$var$Ft(e, t, n, o) {
    try {
        if ("string" != typeof e) throw $06484a9711eaa5fc$var$kt("".concat(t, " must be a string"), "ERR_INVALID_ARG_TYPE", o);
        if (0 === e.length) throw $06484a9711eaa5fc$var$kt("".concat(t, " must not be empty"), "ERR_INVALID_ARG_VALUE", o);
    } catch (e) {
        if (n) throw $06484a9711eaa5fc$var$Ut(e.message, n, o);
        throw e;
    }
}
function $06484a9711eaa5fc$var$Gt(e) {
    !function(e, t) {
        if ($06484a9711eaa5fc$var$wn(e) !== t) throw function(e) {
            let t = '"response" content-type must be ';
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)o[r - 1] = arguments[r];
            if (o.length > 2) {
                const e = o.pop();
                t += "".concat(o.join(", "), ", or ").concat(e);
            } else 2 === o.length ? t += "".concat(o[0], " or ").concat(o[1]) : t += o[0];
            return $06484a9711eaa5fc$var$Ut(t, $06484a9711eaa5fc$var$Wn, e);
        }(e, t);
    }(e, "application/json");
}
function $06484a9711eaa5fc$var$Zt() {
    return $06484a9711eaa5fc$var$Dt(crypto.getRandomValues(new Uint8Array(32)));
}
function $06484a9711eaa5fc$var$qt(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "PS256";
                    case "SHA-384":
                        return "PS384";
                    case "SHA-512":
                        return "PS512";
                    default:
                        throw new $06484a9711eaa5fc$var$Kt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "RS256";
                    case "SHA-384":
                        return "RS384";
                    case "SHA-512":
                        return "RS512";
                    default:
                        throw new $06484a9711eaa5fc$var$Kt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "ECDSA":
            return function(e) {
                switch(e.algorithm.namedCurve){
                    case "P-256":
                        return "ES256";
                    case "P-384":
                        return "ES384";
                    case "P-521":
                        return "ES512";
                    default:
                        throw new $06484a9711eaa5fc$var$Kt("unsupported EcKeyAlgorithm namedCurve", {
                            cause: e
                        });
                }
            }(e);
        case "Ed25519":
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return e.algorithm.name;
        case "EdDSA":
            return "Ed25519";
        default:
            throw new $06484a9711eaa5fc$var$Kt("unsupported CryptoKey algorithm name", {
                cause: e
            });
    }
}
function $06484a9711eaa5fc$var$Bt(e) {
    const t = null == e ? void 0 : e[$06484a9711eaa5fc$var$Et];
    return "number" == typeof t && Number.isFinite(t) ? t : 0;
}
function $06484a9711eaa5fc$var$Xt(e) {
    const t = null == e ? void 0 : e[$06484a9711eaa5fc$var$Tt];
    return "number" == typeof t && Number.isFinite(t) && -1 !== Math.sign(t) ? t : 30;
}
function $06484a9711eaa5fc$var$Yt() {
    return Math.floor(Date.now() / 1e3);
}
function $06484a9711eaa5fc$var$Qt(e) {
    if ("object" != typeof e || null === e) throw $06484a9711eaa5fc$var$kt('"as" must be an object', "ERR_INVALID_ARG_TYPE");
    $06484a9711eaa5fc$var$Ft(e.issuer, '"as.issuer"');
}
function $06484a9711eaa5fc$var$$t(e) {
    if ("object" != typeof e || null === e) throw $06484a9711eaa5fc$var$kt('"client" must be an object', "ERR_INVALID_ARG_TYPE");
    $06484a9711eaa5fc$var$Ft(e.client_id, '"client.client_id"');
}
function $06484a9711eaa5fc$var$en(e) {
    return $06484a9711eaa5fc$var$Ft(e, '"clientSecret"'), (t, n, o, r)=>{
        o.set("client_id", n.client_id), o.set("client_secret", e);
    };
}
function $06484a9711eaa5fc$var$tn(e, t) {
    const { key: n, kid: o } = (r = e) instanceof CryptoKey ? {
        key: r
    } : (null == r ? void 0 : r.key) instanceof CryptoKey ? (void 0 !== r.kid && $06484a9711eaa5fc$var$Ft(r.kid, '"kid"'), {
        key: r.key,
        kid: r.kid
    }) : {};
    var r;
    return $06484a9711eaa5fc$var$Nt(n, '"clientPrivateKey.key"'), async (e, r, i, a)=>{
        var s;
        const c = {
            alg: $06484a9711eaa5fc$var$qt(n),
            kid: o
        }, u = function(e, t) {
            const n = $06484a9711eaa5fc$var$Yt() + $06484a9711eaa5fc$var$Bt(t);
            return {
                jti: $06484a9711eaa5fc$var$Zt(),
                aud: e.issuer,
                exp: n + 60,
                iat: n,
                nbf: n,
                iss: t.client_id,
                sub: t.client_id
            };
        }(e, r);
        null == t || null === (s = t[$06484a9711eaa5fc$var$Pt]) || void 0 === s || s.call(t, c, u), i.set("client_id", r.client_id), i.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), i.set("client_assertion", await async function(e, t, n) {
            if (!n.usages.includes("sign")) throw $06484a9711eaa5fc$var$kt('CryptoKey instances used for signing assertions must include "sign" in their "usages"', "ERR_INVALID_ARG_VALUE");
            const o = "".concat($06484a9711eaa5fc$var$Dt($06484a9711eaa5fc$var$Ot(JSON.stringify(e))), ".").concat($06484a9711eaa5fc$var$Dt($06484a9711eaa5fc$var$Ot(JSON.stringify(t)))), r = $06484a9711eaa5fc$var$Dt(await crypto.subtle.sign(function(e) {
                switch(e.algorithm.name){
                    case "ECDSA":
                        return {
                            name: e.algorithm.name,
                            hash: $06484a9711eaa5fc$var$Xn(e)
                        };
                    case "RSA-PSS":
                        switch($06484a9711eaa5fc$var$Bn(e), e.algorithm.hash.name){
                            case "SHA-256":
                            case "SHA-384":
                            case "SHA-512":
                                return {
                                    name: e.algorithm.name,
                                    saltLength: parseInt(e.algorithm.hash.name.slice(-3), 10) >> 3
                                };
                            default:
                                throw new $06484a9711eaa5fc$var$Kt("unsupported RSA-PSS hash name", {
                                    cause: e
                                });
                        }
                    case "RSASSA-PKCS1-v1_5":
                        return $06484a9711eaa5fc$var$Bn(e), e.algorithm.name;
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                    case "Ed25519":
                        return e.algorithm.name;
                }
                throw new $06484a9711eaa5fc$var$Kt("unsupported CryptoKey algorithm name", {
                    cause: e
                });
            }(n), n, $06484a9711eaa5fc$var$Ot(o)));
            return "".concat(o, ".").concat(r);
        }(c, u, n));
    };
}
const $06484a9711eaa5fc$var$nn = URL.parse ? (e, t)=>URL.parse(e, t) : (e, t)=>{
    try {
        return new URL(e, t);
    } catch (e) {
        return null;
    }
};
function $06484a9711eaa5fc$var$on(e, t) {
    if (t && "https:" !== e.protocol) throw $06484a9711eaa5fc$var$Ut("only requests to HTTPS are allowed", $06484a9711eaa5fc$var$Hn, e);
    if ("https:" !== e.protocol && "http:" !== e.protocol) throw $06484a9711eaa5fc$var$Ut("only HTTP and HTTPS requests are allowed", $06484a9711eaa5fc$var$Mn, e);
}
function $06484a9711eaa5fc$var$rn(e, t, n, o) {
    let r;
    if ("string" != typeof e || !(r = $06484a9711eaa5fc$var$nn(e))) throw $06484a9711eaa5fc$var$Ut("authorization server metadata does not contain a valid ".concat(n ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), void 0 === e ? $06484a9711eaa5fc$var$Gn : $06484a9711eaa5fc$var$Zn, {
        attribute: n ? "mtls_endpoint_aliases.".concat(t) : t
    });
    return $06484a9711eaa5fc$var$on(r, o), r;
}
function $06484a9711eaa5fc$var$an(e, t, n, o) {
    return n && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? $06484a9711eaa5fc$var$rn(e.mtls_endpoint_aliases[t], t, n, o) : $06484a9711eaa5fc$var$rn(e[t], t, n, o);
}
class $06484a9711eaa5fc$var$sn extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "cause", void 0), $06484a9711eaa5fc$var$ht(this, "code", void 0), $06484a9711eaa5fc$var$ht(this, "error", void 0), $06484a9711eaa5fc$var$ht(this, "status", void 0), $06484a9711eaa5fc$var$ht(this, "error_description", void 0), $06484a9711eaa5fc$var$ht(this, "response", void 0), this.name = this.constructor.name, this.code = $06484a9711eaa5fc$var$Dn, this.cause = t.cause, this.error = t.cause.error, this.status = t.response.status, this.error_description = t.cause.error_description, Object.defineProperty(this, "response", {
            enumerable: !1,
            value: t.response
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $06484a9711eaa5fc$var$cn extends Error {
    constructor(e, t){
        var n, o;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "cause", void 0), $06484a9711eaa5fc$var$ht(this, "code", void 0), $06484a9711eaa5fc$var$ht(this, "error", void 0), $06484a9711eaa5fc$var$ht(this, "error_description", void 0), this.name = this.constructor.name, this.code = $06484a9711eaa5fc$var$Ln, this.cause = t.cause, this.error = t.cause.get("error"), this.error_description = null !== (n = t.cause.get("error_description")) && void 0 !== n ? n : void 0, null === (o = Error.captureStackTrace) || void 0 === o || o.call(Error, this, this.constructor);
    }
}
class $06484a9711eaa5fc$var$un extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "cause", void 0), $06484a9711eaa5fc$var$ht(this, "code", void 0), $06484a9711eaa5fc$var$ht(this, "response", void 0), $06484a9711eaa5fc$var$ht(this, "status", void 0), this.name = this.constructor.name, this.code = $06484a9711eaa5fc$var$jn, this.cause = t.cause, this.status = t.response.status, this.response = t.response, Object.defineProperty(this, "response", {
            enumerable: !1
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
const $06484a9711eaa5fc$var$ln = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", $06484a9711eaa5fc$var$dn = new RegExp("^[,\\s]*(" + $06484a9711eaa5fc$var$ln + ")"), $06484a9711eaa5fc$var$hn = new RegExp('^[,\\s]*([a-zA-Z0-9!#$%&\\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"[,\\s]*(.*)'), $06484a9711eaa5fc$var$pn = new RegExp("^[,\\s]*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)[,\\s]*(.*)"), $06484a9711eaa5fc$var$fn = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
async function $06484a9711eaa5fc$var$mn(e, t, n) {
    if (e.status !== t) {
        let t;
        var o;
        if (function(e) {
            let t;
            if (t = function(e) {
                if (!$06484a9711eaa5fc$var$_t(e, Response)) throw $06484a9711eaa5fc$var$kt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
                const t = e.headers.get("www-authenticate");
                if (null === t) return;
                const n = [];
                let o = t;
                for(; o;){
                    var r;
                    let e = o.match($06484a9711eaa5fc$var$dn);
                    const t = null === (r = e) || void 0 === r ? void 0 : r[1].toLowerCase();
                    if (!t) return;
                    const i = o.substring(e[0].length);
                    if (i && !i.match(/^[\s,]/)) return;
                    const a = i.match(/^\s+(.*)$/), s = !!a;
                    o = a ? a[1] : void 0;
                    const c = {};
                    let u;
                    if (s) for(; o;){
                        let t, n;
                        if (e = o.match($06484a9711eaa5fc$var$hn)) {
                            if ([, t, n, o] = e, n.includes("\\")) try {
                                n = JSON.parse('"'.concat(n, '"'));
                            } catch (e) {}
                            c[t.toLowerCase()] = n;
                        } else {
                            if (!(e = o.match($06484a9711eaa5fc$var$pn))) {
                                if (e = o.match($06484a9711eaa5fc$var$fn)) {
                                    if (Object.keys(c).length) break;
                                    [, u, o] = e;
                                    break;
                                }
                                return;
                            }
                            [, t, n, o] = e, c[t.toLowerCase()] = n;
                        }
                    }
                    else o = i || void 0;
                    const l = {
                        scheme: t,
                        parameters: c
                    };
                    u && (l.token68 = u), n.push(l);
                }
                return n.length ? n : void 0;
            }(e)) throw new $06484a9711eaa5fc$var$un("server responded with a challenge in the WWW-Authenticate HTTP Header", {
                cause: t,
                response: e
            });
        }(e), t = await async function(e) {
            if (e.status > 399 && e.status < 500) {
                $06484a9711eaa5fc$var$qn(e), $06484a9711eaa5fc$var$Gt(e);
                try {
                    const t = await e.clone().json();
                    if ($06484a9711eaa5fc$var$Wt(t) && "string" == typeof t.error && t.error.length) return t;
                } catch (e) {}
            }
        }(e)) throw await (null === (o = e.body) || void 0 === o ? void 0 : o.cancel()), new $06484a9711eaa5fc$var$sn("server responded with an error in the response body", {
            cause: t,
            response: e
        });
        throw $06484a9711eaa5fc$var$Ut('"response" is not a conform '.concat(n, " response (unexpected HTTP status code)"), $06484a9711eaa5fc$var$zn, e);
    }
}
function $06484a9711eaa5fc$var$yn(e) {
    if (!$06484a9711eaa5fc$var$An.has(e)) throw $06484a9711eaa5fc$var$kt('"options.DPoP" is not a valid DPoPHandle', "ERR_INVALID_ARG_VALUE");
}
function $06484a9711eaa5fc$var$wn(e) {
    var t;
    return null === (t = e.headers.get("content-type")) || void 0 === t ? void 0 : t.split(";")[0];
}
async function $06484a9711eaa5fc$var$gn(e, t, n, o, r, i, a) {
    return await n(e, t, r, i), i.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), ((null == a ? void 0 : a[$06484a9711eaa5fc$var$At]) || fetch)(o.href, {
        body: r,
        headers: Object.fromEntries(i.entries()),
        method: "POST",
        redirect: "manual",
        signal: $06484a9711eaa5fc$var$Ht(o, null == a ? void 0 : a.signal)
    });
}
async function $06484a9711eaa5fc$var$vn(e, t, n, o, r, i) {
    var a;
    const s = $06484a9711eaa5fc$var$an(e, "token_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$06484a9711eaa5fc$var$St]));
    r.set("grant_type", o);
    const c = $06484a9711eaa5fc$var$zt(null == i ? void 0 : i.headers);
    c.set("accept", "application/json"), void 0 !== (null == i ? void 0 : i.DPoP) && ($06484a9711eaa5fc$var$yn(i.DPoP), await i.DPoP.addProof(s, c, "POST"));
    const u = await $06484a9711eaa5fc$var$gn(e, t, n, s, r, c, i);
    return null == i || null === (a = i.DPoP) || void 0 === a || a.cacheNonce(u, s), u;
}
const $06484a9711eaa5fc$var$bn = new WeakMap, $06484a9711eaa5fc$var$_n = new WeakMap;
function $06484a9711eaa5fc$var$kn(e) {
    if (!e.id_token) return;
    const t = $06484a9711eaa5fc$var$bn.get(e);
    if (!t) throw $06484a9711eaa5fc$var$kt('"ref" was already garbage collected or did not resolve from the proper sources', "ERR_INVALID_ARG_VALUE");
    return t;
}
async function $06484a9711eaa5fc$var$Sn(e, t, n, o, r, i) {
    if ($06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), !$06484a9711eaa5fc$var$_t(n, Response)) throw $06484a9711eaa5fc$var$kt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await $06484a9711eaa5fc$var$mn(n, 200, "Token Endpoint"), $06484a9711eaa5fc$var$qn(n);
    const a = await $06484a9711eaa5fc$var$oo(n);
    if ($06484a9711eaa5fc$var$Ft(a.access_token, '"response" body "access_token" property', $06484a9711eaa5fc$var$Nn, {
        body: a
    }), $06484a9711eaa5fc$var$Ft(a.token_type, '"response" body "token_type" property', $06484a9711eaa5fc$var$Nn, {
        body: a
    }), a.token_type = a.token_type.toLowerCase(), void 0 !== a.expires_in) {
        let e = "number" != typeof a.expires_in ? parseFloat(a.expires_in) : a.expires_in;
        $06484a9711eaa5fc$var$Vt(e, !0, '"response" body "expires_in" property', $06484a9711eaa5fc$var$Nn, {
            body: a
        }), a.expires_in = e;
    }
    if (void 0 !== a.refresh_token && $06484a9711eaa5fc$var$Ft(a.refresh_token, '"response" body "refresh_token" property', $06484a9711eaa5fc$var$Nn, {
        body: a
    }), void 0 !== a.scope && "string" != typeof a.scope) throw $06484a9711eaa5fc$var$Ut('"response" body "scope" property must be a string', $06484a9711eaa5fc$var$Nn, {
        body: a
    });
    if (void 0 !== a.id_token) {
        $06484a9711eaa5fc$var$Ft(a.id_token, '"response" body "id_token" property', $06484a9711eaa5fc$var$Nn, {
            body: a
        });
        const i = [
            "aud",
            "exp",
            "iat",
            "iss",
            "sub"
        ];
        !0 === t.require_auth_time && i.push("auth_time"), void 0 !== t.default_max_age && ($06484a9711eaa5fc$var$Vt(t.default_max_age, !0, '"client.default_max_age"'), i.push("auth_time")), null != o && o.length && i.push(...o);
        const { claims: s, jwt: c } = await (async function(e, t, n, o, r) {
            let i, a, { 0: s, 1: c, length: u } = e.split(".");
            if (5 === u) {
                if (void 0 === r) throw new $06484a9711eaa5fc$var$Kt("JWE decryption is not configured", {
                    cause: e
                });
                e = await r(e), { 0: s, 1: c, length: u } = e.split(".");
            }
            if (3 !== u) throw $06484a9711eaa5fc$var$Ut("Invalid JWT", $06484a9711eaa5fc$var$Nn, e);
            try {
                i = JSON.parse($06484a9711eaa5fc$var$Ot($06484a9711eaa5fc$var$Dt(s)));
            } catch (e) {
                throw $06484a9711eaa5fc$var$Ut("failed to parse JWT Header body as base64url encoded JSON", $06484a9711eaa5fc$var$Un, e);
            }
            if (!$06484a9711eaa5fc$var$Wt(i)) throw $06484a9711eaa5fc$var$Ut("JWT Header must be a top level object", $06484a9711eaa5fc$var$Nn, e);
            if (t(i), void 0 !== i.crit) throw new $06484a9711eaa5fc$var$Kt('no JWT "crit" header parameter extensions are supported', {
                cause: {
                    header: i
                }
            });
            try {
                a = JSON.parse($06484a9711eaa5fc$var$Ot($06484a9711eaa5fc$var$Dt(c)));
            } catch (e) {
                throw $06484a9711eaa5fc$var$Ut("failed to parse JWT Payload body as base64url encoded JSON", $06484a9711eaa5fc$var$Un, e);
            }
            if (!$06484a9711eaa5fc$var$Wt(a)) throw $06484a9711eaa5fc$var$Ut("JWT Payload must be a top level object", $06484a9711eaa5fc$var$Nn, e);
            const l = $06484a9711eaa5fc$var$Yt() + n;
            if (void 0 !== a.exp) {
                if ("number" != typeof a.exp) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "exp" (expiration time) claim type', $06484a9711eaa5fc$var$Nn, {
                    claims: a
                });
                if (a.exp <= l - o) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', $06484a9711eaa5fc$var$Jn, {
                    claims: a,
                    now: l,
                    tolerance: o,
                    claim: "exp"
                });
            }
            if (void 0 !== a.iat && "number" != typeof a.iat) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "iat" (issued at) claim type', $06484a9711eaa5fc$var$Nn, {
                claims: a
            });
            if (void 0 !== a.iss && "string" != typeof a.iss) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "iss" (issuer) claim type', $06484a9711eaa5fc$var$Nn, {
                claims: a
            });
            if (void 0 !== a.nbf) {
                if ("number" != typeof a.nbf) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "nbf" (not before) claim type', $06484a9711eaa5fc$var$Nn, {
                    claims: a
                });
                if (a.nbf > l + o) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "nbf" (not before) claim value', $06484a9711eaa5fc$var$Jn, {
                    claims: a,
                    now: l,
                    tolerance: o,
                    claim: "nbf"
                });
            }
            if (void 0 !== a.aud && "string" != typeof a.aud && !Array.isArray(a.aud)) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "aud" (audience) claim type', $06484a9711eaa5fc$var$Nn, {
                claims: a
            });
            return {
                header: i,
                claims: a,
                jwt: e
            };
        })(a.id_token, $06484a9711eaa5fc$var$Qn.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), $06484a9711eaa5fc$var$Bt(t), $06484a9711eaa5fc$var$Xt(t), r).then($06484a9711eaa5fc$var$In.bind(void 0, i)).then($06484a9711eaa5fc$var$Tn.bind(void 0, e)).then($06484a9711eaa5fc$var$En.bind(void 0, t.client_id));
        if (Array.isArray(s.aud) && 1 !== s.aud.length) {
            if (void 0 === s.azp) throw $06484a9711eaa5fc$var$Ut('ID Token "aud" (audience) claim includes additional untrusted audiences', $06484a9711eaa5fc$var$Vn, {
                claims: s,
                claim: "aud"
            });
            if (s.azp !== t.client_id) throw $06484a9711eaa5fc$var$Ut('unexpected ID Token "azp" (authorized party) claim value', $06484a9711eaa5fc$var$Vn, {
                expected: t.client_id,
                claims: s,
                claim: "azp"
            });
        }
        void 0 !== s.auth_time && $06484a9711eaa5fc$var$Vt(s.auth_time, !0, 'ID Token "auth_time" (authentication time)', $06484a9711eaa5fc$var$Nn, {
            claims: s
        }), $06484a9711eaa5fc$var$_n.set(n, c), $06484a9711eaa5fc$var$bn.set(a, s);
    }
    if (void 0 !== (null == i ? void 0 : i[a.token_type])) i[a.token_type](n, a);
    else if ("dpop" !== a.token_type && "bearer" !== a.token_type) throw new $06484a9711eaa5fc$var$Kt("unsupported `token_type` value", {
        cause: {
            body: a
        }
    });
    return a;
}
function $06484a9711eaa5fc$var$En(e, t) {
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e)) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "aud" (audience) claim value', $06484a9711eaa5fc$var$Vn, {
            expected: e,
            claims: t.claims,
            claim: "aud"
        });
    } else if (t.claims.aud !== e) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "aud" (audience) claim value', $06484a9711eaa5fc$var$Vn, {
        expected: e,
        claims: t.claims,
        claim: "aud"
    });
    return t;
}
function $06484a9711eaa5fc$var$Tn(e, t) {
    var n, o;
    const r = null !== (n = null === (o = e[$06484a9711eaa5fc$var$io]) || void 0 === o ? void 0 : o.call(e, t)) && void 0 !== n ? n : e.issuer;
    if (t.claims.iss !== r) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "iss" (issuer) claim value', $06484a9711eaa5fc$var$Vn, {
        expected: r,
        claims: t.claims,
        claim: "iss"
    });
    return t;
}
const $06484a9711eaa5fc$var$An = new WeakSet;
const $06484a9711eaa5fc$var$Pn = Symbol();
const $06484a9711eaa5fc$var$Rn = {
    aud: "audience",
    c_hash: "code hash",
    client_id: "client id",
    exp: "expiration time",
    iat: "issued at",
    iss: "issuer",
    jti: "jwt id",
    nonce: "nonce",
    s_hash: "state hash",
    sub: "subject",
    ath: "access token hash",
    htm: "http method",
    htu: "http uri",
    cnf: "confirmation",
    auth_time: "authentication time"
};
function $06484a9711eaa5fc$var$In(e, t) {
    for (const n of e)if (void 0 === t.claims[n]) throw $06484a9711eaa5fc$var$Ut('JWT "'.concat(n, '" (').concat($06484a9711eaa5fc$var$Rn[n], ") claim missing"), $06484a9711eaa5fc$var$Nn, {
        claims: t.claims
    });
    return t;
}
const $06484a9711eaa5fc$var$xn = Symbol(), $06484a9711eaa5fc$var$On = Symbol();
async function $06484a9711eaa5fc$var$Cn(e, t, n, o) {
    return "string" == typeof (null == o ? void 0 : o.expectedNonce) || "number" == typeof (null == o ? void 0 : o.maxAge) || null != o && o.requireIdToken ? async function(e, t, n, o, r, i, a) {
        const s = [];
        switch(o){
            case void 0:
                o = $06484a9711eaa5fc$var$xn;
                break;
            case $06484a9711eaa5fc$var$xn:
                break;
            default:
                $06484a9711eaa5fc$var$Ft(o, '"expectedNonce" argument'), s.push("nonce");
        }
        switch(null != r || (r = t.default_max_age), r){
            case void 0:
                r = $06484a9711eaa5fc$var$On;
                break;
            case $06484a9711eaa5fc$var$On:
                break;
            default:
                $06484a9711eaa5fc$var$Vt(r, !0, '"maxAge" argument'), s.push("auth_time");
        }
        const c = await $06484a9711eaa5fc$var$Sn(e, t, n, s, i, a);
        $06484a9711eaa5fc$var$Ft(c.id_token, '"response" body "id_token" property', $06484a9711eaa5fc$var$Nn, {
            body: c
        });
        const u = $06484a9711eaa5fc$var$kn(c);
        if (r !== $06484a9711eaa5fc$var$On) {
            const e = $06484a9711eaa5fc$var$Yt() + $06484a9711eaa5fc$var$Bt(t), n = $06484a9711eaa5fc$var$Xt(t);
            if (u.auth_time + r < e - n) throw $06484a9711eaa5fc$var$Ut("too much time has elapsed since the last End-User authentication", $06484a9711eaa5fc$var$Jn, {
                claims: u,
                now: e,
                tolerance: n,
                claim: "auth_time"
            });
        }
        if (o === $06484a9711eaa5fc$var$xn) {
            if (void 0 !== u.nonce) throw $06484a9711eaa5fc$var$Ut('unexpected ID Token "nonce" claim value', $06484a9711eaa5fc$var$Vn, {
                expected: void 0,
                claims: u,
                claim: "nonce"
            });
        } else if (u.nonce !== o) throw $06484a9711eaa5fc$var$Ut('unexpected ID Token "nonce" claim value', $06484a9711eaa5fc$var$Vn, {
            expected: o,
            claims: u,
            claim: "nonce"
        });
        return c;
    }(e, t, n, o.expectedNonce, o.maxAge, o[$06484a9711eaa5fc$var$Rt], o.recognizedTokenTypes) : async function(e, t, n, o, r) {
        const i = await $06484a9711eaa5fc$var$Sn(e, t, n, void 0, o, r), a = $06484a9711eaa5fc$var$kn(i);
        if (a) {
            if (void 0 !== t.default_max_age) {
                $06484a9711eaa5fc$var$Vt(t.default_max_age, !0, '"client.default_max_age"');
                const e = $06484a9711eaa5fc$var$Yt() + $06484a9711eaa5fc$var$Bt(t), n = $06484a9711eaa5fc$var$Xt(t);
                if (a.auth_time + t.default_max_age < e - n) throw $06484a9711eaa5fc$var$Ut("too much time has elapsed since the last End-User authentication", $06484a9711eaa5fc$var$Jn, {
                    claims: a,
                    now: e,
                    tolerance: n,
                    claim: "auth_time"
                });
            }
            if (void 0 !== a.nonce) throw $06484a9711eaa5fc$var$Ut('unexpected ID Token "nonce" claim value', $06484a9711eaa5fc$var$Vn, {
                expected: void 0,
                claims: a,
                claim: "nonce"
            });
        }
        return i;
    }(e, t, n, null == o ? void 0 : o[$06484a9711eaa5fc$var$Rt], null == o ? void 0 : o.recognizedTokenTypes);
}
const $06484a9711eaa5fc$var$jn = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", $06484a9711eaa5fc$var$Dn = "OAUTH_RESPONSE_BODY_ERROR", $06484a9711eaa5fc$var$Kn = "OAUTH_UNSUPPORTED_OPERATION", $06484a9711eaa5fc$var$Ln = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", $06484a9711eaa5fc$var$Un = "OAUTH_PARSE_ERROR", $06484a9711eaa5fc$var$Nn = "OAUTH_INVALID_RESPONSE", $06484a9711eaa5fc$var$Wn = "OAUTH_RESPONSE_IS_NOT_JSON", $06484a9711eaa5fc$var$zn = "OAUTH_RESPONSE_IS_NOT_CONFORM", $06484a9711eaa5fc$var$Hn = "OAUTH_HTTP_REQUEST_FORBIDDEN", $06484a9711eaa5fc$var$Mn = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", $06484a9711eaa5fc$var$Jn = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", $06484a9711eaa5fc$var$Vn = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", $06484a9711eaa5fc$var$Fn = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", $06484a9711eaa5fc$var$Gn = "OAUTH_MISSING_SERVER_METADATA", $06484a9711eaa5fc$var$Zn = "OAUTH_INVALID_SERVER_METADATA";
function $06484a9711eaa5fc$var$qn(e) {
    if (e.bodyUsed) throw $06484a9711eaa5fc$var$kt('"response" body has been used already', "ERR_INVALID_ARG_VALUE");
}
function $06484a9711eaa5fc$var$Bn(e) {
    const { algorithm: t } = e;
    if ("number" != typeof t.modulusLength || t.modulusLength < 2048) throw new $06484a9711eaa5fc$var$Kt("unsupported ".concat(t.name, " modulusLength"), {
        cause: e
    });
}
function $06484a9711eaa5fc$var$Xn(e) {
    const { algorithm: t } = e;
    switch(t.namedCurve){
        case "P-256":
            return "SHA-256";
        case "P-384":
            return "SHA-384";
        case "P-521":
            return "SHA-512";
        default:
            throw new $06484a9711eaa5fc$var$Kt("unsupported ECDSA namedCurve", {
                cause: e
            });
    }
}
async function $06484a9711eaa5fc$var$Yn(e) {
    if ("POST" !== e.method) throw $06484a9711eaa5fc$var$kt("form_post responses are expected to use the POST method", "ERR_INVALID_ARG_VALUE", {
        cause: e
    });
    if ("application/x-www-form-urlencoded" !== $06484a9711eaa5fc$var$wn(e)) throw $06484a9711eaa5fc$var$kt("form_post responses are expected to use the application/x-www-form-urlencoded content-type", "ERR_INVALID_ARG_VALUE", {
        cause: e
    });
    return async function(e) {
        if (e.bodyUsed) throw $06484a9711eaa5fc$var$kt("form_post Request instances must contain a readable body", "ERR_INVALID_ARG_VALUE", {
            cause: e
        });
        return e.text();
    }(e);
}
function $06484a9711eaa5fc$var$Qn(e, t, n, o) {
    if (void 0 === e) {
        if (Array.isArray(t)) {
            if (!t.includes(o.alg)) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "alg" header parameter', $06484a9711eaa5fc$var$Nn, {
                header: o,
                expected: t,
                reason: "authorization server metadata"
            });
        } else {
            if (void 0 === n) throw $06484a9711eaa5fc$var$Ut('missing client or server configuration to verify used JWT "alg" header parameter', void 0, {
                client: e,
                issuer: t,
                fallback: n
            });
            if ("string" == typeof n ? o.alg !== n : "function" == typeof n ? !n(o.alg) : !n.includes(o.alg)) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "alg" header parameter', $06484a9711eaa5fc$var$Nn, {
                header: o,
                expected: n,
                reason: "default value"
            });
        }
    } else if ("string" == typeof e ? o.alg !== e : !e.includes(o.alg)) throw $06484a9711eaa5fc$var$Ut('unexpected JWT "alg" header parameter', $06484a9711eaa5fc$var$Nn, {
        header: o,
        expected: e,
        reason: "client configuration"
    });
}
function $06484a9711eaa5fc$var$$n(e, t) {
    const { 0: n, length: o } = e.getAll(t);
    if (o > 1) throw $06484a9711eaa5fc$var$Ut('"'.concat(t, '" parameter must be provided only once'), $06484a9711eaa5fc$var$Nn);
    return n;
}
const $06484a9711eaa5fc$var$eo = Symbol(), $06484a9711eaa5fc$var$to = Symbol();
function $06484a9711eaa5fc$var$no(e, t, n, o) {
    if ($06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), n instanceof URL && (n = n.searchParams), !(n instanceof URLSearchParams)) throw $06484a9711eaa5fc$var$kt('"parameters" must be an instance of URLSearchParams, or URL', "ERR_INVALID_ARG_TYPE");
    if ($06484a9711eaa5fc$var$$n(n, "response")) throw $06484a9711eaa5fc$var$Ut('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', $06484a9711eaa5fc$var$Nn, {
        parameters: n
    });
    const r = $06484a9711eaa5fc$var$$n(n, "iss"), i = $06484a9711eaa5fc$var$$n(n, "state");
    if (!r && e.authorization_response_iss_parameter_supported) throw $06484a9711eaa5fc$var$Ut('response parameter "iss" (issuer) missing', $06484a9711eaa5fc$var$Nn, {
        parameters: n
    });
    if (r && r !== e.issuer) throw $06484a9711eaa5fc$var$Ut('unexpected "iss" (issuer) response parameter value', $06484a9711eaa5fc$var$Nn, {
        expected: e.issuer,
        parameters: n
    });
    switch(o){
        case void 0:
        case $06484a9711eaa5fc$var$to:
            if (void 0 !== i) throw $06484a9711eaa5fc$var$Ut('unexpected "state" response parameter encountered', $06484a9711eaa5fc$var$Nn, {
                expected: void 0,
                parameters: n
            });
            break;
        case $06484a9711eaa5fc$var$eo:
            break;
        default:
            if ($06484a9711eaa5fc$var$Ft(o, '"expectedState" argument'), i !== o) throw $06484a9711eaa5fc$var$Ut(void 0 === i ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', $06484a9711eaa5fc$var$Nn, {
                expected: o,
                parameters: n
            });
    }
    if ($06484a9711eaa5fc$var$$n(n, "error")) throw new $06484a9711eaa5fc$var$cn("authorization response from the server is an error", {
        cause: n
    });
    const a = $06484a9711eaa5fc$var$$n(n, "id_token"), s = $06484a9711eaa5fc$var$$n(n, "token");
    if (void 0 !== a || void 0 !== s) throw new $06484a9711eaa5fc$var$Kt("implicit and hybrid flows are not supported");
    var c;
    return c = new URLSearchParams(n), $06484a9711eaa5fc$var$An.add(c), c;
}
async function $06484a9711eaa5fc$var$oo(e) {
    let t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $06484a9711eaa5fc$var$Gt;
    try {
        t = await e.json();
    } catch (t) {
        throw n(e), $06484a9711eaa5fc$var$Ut('failed to parse "response" body as JSON', $06484a9711eaa5fc$var$Un, t);
    }
    if (!$06484a9711eaa5fc$var$Wt(t)) throw $06484a9711eaa5fc$var$Ut('"response" body must be a top level object', $06484a9711eaa5fc$var$Nn, {
        body: t
    });
    return t;
}
const $06484a9711eaa5fc$var$ro = Symbol(), $06484a9711eaa5fc$var$io = Symbol(), $06484a9711eaa5fc$var$ao = new TextEncoder, $06484a9711eaa5fc$var$so = new TextDecoder;
function $06484a9711eaa5fc$var$co(e) {
    const t = new Uint8Array(e.length);
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        if (o > 127) throw new TypeError("non-ASCII string encountered in encode()");
        t[n] = o;
    }
    return t;
}
function $06484a9711eaa5fc$var$uo(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
    const t = atob(e), n = new Uint8Array(t.length);
    for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
    return n;
}
function $06484a9711eaa5fc$var$lo(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64("string" == typeof e ? e : $06484a9711eaa5fc$var$so.decode(e), {
        alphabet: "base64url"
    });
    let t = e;
    t instanceof Uint8Array && (t = $06484a9711eaa5fc$var$so.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
    try {
        return $06484a9711eaa5fc$var$uo(t);
    } catch (e) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
}
class $06484a9711eaa5fc$var$ho extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$ho, "code", "ERR_JOSE_GENERIC");
class $06484a9711eaa5fc$var$po extends $06484a9711eaa5fc$var$ho {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), $06484a9711eaa5fc$var$ht(this, "claim", void 0), $06484a9711eaa5fc$var$ht(this, "reason", void 0), $06484a9711eaa5fc$var$ht(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$po, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
class $06484a9711eaa5fc$var$fo extends $06484a9711eaa5fc$var$ho {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWT_EXPIRED"), $06484a9711eaa5fc$var$ht(this, "claim", void 0), $06484a9711eaa5fc$var$ht(this, "reason", void 0), $06484a9711eaa5fc$var$ht(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$fo, "code", "ERR_JWT_EXPIRED");
class $06484a9711eaa5fc$var$mo extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$mo, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
class $06484a9711eaa5fc$var$yo extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JOSE_NOT_SUPPORTED");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$yo, "code", "ERR_JOSE_NOT_SUPPORTED");
$06484a9711eaa5fc$var$ht(class extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWE_DECRYPTION_FAILED");
    }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
$06484a9711eaa5fc$var$ht(class extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWE_INVALID");
    }
}, "code", "ERR_JWE_INVALID");
class $06484a9711eaa5fc$var$wo extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWS_INVALID");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$wo, "code", "ERR_JWS_INVALID");
class $06484a9711eaa5fc$var$go extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWT_INVALID");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$go, "code", "ERR_JWT_INVALID");
$06484a9711eaa5fc$var$ht(class extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWK_INVALID");
    }
}, "code", "ERR_JWK_INVALID");
class $06484a9711eaa5fc$var$vo extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(...arguments), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWKS_INVALID");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$vo, "code", "ERR_JWKS_INVALID");
class $06484a9711eaa5fc$var$bo extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$bo, "code", "ERR_JWKS_NO_MATCHING_KEY");
class $06484a9711eaa5fc$var$_o extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $06484a9711eaa5fc$var$ht(this, Symbol.asyncIterator, void 0), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$_o, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
class $06484a9711eaa5fc$var$ko extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWKS_TIMEOUT");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$ko, "code", "ERR_JWKS_TIMEOUT");
class $06484a9711eaa5fc$var$So extends $06484a9711eaa5fc$var$ho {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), $06484a9711eaa5fc$var$ht(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
    }
}
$06484a9711eaa5fc$var$ht($06484a9711eaa5fc$var$So, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
const $06484a9711eaa5fc$var$Eo = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "algorithm.name";
    return new TypeError("CryptoKey does not support this operation, its ".concat(t, " must be ").concat(e));
}, $06484a9711eaa5fc$var$To = (e, t)=>e.name === t;
function $06484a9711eaa5fc$var$Ao(e) {
    return parseInt(e.name.slice(4), 10);
}
function $06484a9711eaa5fc$var$Po(e, t, n) {
    switch(t){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$06484a9711eaa5fc$var$To(e.algorithm, "HMAC")) throw $06484a9711eaa5fc$var$Eo("HMAC");
                const n = parseInt(t.slice(2), 10);
                if ($06484a9711eaa5fc$var$Ao(e.algorithm.hash) !== n) throw $06484a9711eaa5fc$var$Eo("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$06484a9711eaa5fc$var$To(e.algorithm, "RSASSA-PKCS1-v1_5")) throw $06484a9711eaa5fc$var$Eo("RSASSA-PKCS1-v1_5");
                const n = parseInt(t.slice(2), 10);
                if ($06484a9711eaa5fc$var$Ao(e.algorithm.hash) !== n) throw $06484a9711eaa5fc$var$Eo("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$06484a9711eaa5fc$var$To(e.algorithm, "RSA-PSS")) throw $06484a9711eaa5fc$var$Eo("RSA-PSS");
                const n = parseInt(t.slice(2), 10);
                if ($06484a9711eaa5fc$var$Ao(e.algorithm.hash) !== n) throw $06484a9711eaa5fc$var$Eo("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "Ed25519":
        case "EdDSA":
            if (!$06484a9711eaa5fc$var$To(e.algorithm, "Ed25519")) throw $06484a9711eaa5fc$var$Eo("Ed25519");
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            if (!$06484a9711eaa5fc$var$To(e.algorithm, t)) throw $06484a9711eaa5fc$var$Eo(t);
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$06484a9711eaa5fc$var$To(e.algorithm, "ECDSA")) throw $06484a9711eaa5fc$var$Eo("ECDSA");
                const n = function(e) {
                    switch(e){
                        case "ES256":
                            return "P-256";
                        case "ES384":
                            return "P-384";
                        case "ES512":
                            return "P-521";
                        default:
                            throw new Error("unreachable");
                    }
                }(t);
                if (e.algorithm.namedCurve !== n) throw $06484a9711eaa5fc$var$Eo(n, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    !function(e, t) {
        if (t && !e.usages.includes(t)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(t, "."));
    }(e, n);
}
function $06484a9711eaa5fc$var$Ro(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
    if ((o = o.filter(Boolean)).length > 2) {
        const t = o.pop();
        e += "one of type ".concat(o.join(", "), ", or ").concat(t, ".");
    } else 2 === o.length ? e += "one of type ".concat(o[0], " or ").concat(o[1], ".") : e += "of type ".concat(o[0], ".");
    if (null == t) e += " Received ".concat(t);
    else if ("function" == typeof t && t.name) e += " Received function ".concat(t.name);
    else if ("object" == typeof t && null != t) {
        var i;
        null !== (i = t.constructor) && void 0 !== i && i.name && (e += " Received an instance of ".concat(t.constructor.name));
    }
    return e;
}
const $06484a9711eaa5fc$var$Io = function(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
    return $06484a9711eaa5fc$var$Ro("Key for the ".concat(e, " algorithm must be "), t, ...o);
}, $06484a9711eaa5fc$var$xo = (e)=>{
    if ("CryptoKey" === (null == e ? void 0 : e[Symbol.toStringTag])) return !0;
    try {
        return e instanceof CryptoKey;
    } catch (e) {
        return !1;
    }
}, $06484a9711eaa5fc$var$Oo = (e)=>"KeyObject" === (null == e ? void 0 : e[Symbol.toStringTag]), $06484a9711eaa5fc$var$Co = (e)=>$06484a9711eaa5fc$var$xo(e) || $06484a9711eaa5fc$var$Oo(e);
function $06484a9711eaa5fc$var$jo(e) {
    if ("object" != typeof (t = e) || null === t || "[object Object]" !== Object.prototype.toString.call(e)) return !1;
    var t;
    if (null === Object.getPrototypeOf(e)) return !0;
    let n = e;
    for(; null !== Object.getPrototypeOf(n);)n = Object.getPrototypeOf(n);
    return Object.getPrototypeOf(e) === n;
}
const $06484a9711eaa5fc$var$Do = (e, t)=>{
    if (e.byteLength !== t.length) return !1;
    for(let n = 0; n < e.byteLength; n++)if (e[n] !== t[n]) return !1;
    return !0;
}, $06484a9711eaa5fc$var$Ko = (e)=>{
    const t = e.data[e.pos++];
    if (128 & t) {
        const n = 127 & t;
        let o = 0;
        for(let t = 0; t < n; t++)o = o << 8 | e.data[e.pos++];
        return o;
    }
    return t;
}, $06484a9711eaa5fc$var$Lo = (e, t, n)=>{
    if (e.data[e.pos++] !== t) throw new Error(n);
}, $06484a9711eaa5fc$var$Uo = (e, t)=>{
    const n = e.data.subarray(e.pos, e.pos + t);
    return e.pos += t, n;
};
const $06484a9711eaa5fc$var$No = (e)=>{
    const t = ((e)=>{
        $06484a9711eaa5fc$var$Lo(e, 6, "Expected algorithm OID");
        const t = $06484a9711eaa5fc$var$Ko(e);
        return $06484a9711eaa5fc$var$Uo(e, t);
    })(e);
    if ($06484a9711eaa5fc$var$Do(t, [
        43,
        101,
        110
    ])) return "X25519";
    if (!$06484a9711eaa5fc$var$Do(t, [
        42,
        134,
        72,
        206,
        61,
        2,
        1
    ])) throw new Error("Unsupported key algorithm");
    $06484a9711eaa5fc$var$Lo(e, 6, "Expected curve OID");
    const n = $06484a9711eaa5fc$var$Ko(e), o = $06484a9711eaa5fc$var$Uo(e, n);
    for (const { name: e, oid: t } of [
        {
            name: "P-256",
            oid: [
                42,
                134,
                72,
                206,
                61,
                3,
                1,
                7
            ]
        },
        {
            name: "P-384",
            oid: [
                43,
                129,
                4,
                0,
                34
            ]
        },
        {
            name: "P-521",
            oid: [
                43,
                129,
                4,
                0,
                35
            ]
        }
    ])if ($06484a9711eaa5fc$var$Do(o, t)) return e;
    throw new Error("Unsupported named curve");
}, $06484a9711eaa5fc$var$Wo = async (e, t, n, o)=>{
    var r;
    let i, a;
    const s = "spki" === e, c = ()=>s ? [
            "verify"
        ] : [
            "sign"
        ];
    switch(n){
        case "PS256":
        case "PS384":
        case "PS512":
            i = {
                name: "RSA-PSS",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            i = {
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            i = {
                name: "RSA-OAEP",
                hash: "SHA-".concat(parseInt(n.slice(-3), 10) || 1)
            }, a = s ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            i = {
                name: "ECDSA",
                namedCurve: ({
                    ES256: "P-256",
                    ES384: "P-384",
                    ES512: "P-521"
                })[n]
            }, a = c();
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            try {
                const e = o.getNamedCurve(t);
                i = "X25519" === e ? {
                    name: "X25519"
                } : {
                    name: "ECDH",
                    namedCurve: e
                };
            } catch (e) {
                throw new $06484a9711eaa5fc$var$yo("Invalid or unsupported key format");
            }
            a = s ? [] : [
                "deriveBits"
            ];
            break;
        case "Ed25519":
        case "EdDSA":
            i = {
                name: "Ed25519"
            }, a = c();
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            i = {
                name: n
            }, a = c();
            break;
        default:
            throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported "alg" (Algorithm) value');
    }
    return crypto.subtle.importKey(e, t, i, null !== (r = null == o ? void 0 : o.extractable) && void 0 !== r ? r : !!s, a);
}, $06484a9711eaa5fc$var$zo = (e, t, n)=>{
    var o;
    const r = ((e, t)=>$06484a9711eaa5fc$var$uo(e.replace(t, "")))(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
    let i = n;
    return null != t && null !== (o = t.startsWith) && void 0 !== o && o.call(t, "ECDH-ES") && (i || (i = {}), i.getNamedCurve = (e)=>{
        const t = {
            data: e,
            pos: 0
        };
        return function(e) {
            $06484a9711eaa5fc$var$Lo(e, 48, "Invalid PKCS#8 structure"), $06484a9711eaa5fc$var$Ko(e), $06484a9711eaa5fc$var$Lo(e, 2, "Expected version field");
            const t = $06484a9711eaa5fc$var$Ko(e);
            e.pos += t, $06484a9711eaa5fc$var$Lo(e, 48, "Expected algorithm identifier");
            const n = $06484a9711eaa5fc$var$Ko(e);
            e.pos;
        }(t), $06484a9711eaa5fc$var$No(t);
    }), $06484a9711eaa5fc$var$Wo("pkcs8", r, t, i);
};
async function $06484a9711eaa5fc$var$Ho(e) {
    var t, n;
    if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: o, keyUsages: r } = function(e) {
        let t, n;
        switch(e.kty){
            case "AKP":
                switch(e.alg){
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                        t = {
                            name: e.alg
                        }, n = e.priv ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    default:
                        throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "RSA":
                switch(e.alg){
                    case "PS256":
                    case "PS384":
                    case "PS512":
                        t = {
                            name: "RSA-PSS",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RS256":
                    case "RS384":
                    case "RS512":
                        t = {
                            name: "RSASSA-PKCS1-v1_5",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RSA-OAEP":
                    case "RSA-OAEP-256":
                    case "RSA-OAEP-384":
                    case "RSA-OAEP-512":
                        t = {
                            name: "RSA-OAEP",
                            hash: "SHA-".concat(parseInt(e.alg.slice(-3), 10) || 1)
                        }, n = e.d ? [
                            "decrypt",
                            "unwrapKey"
                        ] : [
                            "encrypt",
                            "wrapKey"
                        ];
                        break;
                    default:
                        throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "EC":
                switch(e.alg){
                    case "ES256":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-256"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ES384":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-384"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ES512":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-521"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: "ECDH",
                            namedCurve: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "OKP":
                switch(e.alg){
                    case "Ed25519":
                    case "EdDSA":
                        t = {
                            name: "Ed25519"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            default:
                throw new $06484a9711eaa5fc$var$yo('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
        }
        return {
            algorithm: t,
            keyUsages: n
        };
    }(e), i = $06484a9711eaa5fc$var$ft({}, e);
    return "AKP" !== i.kty && delete i.alg, delete i.use, crypto.subtle.importKey("jwk", i, o, null !== (t = e.ext) && void 0 !== t ? t : !e.d && !e.priv, null !== (n = e.key_ops) && void 0 !== n ? n : r);
}
const $06484a9711eaa5fc$var$Mo = (e)=>$06484a9711eaa5fc$var$jo(e) && "string" == typeof e.kty;
let $06484a9711eaa5fc$var$Jo;
const $06484a9711eaa5fc$var$Vo = async function(e, t, n) {
    let o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    $06484a9711eaa5fc$var$Jo || ($06484a9711eaa5fc$var$Jo = new WeakMap);
    let r = $06484a9711eaa5fc$var$Jo.get(e);
    if (null != r && r[n]) return r[n];
    const i = await $06484a9711eaa5fc$var$Ho($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, t), {}, {
        alg: n
    }));
    return o && Object.freeze(e), r ? r[n] = i : $06484a9711eaa5fc$var$Jo.set(e, {
        [n]: i
    }), i;
};
async function $06484a9711eaa5fc$var$Fo(e, t) {
    if (e instanceof Uint8Array) return e;
    if ($06484a9711eaa5fc$var$xo(e)) return e;
    if ($06484a9711eaa5fc$var$Oo(e)) {
        if ("secret" === e.type) return e.export();
        if ("toCryptoKey" in e && "function" == typeof e.toCryptoKey) try {
            return ((e, t)=>{
                $06484a9711eaa5fc$var$Jo || ($06484a9711eaa5fc$var$Jo = new WeakMap);
                let n = $06484a9711eaa5fc$var$Jo.get(e);
                if (null != n && n[t]) return n[t];
                const o = "public" === e.type, r = !!o;
                let i;
                if ("x25519" === e.asymmetricKeyType) {
                    switch(t){
                        case "ECDH-ES":
                        case "ECDH-ES+A128KW":
                        case "ECDH-ES+A192KW":
                        case "ECDH-ES+A256KW":
                            break;
                        default:
                            throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    }
                    i = e.toCryptoKey(e.asymmetricKeyType, r, o ? [] : [
                        "deriveBits"
                    ]);
                }
                if ("ed25519" === e.asymmetricKeyType) {
                    if ("EdDSA" !== t && "Ed25519" !== t) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    i = e.toCryptoKey(e.asymmetricKeyType, r, [
                        o ? "verify" : "sign"
                    ]);
                }
                switch(e.asymmetricKeyType){
                    case "ml-dsa-44":
                    case "ml-dsa-65":
                    case "ml-dsa-87":
                        if (t !== e.asymmetricKeyType.toUpperCase()) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                        i = e.toCryptoKey(e.asymmetricKeyType, r, [
                            o ? "verify" : "sign"
                        ]);
                }
                if ("rsa" === e.asymmetricKeyType) {
                    let n;
                    switch(t){
                        case "RSA-OAEP":
                            n = "SHA-1";
                            break;
                        case "RS256":
                        case "PS256":
                        case "RSA-OAEP-256":
                            n = "SHA-256";
                            break;
                        case "RS384":
                        case "PS384":
                        case "RSA-OAEP-384":
                            n = "SHA-384";
                            break;
                        case "RS512":
                        case "PS512":
                        case "RSA-OAEP-512":
                            n = "SHA-512";
                            break;
                        default:
                            throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    }
                    if (t.startsWith("RSA-OAEP")) return e.toCryptoKey({
                        name: "RSA-OAEP",
                        hash: n
                    }, r, o ? [
                        "encrypt"
                    ] : [
                        "decrypt"
                    ]);
                    i = e.toCryptoKey({
                        name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
                        hash: n
                    }, r, [
                        o ? "verify" : "sign"
                    ]);
                }
                if ("ec" === e.asymmetricKeyType) {
                    var a;
                    const n = new Map([
                        [
                            "prime256v1",
                            "P-256"
                        ],
                        [
                            "secp384r1",
                            "P-384"
                        ],
                        [
                            "secp521r1",
                            "P-521"
                        ]
                    ]).get(null === (a = e.asymmetricKeyDetails) || void 0 === a ? void 0 : a.namedCurve);
                    if (!n) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    "ES256" === t && "P-256" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), "ES384" === t && "P-384" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), "ES512" === t && "P-521" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), t.startsWith("ECDH-ES") && (i = e.toCryptoKey({
                        name: "ECDH",
                        namedCurve: n
                    }, r, o ? [] : [
                        "deriveBits"
                    ]));
                }
                if (!i) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                return n ? n[t] = i : $06484a9711eaa5fc$var$Jo.set(e, {
                    [t]: i
                }), i;
            })(e, t);
        } catch (e) {
            if (e instanceof TypeError) throw e;
        }
        let n = e.export({
            format: "jwk"
        });
        return $06484a9711eaa5fc$var$Vo(e, n, t);
    }
    if ($06484a9711eaa5fc$var$Mo(e)) return e.k ? $06484a9711eaa5fc$var$lo(e.k) : $06484a9711eaa5fc$var$Vo(e, e, t, !0);
    throw new Error("unreachable");
}
const $06484a9711eaa5fc$var$Go = (e)=>null == e ? void 0 : e[Symbol.toStringTag], $06484a9711eaa5fc$var$Zo = (e, t, n)=>{
    if (void 0 !== t.use) {
        let e;
        switch(n){
            case "sign":
            case "verify":
                e = "sig";
                break;
            case "encrypt":
            case "decrypt":
                e = "enc";
        }
        if (t.use !== e) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(e, '" when present'));
    }
    if (void 0 !== t.alg && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
    if (Array.isArray(t.key_ops)) {
        var o, r;
        let i;
        switch(!0){
            case "sign" === n || "verify" === n:
            case "dir" === e:
            case e.includes("CBC-HS"):
                i = n;
                break;
            case e.startsWith("PBES2"):
                i = "deriveBits";
                break;
            case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
                i = !e.includes("GCM") && e.endsWith("KW") ? "encrypt" === n ? "wrapKey" : "unwrapKey" : n;
                break;
            case "encrypt" === n && e.startsWith("RSA"):
                i = "wrapKey";
                break;
            case "decrypt" === n:
                i = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        }
        if (i && !1 === (null === (o = t.key_ops) || void 0 === o || null === (r = o.includes) || void 0 === r ? void 0 : r.call(o, i))) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(i, '" when present'));
    }
    return !0;
};
function $06484a9711eaa5fc$var$qo(e, t, n) {
    switch(e.substring(0, 2)){
        case "A1":
        case "A2":
        case "di":
        case "HS":
        case "PB":
            ((e, t, n)=>{
                if (!(t instanceof Uint8Array)) {
                    if ($06484a9711eaa5fc$var$Mo(t)) {
                        if (((e)=>"oct" === e.kty && "string" == typeof e.k)(t) && $06484a9711eaa5fc$var$Zo(e, t, n)) return;
                        throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
                    }
                    if (!$06484a9711eaa5fc$var$Co(t)) throw new TypeError($06484a9711eaa5fc$var$Io(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
                    if ("secret" !== t.type) throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for symmetric algorithms must be of type "secret"'));
                }
            })(e, t, n);
            break;
        default:
            ((e, t, n)=>{
                if ($06484a9711eaa5fc$var$Mo(t)) switch(n){
                    case "decrypt":
                    case "sign":
                        if (((e)=>"oct" !== e.kty && ("AKP" === e.kty && "string" == typeof e.priv || "string" == typeof e.d))(t) && $06484a9711eaa5fc$var$Zo(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a private JWK");
                    case "encrypt":
                    case "verify":
                        if (((e)=>"oct" !== e.kty && void 0 === e.d && void 0 === e.priv)(t) && $06484a9711eaa5fc$var$Zo(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a public JWK");
                }
                if (!$06484a9711eaa5fc$var$Co(t)) throw new TypeError($06484a9711eaa5fc$var$Io(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
                if ("secret" === t.type) throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for asymmetric algorithms must not be of type "secret"'));
                if ("public" === t.type) switch(n){
                    case "sign":
                        throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for asymmetric algorithm signing must be of type "private"'));
                    case "decrypt":
                        throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for asymmetric algorithm decryption must be of type "private"'));
                }
                if ("private" === t.type) switch(n){
                    case "verify":
                        throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for asymmetric algorithm verifying must be of type "public"'));
                    case "encrypt":
                        throw new TypeError("".concat($06484a9711eaa5fc$var$Go(t), ' instances for asymmetric algorithm encryption must be of type "public"'));
                }
            })(e, t, n);
    }
}
var $06484a9711eaa5fc$var$Bo, $06484a9711eaa5fc$var$Xo;
let $06484a9711eaa5fc$var$Yo, $06484a9711eaa5fc$var$Qo;
if ("undefined" == typeof navigator || null === ($06484a9711eaa5fc$var$Bo = navigator.userAgent) || void 0 === $06484a9711eaa5fc$var$Bo || null === ($06484a9711eaa5fc$var$Xo = $06484a9711eaa5fc$var$Bo.startsWith) || void 0 === $06484a9711eaa5fc$var$Xo || !$06484a9711eaa5fc$var$Xo.call($06484a9711eaa5fc$var$Bo, "Mozilla/5.0 ")) {
    const e = "v6.8.1";
    $06484a9711eaa5fc$var$Qo = "".concat("openid-client", "/").concat(e), $06484a9711eaa5fc$var$Yo = {
        "user-agent": $06484a9711eaa5fc$var$Qo
    };
}
const $06484a9711eaa5fc$var$$o = (e)=>$06484a9711eaa5fc$var$er.get(e);
let $06484a9711eaa5fc$var$er, $06484a9711eaa5fc$var$tr;
function $06484a9711eaa5fc$var$nr(e) {
    return void 0 !== e ? $06484a9711eaa5fc$var$en(e) : ($06484a9711eaa5fc$var$tr || ($06484a9711eaa5fc$var$tr = new WeakMap), (e, t, n, o)=>{
        let r;
        return (r = $06484a9711eaa5fc$var$tr.get(t)) || (!function(e, t) {
            if ("string" != typeof e) throw $06484a9711eaa5fc$var$ar("".concat(t, " must be a string"), $06484a9711eaa5fc$var$ir);
            if (0 === e.length) throw $06484a9711eaa5fc$var$ar("".concat(t, " must not be empty"), $06484a9711eaa5fc$var$rr);
        }(t.client_secret, '"metadata.client_secret"'), r = $06484a9711eaa5fc$var$en(t.client_secret), $06484a9711eaa5fc$var$tr.set(t, r)), r(e, t, n, o);
    });
}
const $06484a9711eaa5fc$var$or = $06484a9711eaa5fc$var$At, $06484a9711eaa5fc$var$rr = "ERR_INVALID_ARG_VALUE", $06484a9711eaa5fc$var$ir = "ERR_INVALID_ARG_TYPE";
function $06484a9711eaa5fc$var$ar(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
function $06484a9711eaa5fc$var$sr(e) {
    return async function(e) {
        return $06484a9711eaa5fc$var$Ft(e, "codeVerifier"), $06484a9711eaa5fc$var$Dt(await crypto.subtle.digest("SHA-256", $06484a9711eaa5fc$var$Ot(e)));
    }(e);
}
function $06484a9711eaa5fc$var$cr() {
    return $06484a9711eaa5fc$var$Zt();
}
class $06484a9711eaa5fc$var$ur extends Error {
    constructor(e, t){
        var n;
        super(e, t), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.name = this.constructor.name, this.code = null == t ? void 0 : t.code, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $06484a9711eaa5fc$var$lr(e, t, n) {
    return new $06484a9711eaa5fc$var$ur(e, {
        cause: t,
        code: n
    });
}
function $06484a9711eaa5fc$var$dr(e) {
    if (e instanceof TypeError || e instanceof $06484a9711eaa5fc$var$ur || e instanceof $06484a9711eaa5fc$var$sn || e instanceof $06484a9711eaa5fc$var$cn || e instanceof $06484a9711eaa5fc$var$un) throw e;
    if (e instanceof $06484a9711eaa5fc$var$Lt) switch(e.code){
        case $06484a9711eaa5fc$var$Hn:
            throw $06484a9711eaa5fc$var$lr("only requests to HTTPS are allowed", e, e.code);
        case $06484a9711eaa5fc$var$Mn:
            throw $06484a9711eaa5fc$var$lr("only requests to HTTP or HTTPS are allowed", e, e.code);
        case $06484a9711eaa5fc$var$zn:
            throw $06484a9711eaa5fc$var$lr("unexpected HTTP response status code", e.cause, e.code);
        case $06484a9711eaa5fc$var$Wn:
            throw $06484a9711eaa5fc$var$lr("unexpected response content-type", e.cause, e.code);
        case $06484a9711eaa5fc$var$Un:
            throw $06484a9711eaa5fc$var$lr("parsing error occured", e, e.code);
        case $06484a9711eaa5fc$var$Nn:
            throw $06484a9711eaa5fc$var$lr("invalid response encountered", e, e.code);
        case $06484a9711eaa5fc$var$Vn:
            throw $06484a9711eaa5fc$var$lr("unexpected JWT claim value encountered", e, e.code);
        case $06484a9711eaa5fc$var$Fn:
            throw $06484a9711eaa5fc$var$lr("unexpected JSON attribute value encountered", e, e.code);
        case $06484a9711eaa5fc$var$Jn:
            throw $06484a9711eaa5fc$var$lr("JWT timestamp claim value failed validation", e, e.code);
        default:
            throw $06484a9711eaa5fc$var$lr(e.message, e, e.code);
    }
    if (e instanceof $06484a9711eaa5fc$var$Kt) throw $06484a9711eaa5fc$var$lr("unsupported operation", e, e.code);
    if (e instanceof DOMException) switch(e.name){
        case "OperationError":
            throw $06484a9711eaa5fc$var$lr("runtime operation error", e, $06484a9711eaa5fc$var$Kn);
        case "NotSupportedError":
            throw $06484a9711eaa5fc$var$lr("runtime unsupported operation", e, $06484a9711eaa5fc$var$Kn);
        case "TimeoutError":
            throw $06484a9711eaa5fc$var$lr("operation timed out", e, "OAUTH_TIMEOUT");
        case "AbortError":
            throw $06484a9711eaa5fc$var$lr("operation aborted", e, "OAUTH_ABORT");
    }
    throw new $06484a9711eaa5fc$var$ur("something went wrong", {
        cause: e
    });
}
async function $06484a9711eaa5fc$var$hr(e, t, n, o, r) {
    const i = await async function(e, t) {
        var n, o;
        if (!(e instanceof URL)) throw $06484a9711eaa5fc$var$ar('"server" must be an instance of URL', $06484a9711eaa5fc$var$ir);
        const r = !e.href.includes("/.well-known/"), i = null !== (n = null == t ? void 0 : t.timeout) && void 0 !== n ? n : 30, a = AbortSignal.timeout(1e3 * i), s = await (r ? $06484a9711eaa5fc$var$Jt(e, {
            algorithm: null == t ? void 0 : t.algorithm,
            [$06484a9711eaa5fc$var$At]: null == t ? void 0 : t[$06484a9711eaa5fc$var$or],
            [$06484a9711eaa5fc$var$St]: null == t || null === (o = t.execute) || void 0 === o ? void 0 : o.includes($06484a9711eaa5fc$var$br),
            signal: a,
            headers: new Headers($06484a9711eaa5fc$var$Yo)
        }) : ((null == t ? void 0 : t[$06484a9711eaa5fc$var$or]) || fetch)(($06484a9711eaa5fc$var$on(e, null == t || null === (c = t.execute) || void 0 === c || !c.includes($06484a9711eaa5fc$var$br)), e.href), {
            headers: Object.fromEntries(new Headers($06484a9711eaa5fc$var$ft({
                accept: "application/json"
            }, $06484a9711eaa5fc$var$Yo)).entries()),
            body: void 0,
            method: "GET",
            redirect: "manual",
            signal: a
        })).then((e)=>(async function(e, t) {
                const n = e;
                if (!(n instanceof URL) && n !== $06484a9711eaa5fc$var$ro) throw $06484a9711eaa5fc$var$kt('"expectedIssuerIdentifier" must be an instance of URL', "ERR_INVALID_ARG_TYPE");
                if (!$06484a9711eaa5fc$var$_t(t, Response)) throw $06484a9711eaa5fc$var$kt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
                if (200 !== t.status) throw $06484a9711eaa5fc$var$Ut('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', $06484a9711eaa5fc$var$zn, t);
                $06484a9711eaa5fc$var$qn(t);
                const o = await $06484a9711eaa5fc$var$oo(t);
                if ($06484a9711eaa5fc$var$Ft(o.issuer, '"response" body "issuer" property', $06484a9711eaa5fc$var$Nn, {
                    body: o
                }), n !== $06484a9711eaa5fc$var$ro && new URL(o.issuer).href !== n.href) throw $06484a9711eaa5fc$var$Ut('"response" body "issuer" property does not match the expected value', $06484a9711eaa5fc$var$Fn, {
                    expected: n.href,
                    body: o,
                    attribute: "issuer"
                });
                return o;
            })($06484a9711eaa5fc$var$ro, e)).catch($06484a9711eaa5fc$var$dr);
        var c;
        r && new URL(s.issuer).href !== e.href && (function(e, t, n) {
            return !("https://login.microsoftonline.com" !== e.origin || null != n && n.algorithm && "oidc" !== n.algorithm || (t[$06484a9711eaa5fc$var$pr] = !0, 0));
        }(e, s, t) || function(e, t) {
            return !(!e.hostname.endsWith(".b2clogin.com") || null != t && t.algorithm && "oidc" !== t.algorithm);
        }(e, t) || (()=>{
            throw new $06484a9711eaa5fc$var$ur("discovered metadata issuer does not match the expected issuer", {
                code: $06484a9711eaa5fc$var$Fn,
                cause: {
                    expected: e.href,
                    body: s,
                    attribute: "issuer"
                }
            });
        })());
        return s;
    }(e, r), a = new $06484a9711eaa5fc$var$fr(i, t, n, o);
    let s = $06484a9711eaa5fc$var$$o(a);
    if (null != r && r[$06484a9711eaa5fc$var$or] && (s.fetch = r[$06484a9711eaa5fc$var$or]), null != r && r.timeout && (s.timeout = r.timeout), null != r && r.execute) for (const e of r.execute)e(a);
    return a;
}
new TextDecoder;
const $06484a9711eaa5fc$var$pr = Symbol();
class $06484a9711eaa5fc$var$fr {
    serverMetadata() {
        const e = structuredClone($06484a9711eaa5fc$var$$o(this).as);
        return function(e) {
            Object.defineProperties(e, function(e) {
                return {
                    supportsPKCE: {
                        __proto__: null,
                        value () {
                            var t;
                            let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "S256";
                            return !0 === (null === (t = e.code_challenge_methods_supported) || void 0 === t ? void 0 : t.includes(n));
                        }
                    }
                };
            }(e));
        }(e), e;
    }
    clientMetadata() {
        return structuredClone($06484a9711eaa5fc$var$$o(this).c);
    }
    get timeout() {
        return $06484a9711eaa5fc$var$$o(this).timeout;
    }
    set timeout(e) {
        $06484a9711eaa5fc$var$$o(this).timeout = e;
    }
    get [$06484a9711eaa5fc$var$or]() {
        return $06484a9711eaa5fc$var$$o(this).fetch;
    }
    set [$06484a9711eaa5fc$var$or](e) {
        $06484a9711eaa5fc$var$$o(this).fetch = e;
    }
    constructor(e, t, n, o){
        var r, i, a, s, c;
        if ("string" != typeof t || !t.length) throw $06484a9711eaa5fc$var$ar('"clientId" must be a non-empty string', $06484a9711eaa5fc$var$ir);
        if ("string" == typeof n && (n = {
            client_secret: n
        }), void 0 !== (null === (r = n) || void 0 === r ? void 0 : r.client_id) && t !== n.client_id) throw $06484a9711eaa5fc$var$ar('"clientId" and "metadata.client_id" must be the same', $06484a9711eaa5fc$var$rr);
        const u = $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, structuredClone(n)), {}, {
            client_id: t
        });
        let l;
        u[$06484a9711eaa5fc$var$Et] = null !== (i = null === (a = n) || void 0 === a ? void 0 : a[$06484a9711eaa5fc$var$Et]) && void 0 !== i ? i : 0, u[$06484a9711eaa5fc$var$Tt] = null !== (s = null === (c = n) || void 0 === c ? void 0 : c[$06484a9711eaa5fc$var$Tt]) && void 0 !== s ? s : 30, l = o || ("string" == typeof u.client_secret && u.client_secret.length ? $06484a9711eaa5fc$var$nr(u.client_secret) : (e, t, n, o)=>{
            n.set("client_id", t.client_id);
        });
        let d = Object.freeze(u);
        const h = structuredClone(e);
        $06484a9711eaa5fc$var$pr in e && (h[$06484a9711eaa5fc$var$io] = (t)=>{
            let { claims: { tid: n } } = t;
            return e.issuer.replace("{tenantid}", n);
        });
        let p = Object.freeze(h);
        $06484a9711eaa5fc$var$er || ($06484a9711eaa5fc$var$er = new WeakMap), $06484a9711eaa5fc$var$er.set(this, {
            __proto__: null,
            as: p,
            c: d,
            auth: l,
            tlsOnly: !0,
            jwksCache: {}
        });
    }
}
function $06484a9711eaa5fc$var$mr(e) {
    Object.defineProperties(e, function(e) {
        let t;
        if (void 0 !== e.expires_in) {
            const n = new Date;
            n.setSeconds(n.getSeconds() + e.expires_in), t = n.getTime();
        }
        return {
            expiresIn: {
                __proto__: null,
                value () {
                    if (t) {
                        const e = Date.now();
                        return t > e ? Math.floor((t - e) / 1e3) : 0;
                    }
                }
            },
            claims: {
                __proto__: null,
                value () {
                    try {
                        return $06484a9711eaa5fc$var$kn(this);
                    } catch (e) {
                        return;
                    }
                }
            }
        };
    }(e));
}
async function $06484a9711eaa5fc$var$yr(e, t, n) {
    var o;
    let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    const i = null === (o = e.headers.get("retry-after")) || void 0 === o ? void 0 : o.trim();
    if (void 0 === i) return;
    let a;
    if (/^\d+$/.test(i)) a = parseInt(i, 10);
    else {
        const e = new Date(i);
        if (Number.isFinite(e.getTime())) {
            const t = new Date, n = e.getTime() - t.getTime();
            n > 0 && (a = Math.ceil(n / 1e3));
        }
    }
    if (r && !Number.isFinite(a)) throw new $06484a9711eaa5fc$var$Lt("invalid Retry-After header value", {
        cause: e
    });
    a > t && await $06484a9711eaa5fc$var$wr(a - t, n);
}
function $06484a9711eaa5fc$var$wr(e, t) {
    return new Promise((n, o)=>{
        const r = (e)=>{
            try {
                t.throwIfAborted();
            } catch (e) {
                return void o(e);
            }
            if (e <= 0) return void n();
            const i = Math.min(e, 5);
            setTimeout(()=>r(e - i), 1e3 * i);
        };
        r(e);
    });
}
async function $06484a9711eaa5fc$var$gr(e, t) {
    $06484a9711eaa5fc$var$Ar(e);
    const { as: n, c: o, auth: r, fetch: i, tlsOnly: a, timeout: s } = $06484a9711eaa5fc$var$$o(e);
    return (async function(e, t, n, o, r) {
        $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t);
        const i = $06484a9711eaa5fc$var$an(e, "backchannel_authentication_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$06484a9711eaa5fc$var$St])), a = new URLSearchParams(o);
        a.set("client_id", t.client_id);
        const s = $06484a9711eaa5fc$var$zt(null == r ? void 0 : r.headers);
        return s.set("accept", "application/json"), $06484a9711eaa5fc$var$gn(e, t, n, i, a, s, r);
    })(n, o, r, t, {
        [$06484a9711eaa5fc$var$At]: i,
        [$06484a9711eaa5fc$var$St]: !a,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(s)
    }).then((e)=>(async function(e, t, n) {
            if ($06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), !$06484a9711eaa5fc$var$_t(n, Response)) throw $06484a9711eaa5fc$var$kt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
            await $06484a9711eaa5fc$var$mn(n, 200, "Backchannel Authentication Endpoint"), $06484a9711eaa5fc$var$qn(n);
            const o = await $06484a9711eaa5fc$var$oo(n);
            $06484a9711eaa5fc$var$Ft(o.auth_req_id, '"response" body "auth_req_id" property', $06484a9711eaa5fc$var$Nn, {
                body: o
            });
            let r = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
            return $06484a9711eaa5fc$var$Vt(r, !0, '"response" body "expires_in" property', $06484a9711eaa5fc$var$Nn, {
                body: o
            }), o.expires_in = r, void 0 !== o.interval && $06484a9711eaa5fc$var$Vt(o.interval, !1, '"response" body "interval" property', $06484a9711eaa5fc$var$Nn, {
                body: o
            }), o;
        })(n, o, e)).catch($06484a9711eaa5fc$var$dr);
}
async function $06484a9711eaa5fc$var$vr(e, t, n, o) {
    var r, i;
    $06484a9711eaa5fc$var$Ar(e), n = new URLSearchParams(n);
    let a = null !== (r = t.interval) && void 0 !== r ? r : 5;
    const s = null !== (i = null == o ? void 0 : o.signal) && void 0 !== i ? i : AbortSignal.timeout(1e3 * t.expires_in);
    try {
        await $06484a9711eaa5fc$var$wr(a, s);
    } catch (e) {
        $06484a9711eaa5fc$var$dr(e);
    }
    const { as: c, c: u, auth: l, fetch: d, tlsOnly: h, nonRepudiation: p, timeout: f, decrypt: m } = $06484a9711eaa5fc$var$$o(e), y = (r, i)=>$06484a9711eaa5fc$var$vr(e, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, t), {}, {
            interval: r
        }), n, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, o), {}, {
            signal: s,
            flag: i
        })), w = await (async function(e, t, n, o, r) {
        $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), $06484a9711eaa5fc$var$Ft(o, '"authReqId"');
        const i = new URLSearchParams(null == r ? void 0 : r.additionalParameters);
        return i.set("auth_req_id", o), $06484a9711eaa5fc$var$vn(e, t, n, "urn:openid:params:grant-type:ciba", i, r);
    })(c, u, l, t.auth_req_id, {
        [$06484a9711eaa5fc$var$At]: d,
        [$06484a9711eaa5fc$var$St]: !h,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: s.aborted ? s : $06484a9711eaa5fc$var$Pr(f)
    }).catch($06484a9711eaa5fc$var$dr);
    var g;
    if (503 === w.status && w.headers.has("retry-after")) return await $06484a9711eaa5fc$var$yr(w, a, s, !0), await (null === (g = w.body) || void 0 === g ? void 0 : g.cancel()), y(a);
    const v = async function(e, t, n, o) {
        return $06484a9711eaa5fc$var$Sn(e, t, n, void 0, null == o ? void 0 : o[$06484a9711eaa5fc$var$Rt], null == o ? void 0 : o.recognizedTokenTypes);
    }(c, u, w, {
        [$06484a9711eaa5fc$var$Rt]: m
    });
    let b;
    try {
        b = await v;
    } catch (e) {
        if ($06484a9711eaa5fc$var$Rr(e, o)) return y(a, $06484a9711eaa5fc$var$Ir);
        if (e instanceof $06484a9711eaa5fc$var$sn) switch(e.error){
            case "slow_down":
                a += 5;
            case "authorization_pending":
                return await $06484a9711eaa5fc$var$yr(e.response, a, s), y(a);
        }
        $06484a9711eaa5fc$var$dr(e);
    }
    return b.id_token && await (null == p ? void 0 : p(w)), $06484a9711eaa5fc$var$mr(b), b;
}
function $06484a9711eaa5fc$var$br(e) {
    $06484a9711eaa5fc$var$$o(e).tlsOnly = !1;
}
async function $06484a9711eaa5fc$var$_r(e, t, n, o, r) {
    if ($06484a9711eaa5fc$var$Ar(e), !((null == r ? void 0 : r.flag) === $06484a9711eaa5fc$var$Ir || t instanceof URL || function(e, t) {
        try {
            return Object.getPrototypeOf(e)[Symbol.toStringTag] === t;
        } catch (e) {
            return !1;
        }
    }(t, "Request"))) throw $06484a9711eaa5fc$var$ar('"currentUrl" must be an instance of URL, or Request', $06484a9711eaa5fc$var$ir);
    let i, a;
    const { as: s, c: c, auth: u, fetch: l, tlsOnly: d, jarm: h, hybrid: p, nonRepudiation: f, timeout: m, decrypt: y, implicit: w } = $06484a9711eaa5fc$var$$o(e);
    if ((null == r ? void 0 : r.flag) === $06484a9711eaa5fc$var$Ir) i = r.authResponse, a = r.redirectUri;
    else {
        if (!(t instanceof URL)) {
            const e = t;
            switch(t = new URL(t.url), e.method){
                case "GET":
                    break;
                case "POST":
                    const n = new URLSearchParams(await $06484a9711eaa5fc$var$Yn(e));
                    if (p) t.hash = n.toString();
                    else for (const [e, o] of n.entries())t.searchParams.append(e, o);
                    break;
                default:
                    throw $06484a9711eaa5fc$var$ar("unexpected Request HTTP method", $06484a9711eaa5fc$var$rr);
            }
        }
        switch(a = function(e) {
            return (e = new URL(e)).search = "", e.hash = "", e.href;
        }(t), !0){
            case !!h:
                i = await h(t, null == n ? void 0 : n.expectedState);
                break;
            case !!p:
                i = await p(t, null == n ? void 0 : n.expectedNonce, null == n ? void 0 : n.expectedState, null == n ? void 0 : n.maxAge);
                break;
            case !!w:
                throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
            default:
                try {
                    i = $06484a9711eaa5fc$var$no(s, c, t.searchParams, null == n ? void 0 : n.expectedState);
                } catch (e) {
                    $06484a9711eaa5fc$var$dr(e);
                }
        }
    }
    const g = await (async function(e, t, n, o, r, i, a) {
        if ($06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), !$06484a9711eaa5fc$var$An.has(o)) throw $06484a9711eaa5fc$var$kt('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', "ERR_INVALID_ARG_VALUE");
        $06484a9711eaa5fc$var$Ft(r, '"redirectUri"');
        const s = $06484a9711eaa5fc$var$$n(o, "code");
        if (!s) throw $06484a9711eaa5fc$var$Ut('no authorization code in "callbackParameters"', $06484a9711eaa5fc$var$Nn);
        const c = new URLSearchParams(null == a ? void 0 : a.additionalParameters);
        return c.set("redirect_uri", r), c.set("code", s), i !== $06484a9711eaa5fc$var$Pn && ($06484a9711eaa5fc$var$Ft(i, '"codeVerifier"'), c.set("code_verifier", i)), $06484a9711eaa5fc$var$vn(e, t, n, "authorization_code", c, a);
    })(s, c, u, i, a, (null == n ? void 0 : n.pkceCodeVerifier) || $06484a9711eaa5fc$var$Pn, {
        additionalParameters: o,
        [$06484a9711eaa5fc$var$At]: l,
        [$06484a9711eaa5fc$var$St]: !d,
        DPoP: null == r ? void 0 : r.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(m)
    }).catch($06484a9711eaa5fc$var$dr);
    "string" != typeof (null == n ? void 0 : n.expectedNonce) && "number" != typeof (null == n ? void 0 : n.maxAge) || (n.idTokenExpected = !0);
    const v = $06484a9711eaa5fc$var$Cn(s, c, g, {
        expectedNonce: null == n ? void 0 : n.expectedNonce,
        maxAge: null == n ? void 0 : n.maxAge,
        requireIdToken: null == n ? void 0 : n.idTokenExpected,
        [$06484a9711eaa5fc$var$Rt]: y
    });
    let b;
    try {
        b = await v;
    } catch (t) {
        if ($06484a9711eaa5fc$var$Rr(t, r)) return $06484a9711eaa5fc$var$_r(e, void 0, n, o, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, r), {}, {
            flag: $06484a9711eaa5fc$var$Ir,
            authResponse: i,
            redirectUri: a
        }));
        $06484a9711eaa5fc$var$dr(t);
    }
    return b.id_token && await (null == f ? void 0 : f(g)), $06484a9711eaa5fc$var$mr(b), b;
}
async function $06484a9711eaa5fc$var$kr(e, t, n, o) {
    $06484a9711eaa5fc$var$Ar(e), n = new URLSearchParams(n);
    const { as: r, c: i, auth: a, fetch: s, tlsOnly: c, nonRepudiation: u, timeout: l, decrypt: d } = $06484a9711eaa5fc$var$$o(e), h = await (async function(e, t, n, o, r) {
        $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), $06484a9711eaa5fc$var$Ft(o, '"refreshToken"');
        const i = new URLSearchParams(null == r ? void 0 : r.additionalParameters);
        return i.set("refresh_token", o), $06484a9711eaa5fc$var$vn(e, t, n, "refresh_token", i, r);
    })(r, i, a, t, {
        [$06484a9711eaa5fc$var$At]: s,
        [$06484a9711eaa5fc$var$St]: !c,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(l)
    }).catch($06484a9711eaa5fc$var$dr), p = async function(e, t, n, o) {
        return $06484a9711eaa5fc$var$Sn(e, t, n, void 0, null == o ? void 0 : o[$06484a9711eaa5fc$var$Rt], null == o ? void 0 : o.recognizedTokenTypes);
    }(r, i, h, {
        [$06484a9711eaa5fc$var$Rt]: d
    });
    let f;
    try {
        f = await p;
    } catch (r) {
        if ($06484a9711eaa5fc$var$Rr(r, o)) return $06484a9711eaa5fc$var$kr(e, t, n, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, o), {}, {
            flag: $06484a9711eaa5fc$var$Ir
        }));
        $06484a9711eaa5fc$var$dr(r);
    }
    return f.id_token && await (null == u ? void 0 : u(h)), $06484a9711eaa5fc$var$mr(f), f;
}
async function $06484a9711eaa5fc$var$Sr(e, t, n) {
    $06484a9711eaa5fc$var$Ar(e), t = new URLSearchParams(t);
    const { as: o, c: r, auth: i, fetch: a, tlsOnly: s, timeout: c } = $06484a9711eaa5fc$var$$o(e), u = await (async function(e, t, n, o, r) {
        return $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), $06484a9711eaa5fc$var$vn(e, t, n, "client_credentials", new URLSearchParams(o), r);
    })(o, r, i, t, {
        [$06484a9711eaa5fc$var$At]: a,
        [$06484a9711eaa5fc$var$St]: !s,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(c)
    }).catch($06484a9711eaa5fc$var$dr), l = async function(e, t, n, o) {
        return $06484a9711eaa5fc$var$Sn(e, t, n, void 0, null == o ? void 0 : o[$06484a9711eaa5fc$var$Rt], null == o ? void 0 : o.recognizedTokenTypes);
    }(o, r, u);
    let d;
    try {
        d = await l;
    } catch (o) {
        if ($06484a9711eaa5fc$var$Rr(o, n)) return $06484a9711eaa5fc$var$Sr(e, t, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, n), {}, {
            flag: $06484a9711eaa5fc$var$Ir
        }));
        $06484a9711eaa5fc$var$dr(o);
    }
    return $06484a9711eaa5fc$var$mr(d), d;
}
function $06484a9711eaa5fc$var$Er(e, t) {
    $06484a9711eaa5fc$var$Ar(e);
    const { as: n, c: o, tlsOnly: r, hybrid: i, jarm: a, implicit: s } = $06484a9711eaa5fc$var$$o(e), c = $06484a9711eaa5fc$var$an(n, "authorization_endpoint", !1, r);
    if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", o.client_id), !t.has("request_uri") && !t.has("request")) {
        if (t.has("response_type") || t.set("response_type", i ? "code id_token" : s ? "id_token" : "code"), s && !t.has("nonce")) throw $06484a9711eaa5fc$var$ar("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", $06484a9711eaa5fc$var$rr);
        a && t.set("response_mode", "jwt");
    }
    for (const [e, n] of t.entries())c.searchParams.append(e, n);
    return c;
}
async function $06484a9711eaa5fc$var$Tr(e, t, n) {
    $06484a9711eaa5fc$var$Ar(e);
    const o = $06484a9711eaa5fc$var$Er(e, t), { as: r, c: i, auth: a, fetch: s, tlsOnly: c, timeout: u } = $06484a9711eaa5fc$var$$o(e), l = await (async function(e, t, n, o, r) {
        var i;
        $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t);
        const a = $06484a9711eaa5fc$var$an(e, "pushed_authorization_request_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$06484a9711eaa5fc$var$St])), s = new URLSearchParams(o);
        s.set("client_id", t.client_id);
        const c = $06484a9711eaa5fc$var$zt(null == r ? void 0 : r.headers);
        c.set("accept", "application/json"), void 0 !== (null == r ? void 0 : r.DPoP) && ($06484a9711eaa5fc$var$yn(r.DPoP), await r.DPoP.addProof(a, c, "POST"));
        const u = await $06484a9711eaa5fc$var$gn(e, t, n, a, s, c, r);
        return null == r || null === (i = r.DPoP) || void 0 === i || i.cacheNonce(u, a), u;
    })(r, i, a, o.searchParams, {
        [$06484a9711eaa5fc$var$At]: s,
        [$06484a9711eaa5fc$var$St]: !c,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(u)
    }).catch($06484a9711eaa5fc$var$dr), d = async function(e, t, n) {
        if ($06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), !$06484a9711eaa5fc$var$_t(n, Response)) throw $06484a9711eaa5fc$var$kt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
        await $06484a9711eaa5fc$var$mn(n, 201, "Pushed Authorization Request Endpoint"), $06484a9711eaa5fc$var$qn(n);
        const o = await $06484a9711eaa5fc$var$oo(n);
        $06484a9711eaa5fc$var$Ft(o.request_uri, '"response" body "request_uri" property', $06484a9711eaa5fc$var$Nn, {
            body: o
        });
        let r = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
        return $06484a9711eaa5fc$var$Vt(r, !0, '"response" body "expires_in" property', $06484a9711eaa5fc$var$Nn, {
            body: o
        }), o.expires_in = r, o;
    }(r, i, l);
    let h;
    try {
        h = await d;
    } catch (o) {
        if ($06484a9711eaa5fc$var$Rr(o, n)) return $06484a9711eaa5fc$var$Tr(e, t, $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, n), {}, {
            flag: $06484a9711eaa5fc$var$Ir
        }));
        $06484a9711eaa5fc$var$dr(o);
    }
    return $06484a9711eaa5fc$var$Er(e, {
        request_uri: h.request_uri
    });
}
function $06484a9711eaa5fc$var$Ar(e) {
    if (!(e instanceof $06484a9711eaa5fc$var$fr)) throw $06484a9711eaa5fc$var$ar('"config" must be an instance of Configuration', $06484a9711eaa5fc$var$ir);
    if (Object.getPrototypeOf(e) !== $06484a9711eaa5fc$var$fr.prototype) throw $06484a9711eaa5fc$var$ar("subclassing Configuration is not allowed", $06484a9711eaa5fc$var$rr);
}
function $06484a9711eaa5fc$var$Pr(e) {
    return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function $06484a9711eaa5fc$var$Rr(e, t) {
    return !(null == t || !t.DPoP || t.flag === $06484a9711eaa5fc$var$Ir) && function(e) {
        if (e instanceof $06484a9711eaa5fc$var$un) {
            const { 0: t, length: n } = e.cause;
            return 1 === n && "dpop" === t.scheme && "use_dpop_nonce" === t.parameters.error;
        }
        return e instanceof $06484a9711eaa5fc$var$sn && "use_dpop_nonce" === e.error;
    }(e);
}
Object.freeze($06484a9711eaa5fc$var$fr.prototype);
const $06484a9711eaa5fc$var$Ir = Symbol();
async function $06484a9711eaa5fc$var$xr(e, t, n, o) {
    $06484a9711eaa5fc$var$Ar(e);
    const { as: r, c: i, auth: a, fetch: s, tlsOnly: c, timeout: u, decrypt: l } = $06484a9711eaa5fc$var$$o(e), d = await (async function(e, t, n, o, r, i) {
        return $06484a9711eaa5fc$var$Qt(e), $06484a9711eaa5fc$var$$t(t), $06484a9711eaa5fc$var$Ft(o, '"grantType"'), $06484a9711eaa5fc$var$vn(e, t, n, o, new URLSearchParams(r), i);
    })(r, i, a, t, new URLSearchParams(n), {
        [$06484a9711eaa5fc$var$At]: s,
        [$06484a9711eaa5fc$var$St]: !c,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($06484a9711eaa5fc$var$Yo),
        signal: $06484a9711eaa5fc$var$Pr(u)
    }).then((e)=>{
        let n;
        return "urn:ietf:params:oauth:grant-type:token-exchange" === t && (n = {
            n_a: ()=>{}
        }), async function(e, t, n, o) {
            return $06484a9711eaa5fc$var$Sn(e, t, n, void 0, null == o ? void 0 : o[$06484a9711eaa5fc$var$Rt], null == o ? void 0 : o.recognizedTokenTypes);
        }(r, i, e, {
            [$06484a9711eaa5fc$var$Rt]: l,
            recognizedTokenTypes: n
        });
    }).catch($06484a9711eaa5fc$var$dr);
    return $06484a9711eaa5fc$var$mr(d), d;
}
async function $06484a9711eaa5fc$var$Or(e, t, n) {
    if (t instanceof Uint8Array) {
        if (!e.startsWith("HS")) throw new TypeError(function(e) {
            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
            return $06484a9711eaa5fc$var$Ro("Key must be ", e, ...n);
        }(t, "CryptoKey", "KeyObject", "JSON Web Key"));
        return crypto.subtle.importKey("raw", t, {
            hash: "SHA-".concat(e.slice(-3)),
            name: "HMAC"
        }, !1, [
            n
        ]);
    }
    return $06484a9711eaa5fc$var$Po(t, e, n), t;
}
async function $06484a9711eaa5fc$var$Cr(e, t, n, o) {
    const r = await $06484a9711eaa5fc$var$Or(e, t, "verify");
    !function(e, t) {
        if (e.startsWith("RS") || e.startsWith("PS")) {
            const { modulusLength: n } = t.algorithm;
            if ("number" != typeof n || n < 2048) throw new TypeError("".concat(e, " requires key modulusLength to be 2048 bits or larger"));
        }
    }(e, r);
    const i = function(e, t) {
        const n = "SHA-".concat(e.slice(-3));
        switch(e){
            case "HS256":
            case "HS384":
            case "HS512":
                return {
                    hash: n,
                    name: "HMAC"
                };
            case "PS256":
            case "PS384":
            case "PS512":
                return {
                    hash: n,
                    name: "RSA-PSS",
                    saltLength: parseInt(e.slice(-3), 10) >> 3
                };
            case "RS256":
            case "RS384":
            case "RS512":
                return {
                    hash: n,
                    name: "RSASSA-PKCS1-v1_5"
                };
            case "ES256":
            case "ES384":
            case "ES512":
                return {
                    hash: n,
                    name: "ECDSA",
                    namedCurve: t.namedCurve
                };
            case "Ed25519":
            case "EdDSA":
                return {
                    name: "Ed25519"
                };
            case "ML-DSA-44":
            case "ML-DSA-65":
            case "ML-DSA-87":
                return {
                    name: e
                };
            default:
                throw new $06484a9711eaa5fc$var$yo("alg ".concat(e, " is not supported either by JOSE or your javascript runtime"));
        }
    }(e, r.algorithm);
    try {
        return await crypto.subtle.verify(i, r, n, o);
    } catch (e) {
        return !1;
    }
}
async function $06484a9711eaa5fc$var$jr(e, t, n) {
    if (!$06484a9711eaa5fc$var$jo(e)) throw new $06484a9711eaa5fc$var$wo("Flattened JWS must be an object");
    if (void 0 === e.protected && void 0 === e.header) throw new $06484a9711eaa5fc$var$wo('Flattened JWS must have either of the "protected" or "header" members');
    if (void 0 !== e.protected && "string" != typeof e.protected) throw new $06484a9711eaa5fc$var$wo("JWS Protected Header incorrect type");
    if (void 0 === e.payload) throw new $06484a9711eaa5fc$var$wo("JWS Payload missing");
    if ("string" != typeof e.signature) throw new $06484a9711eaa5fc$var$wo("JWS Signature missing or incorrect type");
    if (void 0 !== e.header && !$06484a9711eaa5fc$var$jo(e.header)) throw new $06484a9711eaa5fc$var$wo("JWS Unprotected Header incorrect type");
    let o = {};
    if (e.protected) try {
        const t = $06484a9711eaa5fc$var$lo(e.protected);
        o = JSON.parse($06484a9711eaa5fc$var$so.decode(t));
    } catch (e) {
        throw new $06484a9711eaa5fc$var$wo("JWS Protected Header is invalid");
    }
    if (!function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        const o = t.filter(Boolean);
        if (0 === o.length || 1 === o.length) return !0;
        let r;
        for (const e of o){
            const t = Object.keys(e);
            if (r && 0 !== r.size) for (const e of t){
                if (r.has(e)) return !1;
                r.add(e);
            }
            else r = new Set(t);
        }
        return !0;
    }(o, e.header)) throw new $06484a9711eaa5fc$var$wo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const r = $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, o), e.header), i = function(e, t, n, o, r) {
        if (void 0 !== r.crit && void 0 === (null == o ? void 0 : o.crit)) throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
        if (!o || void 0 === o.crit) return new Set;
        if (!Array.isArray(o.crit) || 0 === o.crit.length || o.crit.some((e)=>"string" != typeof e || 0 === e.length)) throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
        let i;
        i = void 0 !== n ? new Map([
            ...Object.entries(n),
            ...t.entries()
        ]) : t;
        for (const t of o.crit){
            if (!i.has(t)) throw new $06484a9711eaa5fc$var$yo('Extension Header Parameter "'.concat(t, '" is not recognized'));
            if (void 0 === r[t]) throw new e('Extension Header Parameter "'.concat(t, '" is missing'));
            if (i.get(t) && void 0 === o[t]) throw new e('Extension Header Parameter "'.concat(t, '" MUST be integrity protected'));
        }
        return new Set(o.crit);
    }($06484a9711eaa5fc$var$wo, new Map([
        [
            "b64",
            !0
        ]
    ]), null == n ? void 0 : n.crit, o, r);
    let a = !0;
    if (i.has("b64") && (a = o.b64, "boolean" != typeof a)) throw new $06484a9711eaa5fc$var$wo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: s } = r;
    if ("string" != typeof s || !s) throw new $06484a9711eaa5fc$var$wo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const c = n && function(e, t) {
        if (void 0 !== t && (!Array.isArray(t) || t.some((e)=>"string" != typeof e))) throw new TypeError('"'.concat(e, '" option must be an array of strings'));
        if (t) return new Set(t);
    }("algorithms", n.algorithms);
    if (c && !c.has(s)) throw new $06484a9711eaa5fc$var$mo('"alg" (Algorithm) Header Parameter value not allowed');
    if (a) {
        if ("string" != typeof e.payload) throw new $06484a9711eaa5fc$var$wo("JWS Payload must be a string");
    } else if ("string" != typeof e.payload && !(e.payload instanceof Uint8Array)) throw new $06484a9711eaa5fc$var$wo("JWS Payload must be a string or an Uint8Array instance");
    let u = !1;
    "function" == typeof t && (t = await t(o, e), u = !0), $06484a9711eaa5fc$var$qo(s, t, "verify");
    const l = function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        const o = t.reduce((e, t)=>{
            let { length: n } = t;
            return e + n;
        }, 0), r = new Uint8Array(o);
        let i = 0;
        for (const e of t)r.set(e, i), i += e.length;
        return r;
    }(void 0 !== e.protected ? $06484a9711eaa5fc$var$co(e.protected) : new Uint8Array, $06484a9711eaa5fc$var$co("."), "string" == typeof e.payload ? a ? $06484a9711eaa5fc$var$co(e.payload) : $06484a9711eaa5fc$var$ao.encode(e.payload) : e.payload);
    let d;
    try {
        d = $06484a9711eaa5fc$var$lo(e.signature);
    } catch (e) {
        throw new $06484a9711eaa5fc$var$wo("Failed to base64url decode the signature");
    }
    const h = await $06484a9711eaa5fc$var$Fo(t, s);
    if (!await $06484a9711eaa5fc$var$Cr(s, h, d, l)) throw new $06484a9711eaa5fc$var$So;
    let p;
    if (a) try {
        p = $06484a9711eaa5fc$var$lo(e.payload);
    } catch (e) {
        throw new $06484a9711eaa5fc$var$wo("Failed to base64url decode the payload");
    }
    else p = "string" == typeof e.payload ? $06484a9711eaa5fc$var$ao.encode(e.payload) : e.payload;
    const f = {
        payload: p
    };
    return void 0 !== e.protected && (f.protectedHeader = o), void 0 !== e.header && (f.unprotectedHeader = e.header), u ? $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, f), {}, {
        key: h
    }) : f;
}
const $06484a9711eaa5fc$var$Dr = (e)=>Math.floor(e.getTime() / 1e3), $06484a9711eaa5fc$var$Kr = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function $06484a9711eaa5fc$var$Lr(e) {
    const t = $06484a9711eaa5fc$var$Kr.exec(e);
    if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
    const n = parseFloat(t[2]);
    let o;
    switch(t[3].toLowerCase()){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            o = Math.round(n);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            o = Math.round(60 * n);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            o = Math.round(3600 * n);
            break;
        case "day":
        case "days":
        case "d":
            o = Math.round(86400 * n);
            break;
        case "week":
        case "weeks":
        case "w":
            o = Math.round(604800 * n);
            break;
        default:
            o = Math.round(31557600 * n);
    }
    return "-" === t[1] || "ago" === t[4] ? -o : o;
}
const $06484a9711eaa5fc$var$Ur = (e)=>e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase()), $06484a9711eaa5fc$var$Nr = (e, t)=>"string" == typeof e ? t.includes(e) : !!Array.isArray(e) && t.some(Set.prototype.has.bind(new Set(e)));
async function $06484a9711eaa5fc$var$Wr(e, t, n) {
    var o;
    const r = await async function(e, t, n) {
        if (e instanceof Uint8Array && (e = $06484a9711eaa5fc$var$so.decode(e)), "string" != typeof e) throw new $06484a9711eaa5fc$var$wo("Compact JWS must be a string or Uint8Array");
        const { 0: o, 1: r, 2: i, length: a } = e.split(".");
        if (3 !== a) throw new $06484a9711eaa5fc$var$wo("Invalid Compact JWS");
        const s = await $06484a9711eaa5fc$var$jr({
            payload: r,
            protected: o,
            signature: i
        }, t, n), c = {
            payload: s.payload,
            protectedHeader: s.protectedHeader
        };
        return "function" == typeof t ? $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, c), {}, {
            key: s.key
        }) : c;
    }(e, t, n);
    if (null !== (o = r.protectedHeader.crit) && void 0 !== o && o.includes("b64") && !1 === r.protectedHeader.b64) throw new $06484a9711eaa5fc$var$go("JWTs MUST NOT use unencoded payload");
    const i = function(e, t) {
        let n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        try {
            n = JSON.parse($06484a9711eaa5fc$var$so.decode(t));
        } catch (e) {}
        if (!$06484a9711eaa5fc$var$jo(n)) throw new $06484a9711eaa5fc$var$go("JWT Claims Set must be a top-level JSON object");
        const { typ: r } = o;
        if (r && ("string" != typeof e.typ || $06484a9711eaa5fc$var$Ur(e.typ) !== $06484a9711eaa5fc$var$Ur(r))) throw new $06484a9711eaa5fc$var$po('unexpected "typ" JWT header value', n, "typ", "check_failed");
        const { requiredClaims: i = [], issuer: a, subject: s, audience: c, maxTokenAge: u } = o, l = [
            ...i
        ];
        void 0 !== u && l.push("iat"), void 0 !== c && l.push("aud"), void 0 !== s && l.push("sub"), void 0 !== a && l.push("iss");
        for (const e of new Set(l.reverse()))if (!(e in n)) throw new $06484a9711eaa5fc$var$po('missing required "'.concat(e, '" claim'), n, e, "missing");
        if (a && !(Array.isArray(a) ? a : [
            a
        ]).includes(n.iss)) throw new $06484a9711eaa5fc$var$po('unexpected "iss" claim value', n, "iss", "check_failed");
        if (s && n.sub !== s) throw new $06484a9711eaa5fc$var$po('unexpected "sub" claim value', n, "sub", "check_failed");
        if (c && !$06484a9711eaa5fc$var$Nr(n.aud, "string" == typeof c ? [
            c
        ] : c)) throw new $06484a9711eaa5fc$var$po('unexpected "aud" claim value', n, "aud", "check_failed");
        let d;
        switch(typeof o.clockTolerance){
            case "string":
                d = $06484a9711eaa5fc$var$Lr(o.clockTolerance);
                break;
            case "number":
                d = o.clockTolerance;
                break;
            case "undefined":
                d = 0;
                break;
            default:
                throw new TypeError("Invalid clockTolerance option type");
        }
        const { currentDate: h } = o, p = $06484a9711eaa5fc$var$Dr(h || new Date);
        if ((void 0 !== n.iat || u) && "number" != typeof n.iat) throw new $06484a9711eaa5fc$var$po('"iat" claim must be a number', n, "iat", "invalid");
        if (void 0 !== n.nbf) {
            if ("number" != typeof n.nbf) throw new $06484a9711eaa5fc$var$po('"nbf" claim must be a number', n, "nbf", "invalid");
            if (n.nbf > p + d) throw new $06484a9711eaa5fc$var$po('"nbf" claim timestamp check failed', n, "nbf", "check_failed");
        }
        if (void 0 !== n.exp) {
            if ("number" != typeof n.exp) throw new $06484a9711eaa5fc$var$po('"exp" claim must be a number', n, "exp", "invalid");
            if (n.exp <= p - d) throw new $06484a9711eaa5fc$var$fo('"exp" claim timestamp check failed', n, "exp", "check_failed");
        }
        if (u) {
            const e = p - n.iat;
            if (e - d > ("number" == typeof u ? u : $06484a9711eaa5fc$var$Lr(u))) throw new $06484a9711eaa5fc$var$fo('"iat" claim timestamp check failed (too far in the past)', n, "iat", "check_failed");
            if (e < 0 - d) throw new $06484a9711eaa5fc$var$po('"iat" claim timestamp check failed (it should be in the past)', n, "iat", "check_failed");
        }
        return n;
    }(r.protectedHeader, r.payload, n), a = {
        payload: i,
        protectedHeader: r.protectedHeader
    };
    return "function" == typeof t ? $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, a), {}, {
        key: r.key
    }) : a;
}
function $06484a9711eaa5fc$var$zr(e) {
    return $06484a9711eaa5fc$var$jo(e);
}
var $06484a9711eaa5fc$var$Hr, $06484a9711eaa5fc$var$Mr, $06484a9711eaa5fc$var$Jr = new WeakMap, $06484a9711eaa5fc$var$Vr = new WeakMap;
class $06484a9711eaa5fc$var$Fr {
    jwks() {
        return $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Jr, this);
    }
    async getKey(e, t) {
        const { alg: n, kid: o } = $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e), null == t ? void 0 : t.header), r = function(e) {
            switch("string" == typeof e && e.slice(0, 2)){
                case "RS":
                case "PS":
                    return "RSA";
                case "ES":
                    return "EC";
                case "Ed":
                    return "OKP";
                case "ML":
                    return "AKP";
                default:
                    throw new $06484a9711eaa5fc$var$yo('Unsupported "alg" value for a JSON Web Key Set');
            }
        }(n), i = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Jr, this).keys.filter((e)=>{
            let t = r === e.kty;
            if (t && "string" == typeof o && (t = o === e.kid), !t || "string" != typeof e.alg && "AKP" !== r || (t = n === e.alg), t && "string" == typeof e.use && (t = "sig" === e.use), t && Array.isArray(e.key_ops) && (t = e.key_ops.includes("verify")), t) switch(n){
                case "ES256":
                    t = "P-256" === e.crv;
                    break;
                case "ES384":
                    t = "P-384" === e.crv;
                    break;
                case "ES512":
                    t = "P-521" === e.crv;
                    break;
                case "Ed25519":
                case "EdDSA":
                    t = "Ed25519" === e.crv;
            }
            return t;
        }), { 0: a, length: s } = i;
        if (0 === s) throw new $06484a9711eaa5fc$var$bo;
        if (1 !== s) {
            const e = new $06484a9711eaa5fc$var$_o, t = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Vr, this);
            throw e[Symbol.asyncIterator] = $06484a9711eaa5fc$var$yt(function*() {
                for (const e of i)try {
                    yield yield $06484a9711eaa5fc$var$st($06484a9711eaa5fc$var$Gr(t, e, n));
                } catch (e) {}
            }), e;
        }
        return $06484a9711eaa5fc$var$Gr($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Vr, this), a, n);
    }
    constructor(e){
        if ($06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$Jr, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$Vr, new WeakMap), !function(e) {
            return e && "object" == typeof e && Array.isArray(e.keys) && e.keys.every($06484a9711eaa5fc$var$zr);
        }(e)) throw new $06484a9711eaa5fc$var$vo("JSON Web Key Set malformed");
        $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$Jr, this, structuredClone(e));
    }
}
async function $06484a9711eaa5fc$var$Gr(e, t, n) {
    const o = e.get(t) || e.set(t, {}).get(t);
    if (void 0 === o[n]) {
        const e = await async function(e, t, n) {
            var o;
            if (!$06484a9711eaa5fc$var$jo(e)) throw new TypeError("JWK must be an object");
            let r;
            switch(null != t || (t = e.alg), null != r || (r = null !== (o = null == n ? void 0 : n.extractable) && void 0 !== o ? o : e.ext), e.kty){
                case "oct":
                    if ("string" != typeof e.k || !e.k) throw new TypeError('missing "k" (Key Value) Parameter value');
                    return $06484a9711eaa5fc$var$lo(e.k);
                case "RSA":
                    if ("oth" in e && void 0 !== e.oth) throw new $06484a9711eaa5fc$var$yo('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
                    return $06484a9711eaa5fc$var$Ho($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e), {}, {
                        alg: t,
                        ext: r
                    }));
                case "AKP":
                    if ("string" != typeof e.alg || !e.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
                    if (void 0 !== t && t !== e.alg) throw new TypeError("JWK alg and alg option value mismatch");
                    return $06484a9711eaa5fc$var$Ho($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e), {}, {
                        ext: r
                    }));
                case "EC":
                case "OKP":
                    return $06484a9711eaa5fc$var$Ho($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e), {}, {
                        alg: t,
                        ext: r
                    }));
                default:
                    throw new $06484a9711eaa5fc$var$yo('Unsupported "kty" (Key Type) Parameter value');
            }
        }($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, t), {}, {
            ext: !0
        }), n);
        if (e instanceof Uint8Array || "public" !== e.type) throw new $06484a9711eaa5fc$var$vo("JSON Web Key Set members must be public keys");
        o[n] = e;
    }
    return o[n];
}
function $06484a9711eaa5fc$var$Zr(e) {
    const t = new $06484a9711eaa5fc$var$Fr(e), n = async (e, n)=>t.getKey(e, n);
    return Object.defineProperties(n, {
        jwks: {
            value: ()=>structuredClone(t.jwks()),
            enumerable: !1,
            configurable: !1,
            writable: !1
        }
    }), n;
}
let $06484a9711eaa5fc$var$qr;
if ("undefined" == typeof navigator || null === ($06484a9711eaa5fc$var$Hr = navigator.userAgent) || void 0 === $06484a9711eaa5fc$var$Hr || null === ($06484a9711eaa5fc$var$Mr = $06484a9711eaa5fc$var$Hr.startsWith) || void 0 === $06484a9711eaa5fc$var$Mr || !$06484a9711eaa5fc$var$Mr.call($06484a9711eaa5fc$var$Hr, "Mozilla/5.0 ")) {
    const e = "v6.1.3";
    $06484a9711eaa5fc$var$qr = "".concat("jose", "/").concat(e);
}
const $06484a9711eaa5fc$var$Br = Symbol();
const $06484a9711eaa5fc$var$Xr = Symbol();
var $06484a9711eaa5fc$var$Yr = new WeakMap, $06484a9711eaa5fc$var$Qr = new WeakMap, $06484a9711eaa5fc$var$$r = new WeakMap, $06484a9711eaa5fc$var$ei = new WeakMap, $06484a9711eaa5fc$var$ti = new WeakMap, $06484a9711eaa5fc$var$ni = new WeakMap, $06484a9711eaa5fc$var$oi = new WeakMap, $06484a9711eaa5fc$var$ri = new WeakMap, $06484a9711eaa5fc$var$ii = new WeakMap, $06484a9711eaa5fc$var$ai = new WeakMap;
class $06484a9711eaa5fc$var$si {
    pendingFetch() {
        return !!$06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ni, this);
    }
    coolingDown() {
        return "number" == typeof $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ti, this) && Date.now() < $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ti, this) + $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$$r, this);
    }
    fresh() {
        return "number" == typeof $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ti, this) && Date.now() < $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ti, this) + $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ei, this);
    }
    jwks() {
        var e;
        return null === (e = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ii, this)) || void 0 === e ? void 0 : e.jwks();
    }
    async getKey(e, t) {
        $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ii, this) && this.fresh() || await this.reload();
        try {
            return await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ii, this).call(this, e, t);
        } catch (n) {
            if (n instanceof $06484a9711eaa5fc$var$bo && !1 === this.coolingDown()) return await this.reload(), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ii, this).call(this, e, t);
            throw n;
        }
    }
    async reload() {
        $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ni, this) && ("undefined" != typeof WebSocketPair || "undefined" != typeof navigator && "Cloudflare-Workers" === navigator.userAgent || "undefined" != typeof EdgeRuntime && "vercel" === EdgeRuntime) && $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ni, this, void 0), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ni, this) || $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ni, this, (async function(e, t, n) {
            let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : fetch;
            const r = await o(e, {
                method: "GET",
                signal: n,
                redirect: "manual",
                headers: t
            }).catch((e)=>{
                if ("TimeoutError" === e.name) throw new $06484a9711eaa5fc$var$ko;
                throw e;
            });
            if (200 !== r.status) throw new $06484a9711eaa5fc$var$ho("Expected 200 OK from the JSON Web Key Set HTTP response");
            try {
                return await r.json();
            } catch (e) {
                throw new $06484a9711eaa5fc$var$ho("Failed to parse the JSON Web Key Set HTTP response as JSON");
            }
        })($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Yr, this).href, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this), AbortSignal.timeout($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$Qr, this)), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ri, this)).then((e)=>{
            $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ii, this, $06484a9711eaa5fc$var$Zr(e)), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ai, this) && ($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ai, this).uat = Date.now(), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ai, this).jwks = e), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ti, this, Date.now()), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ni, this, void 0);
        }).catch((e)=>{
            throw $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ni, this, void 0), e;
        })), await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ni, this);
    }
    constructor(e, t){
        if ($06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$Yr, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$Qr, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$$r, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ei, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ti, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ni, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$oi, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ri, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ii, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$ai, void 0), !(e instanceof URL)) throw new TypeError("url must be an instance of URL");
        var n, o;
        $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$Yr, this, new URL(e.href)), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$Qr, this, "number" == typeof (null == t ? void 0 : t.timeoutDuration) ? null == t ? void 0 : t.timeoutDuration : 5e3), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$$r, this, "number" == typeof (null == t ? void 0 : t.cooldownDuration) ? null == t ? void 0 : t.cooldownDuration : 3e4), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ei, this, "number" == typeof (null == t ? void 0 : t.cacheMaxAge) ? null == t ? void 0 : t.cacheMaxAge : 6e5), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$oi, this, new Headers(null == t ? void 0 : t.headers)), $06484a9711eaa5fc$var$qr && !$06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this).has("User-Agent") && $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this).set("User-Agent", $06484a9711eaa5fc$var$qr), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this).has("accept") || ($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this).set("accept", "application/json"), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$oi, this).append("accept", "application/jwk-set+json")), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ri, this, null == t ? void 0 : t[$06484a9711eaa5fc$var$Br]), void 0 !== (null == t ? void 0 : t[$06484a9711eaa5fc$var$Xr]) && ($06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ai, this, null == t ? void 0 : t[$06484a9711eaa5fc$var$Xr]), n = null == t ? void 0 : t[$06484a9711eaa5fc$var$Xr], o = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ei, this), "object" == typeof n && null !== n && "uat" in n && "number" == typeof n.uat && !(Date.now() - n.uat >= o) && "jwks" in n && $06484a9711eaa5fc$var$jo(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, $06484a9711eaa5fc$var$jo) && ($06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ti, this, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ai, this).uat), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$ii, this, $06484a9711eaa5fc$var$Zr($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$ai, this).jwks))));
    }
}
const $06484a9711eaa5fc$var$ci = [
    "mfaToken"
], $06484a9711eaa5fc$var$ui = [
    "mfaToken"
];
var $06484a9711eaa5fc$var$li, $06484a9711eaa5fc$var$di, $06484a9711eaa5fc$var$hi, $06484a9711eaa5fc$var$pi, $06484a9711eaa5fc$var$fi, $06484a9711eaa5fc$var$mi, $06484a9711eaa5fc$var$yi, $06484a9711eaa5fc$var$wi, $06484a9711eaa5fc$var$gi = class extends Error {
    constructor(e, t){
        super(t), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.name = "NotSupportedError", this.code = e;
    }
}, $06484a9711eaa5fc$var$vi = class extends Error {
    constructor(e, t, n){
        super(t), $06484a9711eaa5fc$var$ht(this, "cause", void 0), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $06484a9711eaa5fc$var$bi = class extends $06484a9711eaa5fc$var$vi {
    constructor(e, t){
        super("token_by_code_error", e, t), this.name = "TokenByCodeError";
    }
}, $06484a9711eaa5fc$var$_i = class extends $06484a9711eaa5fc$var$vi {
    constructor(e, t){
        super("token_by_client_credentials_error", e, t), this.name = "TokenByClientCredentialsError";
    }
}, $06484a9711eaa5fc$var$ki = class extends $06484a9711eaa5fc$var$vi {
    constructor(e, t){
        super("token_by_refresh_token_error", e, t), this.name = "TokenByRefreshTokenError";
    }
}, $06484a9711eaa5fc$var$Si = class extends $06484a9711eaa5fc$var$vi {
    constructor(e, t){
        super("token_for_connection_error", e, t), this.name = "TokenForConnectionErrorCode";
    }
}, $06484a9711eaa5fc$var$Ei = class extends $06484a9711eaa5fc$var$vi {
    constructor(e, t){
        super("token_exchange_error", e, t), this.name = "TokenExchangeError";
    }
}, $06484a9711eaa5fc$var$Ti = class extends Error {
    constructor(e){
        super(e), $06484a9711eaa5fc$var$ht(this, "code", "verify_logout_token_error"), this.name = "VerifyLogoutTokenError";
    }
}, $06484a9711eaa5fc$var$Ai = class extends $06484a9711eaa5fc$var$vi {
    constructor(e){
        super("backchannel_authentication_error", "There was an error when trying to use Client-Initiated Backchannel Authentication.", e), $06484a9711eaa5fc$var$ht(this, "code", "backchannel_authentication_error"), this.name = "BackchannelAuthenticationError";
    }
}, $06484a9711eaa5fc$var$Pi = class extends $06484a9711eaa5fc$var$vi {
    constructor(e){
        super("build_authorization_url_error", "There was an error when trying to build the authorization URL.", e), this.name = "BuildAuthorizationUrlError";
    }
}, $06484a9711eaa5fc$var$Ri = class extends $06484a9711eaa5fc$var$vi {
    constructor(e){
        super("build_link_user_url_error", "There was an error when trying to build the Link User URL.", e), this.name = "BuildLinkUserUrlError";
    }
}, $06484a9711eaa5fc$var$Ii = class extends $06484a9711eaa5fc$var$vi {
    constructor(e){
        super("build_unlink_user_url_error", "There was an error when trying to build the Unlink User URL.", e), this.name = "BuildUnlinkUserUrlError";
    }
}, $06484a9711eaa5fc$var$xi = class extends Error {
    constructor(){
        super("The client secret or client assertion signing key must be provided."), $06484a9711eaa5fc$var$ht(this, "code", "missing_client_auth_error"), this.name = "MissingClientAuthError";
    }
};
function $06484a9711eaa5fc$var$Oi(e) {
    return Object.entries(e).filter((e)=>{
        let [, t] = e;
        return void 0 !== t;
    }).reduce((e, t)=>$06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e), {}, {
            [t[0]]: t[1]
        }), {});
}
var $06484a9711eaa5fc$var$Ci = class extends Error {
    constructor(e, t, n){
        super(t), $06484a9711eaa5fc$var$ht(this, "cause", void 0), $06484a9711eaa5fc$var$ht(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $06484a9711eaa5fc$var$ji = class extends $06484a9711eaa5fc$var$Ci {
    constructor(e, t){
        super("mfa_list_authenticators_error", e, t), this.name = "MfaListAuthenticatorsError";
    }
}, $06484a9711eaa5fc$var$Di = class extends $06484a9711eaa5fc$var$Ci {
    constructor(e, t){
        super("mfa_enrollment_error", e, t), this.name = "MfaEnrollmentError";
    }
}, $06484a9711eaa5fc$var$Ki = class extends $06484a9711eaa5fc$var$Ci {
    constructor(e, t){
        super("mfa_delete_authenticator_error", e, t), this.name = "MfaDeleteAuthenticatorError";
    }
}, $06484a9711eaa5fc$var$Li = class extends $06484a9711eaa5fc$var$Ci {
    constructor(e, t){
        super("mfa_challenge_error", e, t), this.name = "MfaChallengeError";
    }
};
function $06484a9711eaa5fc$var$Ui(e) {
    return {
        id: e.id,
        authenticatorType: e.authenticator_type,
        active: e.active,
        name: e.name,
        oobChannels: e.oob_channels,
        type: e.type
    };
}
var $06484a9711eaa5fc$var$Ni = ($06484a9711eaa5fc$var$li = new WeakMap, $06484a9711eaa5fc$var$di = new WeakMap, $06484a9711eaa5fc$var$hi = new WeakMap, class {
    async listAuthenticators(e) {
        const t = "".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$li, this), "/mfa/authenticators"), { mfaToken: n } = e, o = await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$hi, this).call(this, t, {
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!o.ok) {
            const e = await o.json();
            throw new $06484a9711eaa5fc$var$ji(e.error_description || "Failed to list authenticators", e);
        }
        return (await o.json()).map($06484a9711eaa5fc$var$Ui);
    }
    async enrollAuthenticator(e) {
        const t = "".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$li, this), "/mfa/associate"), { mfaToken: n } = e, o = $06484a9711eaa5fc$var$mt(e, $06484a9711eaa5fc$var$ci), r = {
            authenticator_types: o.authenticatorTypes
        };
        "oobChannels" in o && (r.oob_channels = o.oobChannels), "phoneNumber" in o && o.phoneNumber && (r.phone_number = o.phoneNumber), "email" in o && o.email && (r.email = o.email);
        const i = await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$hi, this).call(this, t, {
            method: "POST",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
        });
        if (!i.ok) {
            const e = await i.json();
            throw new $06484a9711eaa5fc$var$Di(e.error_description || "Failed to enroll authenticator", e);
        }
        return function(e) {
            if ("otp" === e.authenticator_type) return {
                authenticatorType: "otp",
                secret: e.secret,
                barcodeUri: e.barcode_uri,
                recoveryCodes: e.recovery_codes,
                id: e.id
            };
            if ("oob" === e.authenticator_type) return {
                authenticatorType: "oob",
                oobChannel: e.oob_channel,
                oobCode: e.oob_code,
                bindingMethod: e.binding_method,
                id: e.id
            };
            throw new Error("Unexpected authenticator type: ".concat(e.authenticator_type));
        }(await i.json());
    }
    async deleteAuthenticator(e) {
        const { authenticatorId: t, mfaToken: n } = e, o = "".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$li, this), "/mfa/authenticators/").concat(encodeURIComponent(t)), r = await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$hi, this).call(this, o, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!r.ok) {
            const e = await r.json();
            throw new $06484a9711eaa5fc$var$Ki(e.error_description || "Failed to delete authenticator", e);
        }
    }
    async challengeAuthenticator(e) {
        const t = "".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$li, this), "/mfa/challenge"), { mfaToken: n } = e, o = $06484a9711eaa5fc$var$mt(e, $06484a9711eaa5fc$var$ui), r = {
            mfa_token: n,
            client_id: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$di, this),
            challenge_type: o.challengeType
        };
        o.authenticatorId && (r.authenticator_id = o.authenticatorId);
        const i = await $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$hi, this).call(this, t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
        });
        if (!i.ok) {
            const e = await i.json();
            throw new $06484a9711eaa5fc$var$Li(e.error_description || "Failed to challenge authenticator", e);
        }
        return function(e) {
            const t = {
                challengeType: e.challenge_type
            };
            return void 0 !== e.oob_code && (t.oobCode = e.oob_code), void 0 !== e.binding_method && (t.bindingMethod = e.binding_method), t;
        }(await i.json());
    }
    constructor(e){
        var t;
        $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$li, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$di, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$hi, void 0), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$li, this, "https://".concat(e.domain)), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$di, this, e.clientId), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$hi, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        });
    }
}), $06484a9711eaa5fc$var$Wi = class e {
    static fromTokenEndpointResponse(t) {
        const n = t.id_token ? t.claims() : void 0, o = new e(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, n, t.authorization_details);
        return o.tokenType = t.token_type, o.issuedTokenType = t.issued_token_type, o;
    }
    constructor(e, t, n, o, r, i, a){
        $06484a9711eaa5fc$var$ht(this, "accessToken", void 0), $06484a9711eaa5fc$var$ht(this, "idToken", void 0), $06484a9711eaa5fc$var$ht(this, "refreshToken", void 0), $06484a9711eaa5fc$var$ht(this, "expiresAt", void 0), $06484a9711eaa5fc$var$ht(this, "scope", void 0), $06484a9711eaa5fc$var$ht(this, "claims", void 0), $06484a9711eaa5fc$var$ht(this, "authorizationDetails", void 0), $06484a9711eaa5fc$var$ht(this, "tokenType", void 0), $06484a9711eaa5fc$var$ht(this, "issuedTokenType", void 0), this.accessToken = e, this.idToken = n, this.refreshToken = o, this.expiresAt = t, this.scope = r, this.claims = i, this.authorizationDetails = a;
    }
}, $06484a9711eaa5fc$var$zi = "openid profile email offline_access", $06484a9711eaa5fc$var$Hi = Object.freeze(new Set([
    "grant_type",
    "client_id",
    "client_secret",
    "client_assertion",
    "client_assertion_type",
    "subject_token",
    "subject_token_type",
    "requested_token_type",
    "actor_token",
    "actor_token_type",
    "audience",
    "aud",
    "resource",
    "resources",
    "resource_indicator",
    "scope",
    "connection",
    "login_hint",
    "organization",
    "assertion"
]));
function $06484a9711eaa5fc$var$Mi(e) {
    if (null == e) throw new $06484a9711eaa5fc$var$Ei("subject_token is required");
    if ("string" != typeof e) throw new $06484a9711eaa5fc$var$Ei("subject_token must be a string");
    if (0 === e.trim().length) throw new $06484a9711eaa5fc$var$Ei("subject_token cannot be blank or whitespace");
    if (e !== e.trim()) throw new $06484a9711eaa5fc$var$Ei("subject_token must not include leading or trailing whitespace");
    if (/^bearer\s+/i.test(e)) throw new $06484a9711eaa5fc$var$Ei("subject_token must not include the 'Bearer ' prefix");
}
function $06484a9711eaa5fc$var$Ji(e, t) {
    if (t) {
        for (const [n, o] of Object.entries(t))if (!$06484a9711eaa5fc$var$Hi.has(n)) {
            if (Array.isArray(o)) {
                if (o.length > 20) throw new $06484a9711eaa5fc$var$Ei("Parameter '".concat(n, "' exceeds maximum array size of ").concat(20));
                o.forEach((t)=>{
                    e.append(n, t);
                });
            } else e.append(n, o);
        }
    }
}
var $06484a9711eaa5fc$var$Vi = ($06484a9711eaa5fc$var$pi = new WeakMap, $06484a9711eaa5fc$var$fi = new WeakMap, $06484a9711eaa5fc$var$mi = new WeakMap, $06484a9711eaa5fc$var$yi = new WeakMap, $06484a9711eaa5fc$var$wi = new WeakSet, class {
    async buildAuthorizationUrl(e) {
        const { serverMetadata: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        if (null != e && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new $06484a9711eaa5fc$var$gi("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
        try {
            return await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Bi).call(this, e);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Pi(e);
        }
    }
    async buildLinkUserUrl(e) {
        try {
            const t = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Bi).call(this, {
                authorizationParams: $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    requested_connection_scope: e.connectionScope,
                    scope: "openid link_account offline_access",
                    id_token_hint: e.idToken
                })
            });
            return {
                linkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Ri(e);
        }
    }
    async buildUnlinkUserUrl(e) {
        try {
            const t = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Bi).call(this, {
                authorizationParams: $06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    scope: "openid unlink_account",
                    id_token_hint: e.idToken
                })
            });
            return {
                unlinkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Ii(e);
        }
    }
    async backchannelAuthentication(e) {
        const { configuration: t, serverMetadata: n } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this), o = $06484a9711eaa5fc$var$Oi($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), r = new URLSearchParams($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({
            scope: $06484a9711eaa5fc$var$zi
        }, o), {}, {
            client_id: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: n.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && r.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && r.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $06484a9711eaa5fc$var$gr(t, r), n = await $06484a9711eaa5fc$var$vr(t, e);
            return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(n);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Ai(e);
        }
    }
    async initiateBackchannelAuthentication(e) {
        const { configuration: t, serverMetadata: n } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this), o = $06484a9711eaa5fc$var$Oi($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), r = new URLSearchParams($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({
            scope: $06484a9711eaa5fc$var$zi
        }, o), {}, {
            client_id: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: n.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && r.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && r.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $06484a9711eaa5fc$var$gr(t, r);
            return {
                authReqId: e.auth_req_id,
                expiresIn: e.expires_in,
                interval: e.interval
            };
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Ai(e);
        }
    }
    async backchannelAuthenticationGrant(e) {
        let { authReqId: t } = e;
        const { configuration: n } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this), o = new URLSearchParams({
            auth_req_id: t
        });
        try {
            const e = await $06484a9711eaa5fc$var$xr(n, "urn:openid:params:grant-type:ciba", o);
            return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(e);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$Ai(e);
        }
    }
    async getTokenForConnection(e) {
        var t;
        if (e.refreshToken && e.accessToken) throw new $06484a9711eaa5fc$var$Si("Either a refresh or access token should be specified, but not both.");
        const n = null !== (t = e.accessToken) && void 0 !== t ? t : e.refreshToken;
        if (!n) throw new $06484a9711eaa5fc$var$Si("Either a refresh or access token must be specified.");
        try {
            return await this.exchangeToken({
                connection: e.connection,
                subjectToken: n,
                subjectTokenType: e.accessToken ? "urn:ietf:params:oauth:token-type:access_token" : "urn:ietf:params:oauth:token-type:refresh_token",
                loginHint: e.loginHint
            });
        } catch (e) {
            if (e instanceof $06484a9711eaa5fc$var$Ei) throw new $06484a9711eaa5fc$var$Si(e.message, e.cause);
            throw e;
        }
    }
    async exchangeToken(e) {
        return "connection" in e ? $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Gi).call(this, e) : $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Zi).call(this, e);
    }
    async getTokenByCode(e, t) {
        const { configuration: n } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        try {
            const o = await $06484a9711eaa5fc$var$_r(n, e, {
                pkceCodeVerifier: t.codeVerifier
            });
            return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$bi("There was an error while trying to request a token.", e);
        }
    }
    async getTokenByRefreshToken(e) {
        const { configuration: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        try {
            const n = await $06484a9711eaa5fc$var$kr(t, e.refreshToken);
            return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(n);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$ki("The access token has expired and there was an error while trying to refresh it.", e);
        }
    }
    async getTokenByClientCredentials(e) {
        const { configuration: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        try {
            const n = new URLSearchParams({
                audience: e.audience
            });
            e.organization && n.append("organization", e.organization);
            const o = await $06484a9711eaa5fc$var$Sr(t, n);
            return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $06484a9711eaa5fc$var$_i("There was an error while trying to request a token.", e);
        }
    }
    async buildLogoutUrl(e) {
        const { configuration: t, serverMetadata: n } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        if (!n.end_session_endpoint) {
            const t = new URL("https://".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).domain, "/v2/logout"));
            return t.searchParams.set("returnTo", e.returnTo), t.searchParams.set("client_id", $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId), t;
        }
        return function(e, t) {
            $06484a9711eaa5fc$var$Ar(e);
            const { as: n, c: o, tlsOnly: r } = $06484a9711eaa5fc$var$$o(e), i = $06484a9711eaa5fc$var$an(n, "end_session_endpoint", !1, r);
            (t = new URLSearchParams(t)).has("client_id") || t.set("client_id", o.client_id);
            for (const [e, n] of t.entries())i.searchParams.append(e, n);
            return i;
        }(t, {
            post_logout_redirect_uri: e.returnTo
        });
    }
    async verifyLogoutToken(e) {
        const { serverMetadata: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
        $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$yi, this) || $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$yi, this, function(e, t) {
            const n = new $06484a9711eaa5fc$var$si(e, t), o = async (e, t)=>n.getKey(e, t);
            return Object.defineProperties(o, {
                coolingDown: {
                    get: ()=>n.coolingDown(),
                    enumerable: !0,
                    configurable: !1
                },
                fresh: {
                    get: ()=>n.fresh(),
                    enumerable: !0,
                    configurable: !1
                },
                reload: {
                    value: ()=>n.reload(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                },
                reloading: {
                    get: ()=>n.pendingFetch(),
                    enumerable: !0,
                    configurable: !1
                },
                jwks: {
                    value: ()=>n.jwks(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                }
            }), o;
        }(new URL(t.jwks_uri), {
            [$06484a9711eaa5fc$var$Br]: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).customFetch
        }));
        const { payload: n } = await $06484a9711eaa5fc$var$Wr(e.logoutToken, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$yi, this), {
            issuer: t.issuer,
            audience: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId,
            algorithms: [
                "RS256"
            ],
            requiredClaims: [
                "iat"
            ]
        });
        if (!("sid" in n) && !("sub" in n)) throw new $06484a9711eaa5fc$var$Ti('either "sid" or "sub" (or both) claims must be present');
        if ("sid" in n && "string" != typeof n.sid) throw new $06484a9711eaa5fc$var$Ti('"sid" claim must be a string');
        if ("sub" in n && "string" != typeof n.sub) throw new $06484a9711eaa5fc$var$Ti('"sub" claim must be a string');
        if ("nonce" in n) throw new $06484a9711eaa5fc$var$Ti('"nonce" claim is prohibited');
        if (!("events" in n)) throw new $06484a9711eaa5fc$var$Ti('"events" claim is missing');
        if ("object" != typeof n.events || null === n.events) throw new $06484a9711eaa5fc$var$Ti('"events" claim must be an object');
        if (!("http://schemas.openid.net/event/backchannel-logout" in n.events)) throw new $06484a9711eaa5fc$var$Ti('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
        if ("object" != typeof n.events["http://schemas.openid.net/event/backchannel-logout"]) throw new $06484a9711eaa5fc$var$Ti('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
        return {
            sid: n.sid,
            sub: n.sub
        };
    }
    constructor(e){
        if (function(e, t) {
            $06484a9711eaa5fc$var$ct(e, t), t.add(e);
        }(this, $06484a9711eaa5fc$var$wi), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$pi, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$fi, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$mi, void 0), $06484a9711eaa5fc$var$lt(this, $06484a9711eaa5fc$var$yi, void 0), $06484a9711eaa5fc$var$ht(this, "mfa", void 0), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$mi, this, e), e.useMtls && !e.customFetch) throw new $06484a9711eaa5fc$var$gi("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
        this.mfa = new $06484a9711eaa5fc$var$Ni({
            domain: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).domain,
            clientId: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId,
            customFetch: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).customFetch
        });
    }
});
async function $06484a9711eaa5fc$var$Fi() {
    if ($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$pi, this) && $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$fi, this)) return {
        configuration: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$pi, this),
        serverMetadata: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$fi, this)
    };
    const e = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$qi).call(this);
    return $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$pi, this, await $06484a9711eaa5fc$var$hr(new URL("https://".concat($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).domain)), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId, {
        use_mtls_endpoint_aliases: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).useMtls
    }, e, {
        [$06484a9711eaa5fc$var$or]: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).customFetch
    })), $06484a9711eaa5fc$var$dt($06484a9711eaa5fc$var$fi, this, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$pi, this).serverMetadata()), $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$pi, this)[$06484a9711eaa5fc$var$or] = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).customFetch || fetch, {
        configuration: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$pi, this),
        serverMetadata: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$fi, this)
    };
}
async function $06484a9711eaa5fc$var$Gi(e) {
    var t, n;
    const { configuration: o } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
    if ("audience" in e || "resource" in e) throw new $06484a9711eaa5fc$var$Ei("audience and resource parameters are not supported for Token Vault exchanges");
    $06484a9711eaa5fc$var$Mi(e.subjectToken);
    const r = new URLSearchParams({
        connection: e.connection,
        subject_token: e.subjectToken,
        subject_token_type: null !== (t = e.subjectTokenType) && void 0 !== t ? t : "urn:ietf:params:oauth:token-type:access_token",
        requested_token_type: null !== (n = e.requestedTokenType) && void 0 !== n ? n : "http://auth0.com/oauth/token-type/federated-connection-access-token"
    });
    e.loginHint && r.append("login_hint", e.loginHint), e.scope && r.append("scope", e.scope), $06484a9711eaa5fc$var$Ji(r, e.extra);
    try {
        const e = await $06484a9711eaa5fc$var$xr(o, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", r);
        return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(e);
    } catch (t) {
        throw new $06484a9711eaa5fc$var$Ei("Failed to exchange token for connection '".concat(e.connection, "'."), t);
    }
}
async function $06484a9711eaa5fc$var$Zi(e) {
    const { configuration: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this);
    $06484a9711eaa5fc$var$Mi(e.subjectToken);
    const n = new URLSearchParams({
        subject_token_type: e.subjectTokenType,
        subject_token: e.subjectToken
    });
    e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.requestedTokenType && n.append("requested_token_type", e.requestedTokenType), e.organization && n.append("organization", e.organization), $06484a9711eaa5fc$var$Ji(n, e.extra);
    try {
        const e = await $06484a9711eaa5fc$var$xr(t, "urn:ietf:params:oauth:grant-type:token-exchange", n);
        return $06484a9711eaa5fc$var$Wi.fromTokenEndpointResponse(e);
    } catch (t) {
        throw new $06484a9711eaa5fc$var$Ei("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), t);
    }
}
async function $06484a9711eaa5fc$var$qi() {
    if (!$06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientSecret && !$06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientAssertionSigningKey && !$06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).useMtls) throw new $06484a9711eaa5fc$var$xi;
    if ($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).useMtls) return (e, t, n, o)=>{
        n.set("client_id", t.client_id);
    };
    let e = $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientAssertionSigningKey;
    return !e || e instanceof CryptoKey || (e = await async function(e, t, n) {
        if ("string" != typeof e || 0 !== e.indexOf("-----BEGIN PRIVATE KEY-----")) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
        return $06484a9711eaa5fc$var$zo(e, t, n);
    }(e, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientAssertionSigningAlg || "RS256")), e ? function(e, t) {
        return $06484a9711eaa5fc$var$tn(e, t);
    }(e) : $06484a9711eaa5fc$var$nr($06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientSecret);
}
async function $06484a9711eaa5fc$var$Bi(e) {
    const { configuration: t } = await $06484a9711eaa5fc$var$at($06484a9711eaa5fc$var$wi, this, $06484a9711eaa5fc$var$Fi).call(this), n = $06484a9711eaa5fc$var$cr(), o = await $06484a9711eaa5fc$var$sr(n), r = $06484a9711eaa5fc$var$Oi($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({}, $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), i = new URLSearchParams($06484a9711eaa5fc$var$ft($06484a9711eaa5fc$var$ft({
        scope: $06484a9711eaa5fc$var$zi
    }, r), {}, {
        client_id: $06484a9711eaa5fc$var$ut($06484a9711eaa5fc$var$mi, this).clientId,
        code_challenge: o,
        code_challenge_method: "S256"
    }));
    return {
        authorizationUrl: null != e && e.pushedAuthorizationRequests ? await $06484a9711eaa5fc$var$Tr(t, i) : await $06484a9711eaa5fc$var$Er(t, i),
        codeVerifier: n
    };
}
class $06484a9711eaa5fc$export$fd2d7253282cd781 extends $06484a9711eaa5fc$export$7d465be8efa67280 {
    static fromPayload(e) {
        let { error: t, error_description: n } = e;
        return new $06484a9711eaa5fc$export$fd2d7253282cd781(t, n);
    }
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$fd2d7253282cd781.prototype);
    }
}
class $06484a9711eaa5fc$export$940c42743f432969 extends $06484a9711eaa5fc$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$940c42743f432969.prototype);
    }
}
class $06484a9711eaa5fc$export$870742f9876ce7c1 extends $06484a9711eaa5fc$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$870742f9876ce7c1.prototype);
    }
}
class $06484a9711eaa5fc$export$5a994d9ede115726 extends $06484a9711eaa5fc$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$5a994d9ede115726.prototype);
    }
}
class $06484a9711eaa5fc$export$ed4d3fbc582ebfd8 extends $06484a9711eaa5fc$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$ed4d3fbc582ebfd8.prototype);
    }
}
class $06484a9711eaa5fc$export$702aa0eb54b4ab0a extends $06484a9711eaa5fc$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $06484a9711eaa5fc$export$702aa0eb54b4ab0a.prototype);
    }
}
class $06484a9711eaa5fc$var$na {
    set(e, t) {
        this.cleanup(), this.contexts.set(e, Object.assign(Object.assign({}, t), {
            createdAt: Date.now()
        }));
    }
    get(e) {
        const t = this.contexts.get(e);
        if (t) {
            if (!(Date.now() - t.createdAt > this.ttlMs)) return t;
            this.contexts.delete(e);
        }
    }
    remove(e) {
        this.contexts.delete(e);
    }
    cleanup() {
        const e = Date.now();
        for (const [t, n] of this.contexts)e - n.createdAt > this.ttlMs && this.contexts.delete(t);
    }
    get size() {
        return this.contexts.size;
    }
    constructor(){
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e5;
        this.contexts = new Map, this.ttlMs = e;
    }
}
class $06484a9711eaa5fc$export$c23d31083644c64d {
    setMFAAuthDetails(e, t, n, o) {
        this.contextManager.set(e, {
            scope: t,
            audience: n,
            mfaRequirements: o
        });
    }
    async getAuthenticators(e) {
        var t, n;
        const o = this.contextManager.get(e);
        if (!(null === (t = null == o ? void 0 : o.mfaRequirements) || void 0 === t ? void 0 : t.challenge) || 0 === o.mfaRequirements.challenge.length) throw new $06484a9711eaa5fc$export$940c42743f432969("invalid_request", "challengeType is required and must contain at least one challenge type, please check mfa_required error payload");
        const r = o.mfaRequirements.challenge.map((e)=>e.type);
        try {
            return (await this.authJsMfaClient.listAuthenticators({
                mfaToken: e
            })).filter((e)=>!!e.type && r.includes(e.type));
        } catch (e) {
            if (e instanceof $06484a9711eaa5fc$var$ji) throw new $06484a9711eaa5fc$export$940c42743f432969(null === (n = e.cause) || void 0 === n ? void 0 : n.error, e.message);
            throw e;
        }
    }
    async enroll(e) {
        var t;
        const n = function(e) {
            const t = $06484a9711eaa5fc$var$tt[e.factorType];
            return Object.assign(Object.assign(Object.assign({
                mfaToken: e.mfaToken,
                authenticatorTypes: t.authenticatorTypes
            }, t.oobChannels && {
                oobChannels: t.oobChannels
            }), "phoneNumber" in e && {
                phoneNumber: e.phoneNumber
            }), "email" in e && {
                email: e.email
            });
        }(e);
        try {
            return await this.authJsMfaClient.enrollAuthenticator(n);
        } catch (e) {
            if (e instanceof $06484a9711eaa5fc$var$Di) throw new $06484a9711eaa5fc$export$870742f9876ce7c1(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async challenge(e) {
        var t;
        try {
            const t = {
                challengeType: e.challengeType,
                mfaToken: e.mfaToken
            };
            return e.authenticatorId && (t.authenticatorId = e.authenticatorId), await this.authJsMfaClient.challengeAuthenticator(t);
        } catch (e) {
            if (e instanceof $06484a9711eaa5fc$var$Li) throw new $06484a9711eaa5fc$export$5a994d9ede115726(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async getEnrollmentFactors(e) {
        const t = this.contextManager.get(e);
        if (!t || !t.mfaRequirements) throw new $06484a9711eaa5fc$export$702aa0eb54b4ab0a("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        return t.mfaRequirements.enroll && 0 !== t.mfaRequirements.enroll.length ? t.mfaRequirements.enroll : [];
    }
    async verify(e) {
        const t = this.contextManager.get(e.mfaToken);
        if (!t) throw new $06484a9711eaa5fc$export$ed4d3fbc582ebfd8("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        const n = function(e) {
            return "otp" in e && e.otp ? $06484a9711eaa5fc$var$nt : "oobCode" in e && e.oobCode ? $06484a9711eaa5fc$var$ot : "recoveryCode" in e && e.recoveryCode ? $06484a9711eaa5fc$var$rt : void 0;
        }(e);
        if (!n) throw new $06484a9711eaa5fc$export$ed4d3fbc582ebfd8("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
        const o = t.scope, r = t.audience;
        try {
            const t = await this.auth0Client._requestTokenForMfa({
                grant_type: n,
                mfaToken: e.mfaToken,
                scope: o,
                audience: r,
                otp: e.otp,
                oob_code: e.oobCode,
                binding_code: e.bindingCode,
                recovery_code: e.recoveryCode
            });
            return this.contextManager.remove(e.mfaToken), t;
        } catch (e) {
            if (e instanceof $06484a9711eaa5fc$export$c59494f4dae44ada) this.setMFAAuthDetails(e.mfa_token, o, r, e.mfa_requirements);
            else if (e instanceof $06484a9711eaa5fc$export$ed4d3fbc582ebfd8) throw new $06484a9711eaa5fc$export$ed4d3fbc582ebfd8(e.error, e.error_description);
            throw e;
        }
    }
    constructor(e, t){
        this.authJsMfaClient = e, this.auth0Client = t, this.contextManager = new $06484a9711eaa5fc$var$na;
    }
}
class $06484a9711eaa5fc$export$b50978e389d6e1d5 {
    getConfiguration() {
        return Object.freeze({
            domain: this.options.domain,
            clientId: this.options.clientId
        });
    }
    _url(e) {
        const t = this.options.auth0Client || $06484a9711eaa5fc$var$n, o = $06484a9711eaa5fc$var$b(t, !0), r = encodeURIComponent(btoa(JSON.stringify(o)));
        return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(r);
    }
    _authorizeUrl(e) {
        return this._url("/authorize?".concat($06484a9711eaa5fc$var$_(e)));
    }
    async _verifyIdToken(e, t, n) {
        const o = await this.nowProvider();
        var r;
        return $06484a9711eaa5fc$var$ke({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: n,
            leeway: this.options.leeway,
            max_age: (r = this.options.authorizationParams.max_age, "string" != typeof r ? r : parseInt(r, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, n) {
        var o;
        const r = $06484a9711eaa5fc$var$g($06484a9711eaa5fc$var$w()), i = $06484a9711eaa5fc$var$g($06484a9711eaa5fc$var$w()), a = $06484a9711eaa5fc$var$w(), s = await $06484a9711eaa5fc$var$k(a), c = $06484a9711eaa5fc$var$E(s), u = await (null === (o = this.dpop) || void 0 === o ? void 0 : o.calculateThumbprint()), l = ((e, t, n, o, r, i, a, s, c)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), n), {
                scope: $06484a9711eaa5fc$var$fe(t, n.scope, n.audience),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: r,
                redirect_uri: a || e.authorizationParams.redirect_uri,
                code_challenge: i,
                code_challenge_method: "S256",
                dpop_jkt: c
            }))(this.options, this.scope, e, r, i, c, e.redirect_uri || this.options.authorizationParams.redirect_uri || n, null == t ? void 0 : t.response_mode, u), d = this._authorizeUrl(l);
        return {
            nonce: i,
            code_verifier: a,
            scope: l.scope,
            audience: l.audience || "default",
            redirect_uri: l.redirect_uri,
            state: r,
            url: d
        };
    }
    async loginWithPopup(e, t) {
        var n;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
        })(""), !t.popup)) throw new $06484a9711eaa5fc$export$d52312082b7f6392;
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const i = await ((e)=>new Promise((t, n)=>{
                let o;
                const i = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(i), clearTimeout(a), window.removeEventListener("message", o, !1), n(new $06484a9711eaa5fc$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(i), n(new $06484a9711eaa5fc$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(s) {
                    if (s.data && "authorization_response" === s.data.type) {
                        if (clearTimeout(a), clearInterval(i), window.removeEventListener("message", o, !1), !1 !== e.closePopup && e.popup.close(), s.data.response.error) return n($06484a9711eaa5fc$export$7d465be8efa67280.fromPayload(s.data.response));
                        t(s.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== i.state) throw new $06484a9711eaa5fc$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: i.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect() {
        var t;
        const n = $06484a9711eaa5fc$var$Ge(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), { openUrl: o, fragment: r, appState: i } = n, a = $06484a9711eaa5fc$var$e(n, [
            "openUrl",
            "fragment",
            "appState"
        ]), s = (null === (t = a.authorizationParams) || void 0 === t ? void 0 : t.organization) || this.options.authorizationParams.organization, c = await this._prepareAuthorizeUrl(a.authorizationParams || {}), { url: u } = c, l = $06484a9711eaa5fc$var$e(c, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: i,
            response_type: $06484a9711eaa5fc$export$7390b1e457b4cb6f.Code
        }), s && {
            organization: s
        }));
        const d = r ? "".concat(u, "#").concat(r) : u;
        o ? await o(d) : window.location.assign(d);
    }
    async handleRedirectCallback() {
        const e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.href).split("?").slice(1);
        if (0 === e.length) throw new Error("There are no query params available for parsing.");
        const t = this.transactionManager.get();
        if (!t) throw new $06484a9711eaa5fc$export$7d465be8efa67280("missing_transaction", "Invalid state");
        this.transactionManager.remove();
        const n = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                connect_code: t.get("connect_code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(e.join(""));
        return t.response_type === $06484a9711eaa5fc$export$7390b1e457b4cb6f.ConnectCode ? this._handleConnectAccountRedirectCallback(n, t) : this._handleLoginRedirectCallback(n, t);
    }
    async _handleLoginRedirectCallback(e, t) {
        const { code: n, state: o, error: a, error_description: s } = e;
        if (a) throw new $06484a9711eaa5fc$export$cf0c46b07324e9c5(a, s || a, o, t.appState);
        if (!t.code_verifier || t.state && t.state !== o) throw new $06484a9711eaa5fc$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const c = t.organization, u = t.nonce, l = t.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: t.audience,
            scope: t.scope,
            code_verifier: t.code_verifier,
            grant_type: "authorization_code",
            code: n
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: u,
            organization: c
        }), {
            appState: t.appState,
            response_type: $06484a9711eaa5fc$export$7390b1e457b4cb6f.Code
        };
    }
    async _handleConnectAccountRedirectCallback(e, t) {
        const { connect_code: n, state: o, error: i, error_description: s } = e;
        if (i) throw new $06484a9711eaa5fc$export$aaa3fc6bdea78d4d(i, s || i, t.connection, o, t.appState);
        if (!n) throw new $06484a9711eaa5fc$export$7d465be8efa67280("missing_connect_code", "Missing connect code");
        if (!(t.code_verifier && t.state && t.auth_session && t.redirect_uri && t.state === o)) throw new $06484a9711eaa5fc$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const c = await this.myAccountApi.completeAccount({
            auth_session: t.auth_session,
            connect_code: n,
            redirect_uri: t.redirect_uri,
            code_verifier: t.code_verifier
        });
        return Object.assign(Object.assign({}, c), {
            appState: t.appState,
            response_type: $06484a9711eaa5fc$export$7390b1e457b4cb6f.ConnectCode
        });
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var t, n;
        const o = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $06484a9711eaa5fc$var$fe(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience) || this.options.authorizationParams.audience)
            })
        }), r = await ((e, t)=>{
            let n = $06484a9711eaa5fc$var$Me[t];
            return n || (n = e().finally(()=>{
                delete $06484a9711eaa5fc$var$Me[t], n = null;
            }), $06484a9711eaa5fc$var$Me[t] = n), n;
        })(()=>this._getTokenSilently(o), "".concat(this.options.clientId, "::").concat(o.authorizationParams.audience, "::").concat(o.authorizationParams.scope));
        return e.detailedResponse ? r : null == r ? void 0 : r.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: n } = t, o = $06484a9711eaa5fc$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== n) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId,
                cacheMode: n
            });
            if (e) return e;
        }
        if ("cache-only" === n) return;
        const r = (i = this.options.clientId, a = o.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(i, ".").concat(a));
        var i, a;
        try {
            return await this.lockManager.runWithLock(r, 5e3, async ()=>{
                if ("off" !== n) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, token_type: r, access_token: i, oauthTokenScope: a, expires_in: s } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    token_type: r,
                    access_token: i
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: s
                });
            });
        } catch (e) {
            if (this._isInteractiveError(e) && "popup" === this.options.interactiveErrorHandler) return await this._handleInteractiveErrorWithPopup(o);
            throw e;
        }
    }
    _isInteractiveError(e) {
        return e instanceof $06484a9711eaa5fc$export$c59494f4dae44ada || e instanceof $06484a9711eaa5fc$export$7d465be8efa67280 && this._isIframeMfaError(e);
    }
    _isIframeMfaError(e) {
        return "login_required" === e.error && "Multifactor authentication required" === e.error_description;
    }
    async _handleInteractiveErrorWithPopup(e) {
        try {
            await this.loginWithPopup({
                authorizationParams: e.authorizationParams
            });
            const t = await this._getEntryFromCache({
                scope: e.authorizationParams.scope,
                audience: e.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (!t) throw new $06484a9711eaa5fc$export$7d465be8efa67280("interactive_handler_cache_miss", "Token not found in cache after interactive authentication");
            return t;
        } catch (e) {
            throw e;
        }
    }
    async getTokenWithPopup() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var o, r;
        const i = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $06484a9711eaa5fc$var$fe(this.scope, null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.scope, (null === (r = e.authorizationParams) || void 0 === r ? void 0 : r.audience) || this.options.authorizationParams.audience)
            })
        });
        n = Object.assign(Object.assign({}, $06484a9711eaa5fc$var$t), n), await this.loginWithPopup(i, n);
        return (await this.cacheManager.get(new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            scope: i.authorizationParams.scope,
            audience: i.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt)).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const n = t.logoutParams || {}, { federated: o } = n, r = $06484a9711eaa5fc$var$e(n, [
            "federated"
        ]), i = o ? "&federated" : "";
        return this._url("/v2/logout?".concat($06484a9711eaa5fc$var$_(Object.assign({
            clientId: t.clientId
        }, r)))) + i;
    }
    async logout() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var n;
        const o = $06484a9711eaa5fc$var$Ge(t), { openUrl: r } = o, i = $06484a9711eaa5fc$var$e(o, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@"), await (null === (n = this.dpop) || void 0 === n ? void 0 : n.clear());
        const a = this._buildLogoutUrl(i);
        r ? await r(a) : !1 !== r && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
        var n;
        try {
            return await this.lockManager.runWithLock(t, 5e3, async ()=>{
                const t = Object.assign(Object.assign({}, e.authorizationParams), {
                    prompt: "none"
                }), n = this.cookieStorage.get(this.orgHintCookieName);
                n && !t.organization && (t.organization = n);
                const { url: o, state: i, nonce: a, code_verifier: c, redirect_uri: u, scope: l, audience: d } = await this._prepareAuthorizeUrl(t, {
                    response_mode: "web_message"
                }, window.location.origin);
                if (window.crossOriginIsolated) throw new $06484a9711eaa5fc$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
                const h = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
                let p;
                try {
                    p = new URL(this.domainUrl).origin;
                } catch (e) {
                    p = this.domainUrl;
                }
                const f = await function(e, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 60;
                    return new Promise((o, i)=>{
                        const a = window.document.createElement("iframe");
                        a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                        const c = ()=>{
                            window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", u, !1));
                        };
                        let u;
                        const l = setTimeout(()=>{
                            i(new $06484a9711eaa5fc$export$66d311bf29d5c89c), c();
                        }, 1e3 * n);
                        u = function(e) {
                            if (e.origin != t) return;
                            if (!e.data || "authorization_response" !== e.data.type) return;
                            const n = e.source;
                            n && n.close(), e.data.response.error ? i($06484a9711eaa5fc$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(l), window.removeEventListener("message", u, !1), setTimeout(c, 2e3);
                        }, window.addEventListener("message", u, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                    });
                }(o, p, h);
                if (i !== f.state) throw new $06484a9711eaa5fc$export$7d465be8efa67280("state_mismatch", "Invalid state");
                const m = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                    code_verifier: c,
                    code: f.code,
                    grant_type: "authorization_code",
                    redirect_uri: u,
                    timeout: e.authorizationParams.timeout || this.httpTimeoutMs
                }), {
                    nonceIn: a,
                    organization: t.organization
                });
                return Object.assign(Object.assign({}, m), {
                    scope: l,
                    oauthTokenScope: m.scope,
                    audience: d
                });
            });
        } catch (e) {
            if ("login_required" === e.error) e instanceof $06484a9711eaa5fc$export$7d465be8efa67280 && this._isIframeMfaError(e) && "popup" === this.options.interactiveErrorHandler || this.logout({
                openUrl: !1
            });
            throw e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        var t, n;
        const o = await this.cacheManager.get(new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt);
        if (!(o && o.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $06484a9711eaa5fc$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const r = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, i = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, a = ((e, t, n, o)=>{
            var r;
            if (e && n && o) {
                if (t.audience !== n) return t.scope;
                const e = o.split(" "), i = (null === (r = t.scope) || void 0 === r ? void 0 : r.split(" ")) || [], a = i.every((t)=>e.includes(t));
                return e.length >= i.length && a ? o : t.scope;
            }
            return t.scope;
        })(this.options.useMrrt, e.authorizationParams, null == o ? void 0 : o.audience, null == o ? void 0 : o.scope);
        try {
            const t = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: o && o.refresh_token,
                redirect_uri: r
            }), i && {
                timeout: i
            }), {
                scopesToRequest: a
            });
            if (t.refresh_token && (null == o ? void 0 : o.refresh_token) && await this.cacheManager.updateEntry(o.refresh_token, t.refresh_token), this.options.useMrrt) {
                if (s = null == o ? void 0 : o.audience, c = null == o ? void 0 : o.scope, u = e.authorizationParams.audience, l = e.authorizationParams.scope, s !== u || !$06484a9711eaa5fc$var$Ze(l, c)) {
                    if (!$06484a9711eaa5fc$var$Ze(a, t.scope)) {
                        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
                        await this.cacheManager.remove(this.options.clientId, e.authorizationParams.audience, e.authorizationParams.scope);
                        const n = ((e, t)=>{
                            const n = (null == e ? void 0 : e.split(" ")) || [], o = (null == t ? void 0 : t.split(" ")) || [];
                            return n.filter((e)=>-1 == o.indexOf(e)).join(",");
                        })(a, t.scope);
                        throw new $06484a9711eaa5fc$var$p(e.authorizationParams.audience || "default", n);
                    }
                }
            }
            return Object.assign(Object.assign({}, t), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: t.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (o) {
            if (o.message) {
                if (o.message.includes("user is blocked")) throw await this.logout({
                    openUrl: !1
                }), o;
                if ((o.message.includes("Missing Refresh Token") || o.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            }
            throw o instanceof $06484a9711eaa5fc$export$c59494f4dae44ada && this.mfa.setMFAAuthDetails(o.mfa_token, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience, o.mfa_requirements), o;
        }
        var s, c, u, l;
    }
    async _saveEntryInCache(t) {
        const { id_token: n, decodedToken: o } = t, r = $06484a9711eaa5fc$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: n,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(r);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = this.scope[e], n = await this.cacheManager.getIdToken(new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            clientId: this.options.clientId,
            audience: e,
            scope: t
        })), o = this.userCache.get("@@user@@");
        return n && n.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set("@@user@@", n), n);
    }
    async _getEntryFromCache(e) {
        let { scope: t, audience: n, clientId: o, cacheMode: r } = e;
        const i = await this.cacheManager.get(new $06484a9711eaa5fc$export$2cb47d384c8dd787({
            scope: t,
            audience: n,
            clientId: o
        }), 60, this.options.useMrrt, r);
        if (i && i.access_token) {
            const { token_type: e, access_token: t, oauthTokenScope: n, expires_in: o } = i, r = await this._getIdTokenFromCache();
            return r && Object.assign(Object.assign({
                id_token: r.id_token,
                token_type: e || "Bearer",
                access_token: t
            }, n ? {
                scope: n
            } : null), {
                expires_in: o
            });
        }
    }
    async _requestToken(e, t) {
        var n, o;
        const { nonceIn: r, organization: i, scopesToRequest: a } = t || {}, s = await $06484a9711eaa5fc$var$de(Object.assign(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs,
            useMrrt: this.options.useMrrt,
            dpop: this.dpop
        }, e), {
            scope: a || e.scope
        }), this.worker), c = await this._verifyIdToken(s.id_token, r, i);
        if ("authorization_code" === e.grant_type) {
            const e = await this._getIdTokenFromCache();
            (null === (o = null === (n = null == e ? void 0 : e.decodedToken) || void 0 === n ? void 0 : n.claims) || void 0 === o ? void 0 : o.sub) && e.decodedToken.claims.sub !== c.claims.sub && (await this.cacheManager.clear(this.options.clientId), this.userCache.remove("@@user@@"));
        }
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, s), {
            decodedToken: c,
            scope: e.scope,
            audience: e.audience || "default"
        }), s.scope ? {
            oauthTokenScope: s.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(i || c.claims.org_id), Object.assign(Object.assign({}, s), {
            decodedToken: c
        });
    }
    async loginWithCustomTokenExchange(e) {
        return this._requestToken(Object.assign(Object.assign({}, e), {
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
            subject_token: e.subject_token,
            subject_token_type: e.subject_token_type,
            scope: $06484a9711eaa5fc$var$fe(this.scope, e.scope, e.audience || this.options.authorizationParams.audience),
            audience: e.audience || this.options.authorizationParams.audience,
            organization: e.organization || this.options.authorizationParams.organization
        }));
    }
    async exchangeToken(e) {
        return this.loginWithCustomTokenExchange(e);
    }
    _assertDpop(e) {
        if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
    }
    getDpopNonce(e) {
        return this._assertDpop(this.dpop), this.dpop.getNonce(e);
    }
    setDpopNonce(e, t) {
        return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
    }
    generateDpopProof(e) {
        return this._assertDpop(this.dpop), this.dpop.generateProof(e);
    }
    createFetcher() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return new $06484a9711eaa5fc$var$Qe(e, {
            isDpopEnabled: ()=>!!this.options.useDpop,
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: null == e ? void 0 : e.audience
                    },
                    detailedResponse: !0
                });
            },
            getDpopNonce: ()=>this.getDpopNonce(e.dpopNonceId),
            setDpopNonce: (t)=>this.setDpopNonce(t, e.dpopNonceId),
            generateDpopProof: (e)=>this.generateDpopProof(e)
        });
    }
    async connectAccountWithRedirect(e) {
        const { openUrl: t, appState: n, connection: o, scopes: r, authorization_params: i, redirectUri: a = this.options.authorizationParams.redirect_uri || window.location.origin } = e;
        if (!o) throw new Error("connection is required");
        const s = $06484a9711eaa5fc$var$g($06484a9711eaa5fc$var$w()), c = $06484a9711eaa5fc$var$w(), u = await $06484a9711eaa5fc$var$k(c), l = $06484a9711eaa5fc$var$E(u), { connect_uri: d, connect_params: h, auth_session: p } = await this.myAccountApi.connectAccount({
            connection: o,
            scopes: r,
            redirect_uri: a,
            state: s,
            code_challenge: l,
            code_challenge_method: "S256",
            authorization_params: i
        });
        this.transactionManager.create({
            state: s,
            code_verifier: c,
            auth_session: p,
            redirect_uri: a,
            appState: n,
            connection: o,
            response_type: $06484a9711eaa5fc$export$7390b1e457b4cb6f.ConnectCode
        });
        const f = new URL(d);
        f.searchParams.set("ticket", h.ticket), t ? await t(f.toString()) : window.location.assign(f);
    }
    async _requestTokenForMfa(t, n) {
        const { mfaToken: o } = t, r = $06484a9711eaa5fc$var$e(t, [
            "mfaToken"
        ]);
        return this._requestToken(Object.assign(Object.assign({}, r), {
            mfa_token: o
        }), n);
    }
    constructor(e){
        let t, n;
        if (this.userCache = (new $06484a9711eaa5fc$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$06484a9711eaa5fc$var$y()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $06484a9711eaa5fc$var$y().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), this.lockManager = ($06484a9711eaa5fc$var$H || ($06484a9711eaa5fc$var$H = $06484a9711eaa5fc$var$z()), $06484a9711eaa5fc$var$H), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) n = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$06484a9711eaa5fc$var$Fe(t)) throw new Error('Invalid cache location "'.concat(t, '"'));
            n = $06484a9711eaa5fc$var$Fe(t)();
        }
        var r;
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $06484a9711eaa5fc$var$Oe : $06484a9711eaa5fc$var$Ce, this.orgHintCookieName = (r = this.options.clientId, "auth0.".concat(r, ".organization_hint")), this.isAuthenticatedCookieName = ((e)=>"auth0.".concat(e, ".is.authenticated"))(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const i = e.useCookiesForTransactions ? this.cookieStorage : $06484a9711eaa5fc$var$je;
        var a;
        this.scope = function(e, t) {
            for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
            if ("object" != typeof e) return {
                default: $06484a9711eaa5fc$var$pe(t, e, ...o)
            };
            let i = {
                default: $06484a9711eaa5fc$var$pe(t, ...o)
            };
            return Object.keys(e).forEach((n)=>{
                const r = e[n];
                i[n] = $06484a9711eaa5fc$var$pe(t, r, ...o);
            }), i;
        }(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $06484a9711eaa5fc$var$ve(i, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $06484a9711eaa5fc$var$o, this.cacheManager = new $06484a9711eaa5fc$var$ge(n, n.allKeys ? void 0 : new $06484a9711eaa5fc$var$Je(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new $06484a9711eaa5fc$var$Xe(this.options.clientId) : void 0, this.domainUrl = (a = this.options.domain, /^https?:\/\//.test(a) ? a : "https://".concat(a)), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/"))(this.options.issuer, this.domainUrl);
        const s = "".concat(this.domainUrl, "/me/"), c = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && {
            dpopNonceId: "__auth0_my_account_api__"
        }), {
            getAccessToken: ()=>this.getTokenSilently({
                    authorizationParams: {
                        scope: "create:me:connected_accounts",
                        audience: s
                    },
                    detailedResponse: !0
                })
        }));
        this.myAccountApi = new $06484a9711eaa5fc$var$$e(c, s), this.authJsClient = new $06484a9711eaa5fc$var$Vi({
            domain: this.options.domain,
            clientId: this.options.clientId
        }), this.mfa = new $06484a9711eaa5fc$export$c23d31083644c64d(this.authJsClient.mfa, this), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $06484a9711eaa5fc$var$He);
    }
}
async function $06484a9711eaa5fc$export$9fa2cfec0168886e(e) {
    const t = new $06484a9711eaa5fc$export$b50978e389d6e1d5(e);
    return await t.checkSession(), t;
}


var $ecf72800a9078842$exports = {};
function $0f3848f7a1c2078a$export$71511d61b312f219() {
    $0f3848f7a1c2078a$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f3848f7a1c2078a$export$71511d61b312f219.apply(this, arguments);
}


function $63817221bd623677$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}




function $d4f2c7c7deccaef7$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $ea8150e9c5ee7fe1$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $d4f2c7c7deccaef7$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


"use strict";
var $ecf72800a9078842$var$__defProp = Object.defineProperty;
var $ecf72800a9078842$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ecf72800a9078842$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ecf72800a9078842$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ecf72800a9078842$var$__export = (target, all)=>{
    for(var name in all)$ecf72800a9078842$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $ecf72800a9078842$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $ecf72800a9078842$var$__getOwnPropNames(from))if (!$ecf72800a9078842$var$__hasOwnProp.call(to, key) && key !== except) $ecf72800a9078842$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $ecf72800a9078842$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $ecf72800a9078842$var$__toCommonJS = (mod)=>$ecf72800a9078842$var$__copyProps($ecf72800a9078842$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $ecf72800a9078842$var$index_exports = {};
$ecf72800a9078842$var$__export($ecf72800a9078842$var$index_exports, {
    AccessTokenEvents: ()=>$ecf72800a9078842$var$AccessTokenEvents,
    CheckSessionIFrame: ()=>$ecf72800a9078842$var$CheckSessionIFrame,
    DPoPState: ()=>$ecf72800a9078842$var$DPoPState,
    ErrorResponse: ()=>$ecf72800a9078842$var$ErrorResponse,
    ErrorTimeout: ()=>$ecf72800a9078842$var$ErrorTimeout,
    InMemoryWebStorage: ()=>$ecf72800a9078842$var$InMemoryWebStorage,
    IndexedDbDPoPStore: ()=>$ecf72800a9078842$var$IndexedDbDPoPStore,
    Log: ()=>$ecf72800a9078842$var$Log,
    Logger: ()=>$ecf72800a9078842$var$Logger,
    MetadataService: ()=>$ecf72800a9078842$var$MetadataService,
    OidcClient: ()=>$ecf72800a9078842$var$OidcClient,
    OidcClientSettingsStore: ()=>$ecf72800a9078842$var$OidcClientSettingsStore,
    SessionMonitor: ()=>$ecf72800a9078842$var$SessionMonitor,
    SigninResponse: ()=>$ecf72800a9078842$var$SigninResponse,
    SigninState: ()=>$ecf72800a9078842$var$SigninState,
    SignoutResponse: ()=>$ecf72800a9078842$var$SignoutResponse,
    State: ()=>$ecf72800a9078842$var$State,
    User: ()=>$ecf72800a9078842$var$User,
    UserManager: ()=>$ecf72800a9078842$var$UserManager,
    UserManagerSettingsStore: ()=>$ecf72800a9078842$var$UserManagerSettingsStore,
    Version: ()=>$ecf72800a9078842$var$Version,
    WebStorageStateStore: ()=>$ecf72800a9078842$var$WebStorageStateStore
});
$ecf72800a9078842$exports = $ecf72800a9078842$var$__toCommonJS($ecf72800a9078842$var$index_exports);
// src/utils/Logger.ts
var $ecf72800a9078842$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $ecf72800a9078842$var$level;
var $ecf72800a9078842$var$logger;
var $ecf72800a9078842$var$Log = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($ecf72800a9078842$var$Log || {});
((Log2)=>{
    function reset() {
        $ecf72800a9078842$var$level = 3 /* INFO */ ;
        $ecf72800a9078842$var$logger = $ecf72800a9078842$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $ecf72800a9078842$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $ecf72800a9078842$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($ecf72800a9078842$var$Log || ($ecf72800a9078842$var$Log = {}));
var $ecf72800a9078842$var$Logger = class _Logger {
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($ecf72800a9078842$var$level >= 4 /* DEBUG */ ) $ecf72800a9078842$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($ecf72800a9078842$var$level >= 3 /* INFO */ ) $ecf72800a9078842$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($ecf72800a9078842$var$level >= 2 /* WARN */ ) $ecf72800a9078842$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($ecf72800a9078842$var$level >= 1 /* ERROR */ ) $ecf72800a9078842$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($ecf72800a9078842$var$level >= 4 /* DEBUG */ ) $ecf72800a9078842$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($ecf72800a9078842$var$level >= 3 /* INFO */ ) $ecf72800a9078842$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($ecf72800a9078842$var$level >= 2 /* WARN */ ) $ecf72800a9078842$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($ecf72800a9078842$var$level >= 1 /* ERROR */ ) $ecf72800a9078842$var$logger.error(_Logger._format(name), ...args);
    }
    constructor(_name){
        this._name = _name;
    }
};
$ecf72800a9078842$var$Log.reset();
class $12b37b146a2ef9c0$export$b9721ef022f71a68 extends Error {
}
$12b37b146a2ef9c0$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $12b37b146a2ef9c0$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $12b37b146a2ef9c0$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $12b37b146a2ef9c0$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $12b37b146a2ef9c0$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $12b37b146a2ef9c0$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $12b37b146a2ef9c0$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $12b37b146a2ef9c0$var$base64UrlDecode(part);
    } catch (e) {
        throw new $12b37b146a2ef9c0$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $12b37b146a2ef9c0$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


var $ecf72800a9078842$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $12b37b146a2ef9c0$export$fa1e2fb699b7861e)(token);
        } catch (err) {
            $ecf72800a9078842$var$Logger.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $ecf72800a9078842$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $ecf72800a9078842$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $ecf72800a9078842$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $ecf72800a9078842$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $ecf72800a9078842$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $ecf72800a9078842$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $ecf72800a9078842$var$Logger.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $ecf72800a9078842$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $ecf72800a9078842$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $ecf72800a9078842$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $ecf72800a9078842$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $ecf72800a9078842$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $ecf72800a9078842$var$CryptoUtils = $ecf72800a9078842$var$_CryptoUtils;
// src/utils/Event.ts
var $ecf72800a9078842$var$Event = class {
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $ecf72800a9078842$var$Logger(`Event('${this._name}')`);
    }
};
// src/utils/PopupUtils.ts
var $ecf72800a9078842$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center(_param) {
        var features = (0, $0f3848f7a1c2078a$export$71511d61b312f219)({}, (0, $63817221bd623677$export$71511d61b312f219)(_param));
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $ecf72800a9078842$var$Timer = class _Timer extends $ecf72800a9078842$var$Event {
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
    constructor(){
        super(...arguments);
        this._logger = new $ecf72800a9078842$var$Logger(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
};
// src/utils/UrlUtils.ts
var $ecf72800a9078842$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $ecf72800a9078842$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $ecf72800a9078842$var$ErrorResponse = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $ecf72800a9078842$var$Logger.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $ecf72800a9078842$var$ErrorTimeout = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $ecf72800a9078842$var$AccessTokenEvents = class {
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
    constructor(args){
        this._logger = new $ecf72800a9078842$var$Logger("AccessTokenEvents");
        this._expiringTimer = new $ecf72800a9078842$var$Timer("Access token expiring");
        this._expiredTimer = new $ecf72800a9078842$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
};
// src/CheckSessionIFrame.ts
var $ecf72800a9078842$var$CheckSessionIFrame = class {
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $ecf72800a9078842$var$Logger("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
};
// src/InMemoryWebStorage.ts
var $ecf72800a9078842$var$InMemoryWebStorage = class {
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
    constructor(){
        this._logger = new $ecf72800a9078842$var$Logger("InMemoryWebStorage");
        this._data = {};
    }
};
// src/errors/ErrorDPoPNonce.ts
var $ecf72800a9078842$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $ecf72800a9078842$var$JsonService = class {
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds } = init, initFetch = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(init, [
            "timeoutInSeconds"
        ]);
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, (0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, init), {
                signal: controller.signal
            }));
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $ecf72800a9078842$var$ErrorTimeout("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $ecf72800a9078842$var$ErrorResponse(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = (0, $b62be182d8770687$export$71511d61b312f219)({
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded"
        }, extraHeaders);
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $ecf72800a9078842$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $ecf72800a9078842$var$ErrorResponse(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $ecf72800a9078842$var$Logger("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
};
// src/MetadataService.ts
var $ecf72800a9078842$var$MetadataService = class {
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $ecf72800a9078842$var$Logger("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $ecf72800a9078842$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
};
// src/WebStorageStateStore.ts
var $ecf72800a9078842$var$WebStorageStateStore = class {
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $ecf72800a9078842$var$Logger("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
};
// src/OidcClientSettings.ts
var $ecf72800a9078842$var$DefaultResponseType = "code";
var $ecf72800a9078842$var$DefaultScope = "openid";
var $ecf72800a9078842$var$DefaultClientAuthentication = "client_secret_post";
var $ecf72800a9078842$var$DefaultStaleStateAgeInSeconds = 900;
var $ecf72800a9078842$var$OidcClientSettingsStore = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $ecf72800a9078842$var$DefaultResponseType, scope: scope = $ecf72800a9078842$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $ecf72800a9078842$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $ecf72800a9078842$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $ecf72800a9078842$var$InMemoryWebStorage();
            this.stateStore = new $ecf72800a9078842$var$WebStorageStateStore({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $ecf72800a9078842$var$UserInfoService = class {
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $ecf72800a9078842$var$Logger("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $ecf72800a9078842$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $ecf72800a9078842$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
};
// src/TokenClient.ts
var $ecf72800a9078842$var$TokenClient = class {
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode(_param) {
        var { grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders } = _param, args = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(_param, [
            "grant_type",
            "redirect_uri",
            "client_id",
            "client_secret",
            "extraHeaders"
        ]);
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $ecf72800a9078842$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $ecf72800a9078842$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials(_param) {
        var { grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope } = _param, args = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(_param, [
            "grant_type",
            "client_id",
            "client_secret",
            "scope"
        ]);
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $ecf72800a9078842$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $ecf72800a9078842$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken(_param) {
        var { grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders } = _param, args = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(_param, [
            "grant_type",
            "client_id",
            "client_secret",
            "timeoutInSeconds",
            "extraHeaders"
        ]);
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $ecf72800a9078842$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $ecf72800a9078842$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $ecf72800a9078842$var$Logger("TokenClient");
        this._jsonService = new $ecf72800a9078842$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
};
// src/ResponseValidator.ts
var $ecf72800a9078842$var$ResponseValidator = class {
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response, "", state.nonce);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $ecf72800a9078842$var$ErrorResponse(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $ecf72800a9078842$var$ErrorResponse(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode((0, $b62be182d8770687$export$71511d61b312f219)({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders
            }, state.extraTokenParams));
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken, nonce) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $ecf72800a9078842$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (nonce && incoming.nonce !== nonce) logger2.throw(new Error("nonce in id_token does not match nonce in client storage"));
        if (existingToken) {
            const existing = $ecf72800a9078842$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $ecf72800a9078842$var$Logger("ResponseValidator");
        this._userInfoService = new $ecf72800a9078842$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $ecf72800a9078842$var$TokenClient(this._settings, this._metadataService);
    }
};
// src/State.ts
var $ecf72800a9078842$var$State = class _State {
    toStorageString() {
        new $ecf72800a9078842$var$Logger("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $ecf72800a9078842$var$Logger.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $ecf72800a9078842$var$Logger.createStatic("State", "clearStaleState");
        const cutoff = $ecf72800a9078842$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
    constructor(args){
        this.id = args.id || $ecf72800a9078842$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $ecf72800a9078842$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
};
// src/SigninState.ts
var $ecf72800a9078842$var$SigninState = class _SigninState extends $ecf72800a9078842$var$State {
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $ecf72800a9078842$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $ecf72800a9078842$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState((0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, args), {
            code_verifier: code_verifier,
            code_challenge: code_challenge
        }));
    }
    toStorageString() {
        new $ecf72800a9078842$var$Logger("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo,
            nonce: this.nonce
        });
    }
    static fromStorageString(storageString) {
        $ecf72800a9078842$var$Logger.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
        this.nonce = args.nonce;
    }
};
// src/SigninRequest.ts
var $ecf72800a9078842$var$_SigninRequest = class _SigninRequest {
    static async create(_param) {
        var { url: // mandatory
        url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
        state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting } = _param, optionalParams = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(_param, [
            "url",
            "authority",
            "client_id",
            "redirect_uri",
            "response_type",
            "scope",
            "state_data",
            "response_mode",
            "request_type",
            "client_secret",
            "nonce",
            "url_state",
            "resource",
            "skipUserInfo",
            "extraQueryParams",
            "extraTokenParams",
            "disablePKCE",
            "dpopJkt",
            "omitScopeWhenRequesting"
        ]);
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $ecf72800a9078842$var$SigninState.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo,
            nonce: nonce
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$ecf72800a9078842$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries((0, $b62be182d8770687$export$71511d61b312f219)({
            response_mode: response_mode
        }, optionalParams, extraQueryParams)))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
};
$ecf72800a9078842$var$_SigninRequest._logger = new $ecf72800a9078842$var$Logger("SigninRequest");
var $ecf72800a9078842$var$SigninRequest = $ecf72800a9078842$var$_SigninRequest;
// src/SigninResponse.ts
var $ecf72800a9078842$var$OidcScope = "openid";
var $ecf72800a9078842$var$SigninResponse = class {
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $ecf72800a9078842$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $ecf72800a9078842$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($ecf72800a9078842$var$OidcScope)) || !!this.id_token;
    }
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($ecf72800a9078842$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($ecf72800a9078842$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
};
// src/SignoutRequest.ts
var $ecf72800a9078842$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $ecf72800a9078842$var$Logger("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $ecf72800a9078842$var$State({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$ecf72800a9078842$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries((0, $b62be182d8770687$export$71511d61b312f219)({}, extraQueryParams)))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $ecf72800a9078842$var$SignoutResponse = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($ecf72800a9078842$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($ecf72800a9078842$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $ecf72800a9078842$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $ecf72800a9078842$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $ecf72800a9078842$var$ClaimsService = class {
    filterProtocolClaims(claims) {
        const result = (0, $b62be182d8770687$export$71511d61b312f219)({}, claims);
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $ecf72800a9078842$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$ecf72800a9078842$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = (0, $b62be182d8770687$export$71511d61b312f219)({}, claims1);
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $ecf72800a9078842$var$Logger("ClaimsService");
    }
};
// src/DPoPStore.ts
var $ecf72800a9078842$var$DPoPState = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $ecf72800a9078842$var$OidcClient = class {
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $ecf72800a9078842$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $ecf72800a9078842$var$SigninResponse($ecf72800a9078842$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $ecf72800a9078842$var$SigninState.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = (0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, extraHeaders), {
                "DPoP": dpopProof
            });
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $ecf72800a9078842$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $ecf72800a9078842$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $ecf72800a9078842$var$DPoPState(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $ecf72800a9078842$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials((0, $b62be182d8770687$export$71511d61b312f219)({
            username: username,
            password: password
        }, extraTokenParams));
        const signinResponse = new $ecf72800a9078842$var$SigninResponse(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = (0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, extraHeaders), {
                "DPoP": dpopProof
            });
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken((0, $b62be182d8770687$export$71511d61b312f219)({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders
            }, extraTokenParams));
        } catch (err) {
            if (err instanceof $ecf72800a9078842$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken((0, $b62be182d8770687$export$71511d61b312f219)({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders
                }, extraTokenParams));
            } else throw err;
        }
        const response = new $ecf72800a9078842$var$SigninResponse(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, (0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, state), {
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        }));
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $ecf72800a9078842$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $ecf72800a9078842$var$SignoutResponse($ecf72800a9078842$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $ecf72800a9078842$var$ErrorResponse(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $ecf72800a9078842$var$State.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $ecf72800a9078842$var$State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
    constructor(settings, metadataService){
        this._logger = new $ecf72800a9078842$var$Logger("OidcClient");
        this.settings = settings instanceof $ecf72800a9078842$var$OidcClientSettingsStore ? settings : new $ecf72800a9078842$var$OidcClientSettingsStore(settings);
        this.metadataService = metadataService != null ? metadataService : new $ecf72800a9078842$var$MetadataService(this.settings);
        this._claimsService = new $ecf72800a9078842$var$ClaimsService(this.settings);
        this._validator = new $ecf72800a9078842$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $ecf72800a9078842$var$TokenClient(this.settings, this.metadataService);
    }
};
// src/SessionMonitor.ts
var $ecf72800a9078842$var$SessionMonitor = class {
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $ecf72800a9078842$var$Logger("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $ecf72800a9078842$var$CheckSessionIFrame(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
};
// src/User.ts
var $ecf72800a9078842$var$User = class _User {
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $ecf72800a9078842$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $ecf72800a9078842$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $ecf72800a9078842$var$Logger("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $ecf72800a9078842$var$Logger.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
};
// src/navigators/AbstractChildWindow.ts
var $ecf72800a9078842$var$messageSource = "oidc-client";
var $ecf72800a9078842$var$AbstractChildWindow = class {
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $ecf72800a9078842$var$messageSource) return;
                try {
                    const state = $ecf72800a9078842$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch (e) {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $ecf72800a9078842$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $ecf72800a9078842$var$Logger("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
    constructor(){
        this._abort = new $ecf72800a9078842$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
};
// src/UserManagerSettings.ts
var $ecf72800a9078842$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $ecf72800a9078842$var$DefaultPopupTarget = "_blank";
var $ecf72800a9078842$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $ecf72800a9078842$var$DefaultCheckSessionIntervalInSeconds = 2;
var $ecf72800a9078842$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $ecf72800a9078842$var$UserManagerSettingsStore = class extends $ecf72800a9078842$var$OidcClientSettingsStore {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $ecf72800a9078842$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $ecf72800a9078842$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $ecf72800a9078842$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $ecf72800a9078842$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, maxSilentRenewTimeoutRetries: maxSilentRenewTimeoutRetries, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $ecf72800a9078842$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        this.maxSilentRenewTimeoutRetries = maxSilentRenewTimeoutRetries;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $ecf72800a9078842$var$InMemoryWebStorage();
            this.userStore = new $ecf72800a9078842$var$WebStorageStateStore({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $ecf72800a9078842$var$IFrameWindow = class _IFrameWindow extends $ecf72800a9078842$var$AbstractChildWindow {
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $ecf72800a9078842$var$ErrorTimeout("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $ecf72800a9078842$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $ecf72800a9078842$var$Logger("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
};
// src/navigators/IFrameNavigator.ts
var $ecf72800a9078842$var$IFrameNavigator = class {
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $ecf72800a9078842$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $ecf72800a9078842$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $ecf72800a9078842$var$Logger("IFrameNavigator");
    }
};
// src/navigators/PopupWindow.ts
var $ecf72800a9078842$var$checkForPopupClosedInterval = 500;
var $ecf72800a9078842$var$second = 1e3;
var $ecf72800a9078842$var$PopupWindow = class extends $ecf72800a9078842$var$AbstractChildWindow {
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $ecf72800a9078842$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
    constructor({ popupWindowTarget: popupWindowTarget = $ecf72800a9078842$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $ecf72800a9078842$var$Logger("PopupWindow");
        const centeredPopup = $ecf72800a9078842$var$PopupUtils.center((0, $b62be182d8770687$export$71511d61b312f219)({}, $ecf72800a9078842$var$DefaultPopupWindowFeatures, popupWindowFeatures));
        this._window = window.open(void 0, popupWindowTarget, $ecf72800a9078842$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $ecf72800a9078842$var$second);
    }
};
// src/navigators/PopupNavigator.ts
var $ecf72800a9078842$var$PopupNavigator = class {
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $ecf72800a9078842$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $ecf72800a9078842$var$PopupWindow.notifyOpener(url, keepOpen);
    }
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $ecf72800a9078842$var$Logger("PopupNavigator");
    }
};
// src/navigators/RedirectNavigator.ts
var $ecf72800a9078842$var$RedirectNavigator = class {
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $ecf72800a9078842$var$Logger("RedirectNavigator");
    }
};
// src/UserManagerEvents.ts
var $ecf72800a9078842$var$UserManagerEvents = class extends $ecf72800a9078842$var$AccessTokenEvents {
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $ecf72800a9078842$var$Logger("UserManagerEvents");
        this._userLoaded = new $ecf72800a9078842$var$Event("User loaded");
        this._userUnloaded = new $ecf72800a9078842$var$Event("User unloaded");
        this._silentRenewError = new $ecf72800a9078842$var$Event("Silent renew error");
        this._userSignedIn = new $ecf72800a9078842$var$Event("User signed in");
        this._userSignedOut = new $ecf72800a9078842$var$Event("User signed out");
        this._userSessionChanged = new $ecf72800a9078842$var$Event("User session changed");
    }
};
// src/SilentRenewService.ts
var $ecf72800a9078842$var$SilentRenewService = class {
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $ecf72800a9078842$var$Logger("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $ecf72800a9078842$var$Timer("Retry Silent Renew");
        this._timeoutRetryCount = 0;
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                this._timeoutRetryCount = 0;
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $ecf72800a9078842$var$ErrorTimeout) {
                    this._timeoutRetryCount++;
                    const maxRetries = this._userManager.settings.maxSilentRenewTimeoutRetries;
                    const hasReachedLimit = maxRetries !== void 0 && this._timeoutRetryCount > maxRetries;
                    if (hasReachedLimit) {
                        logger2.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${maxRetries}), raising silentRenewError:`, err);
                        this._timeoutRetryCount = 0;
                        await this._userManager.events._raiseSilentRenewError(err);
                        return;
                    }
                    logger2.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, err);
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                this._timeoutRetryCount = 0;
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
};
// src/RefreshState.ts
var $ecf72800a9078842$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $ecf72800a9078842$var$UserManager = class {
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "redirectMethod"
        ]);
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "si:r",
            dpopJkt: dpopJkt
        }, requestArgs), handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "popupWindowFeatures",
            "popupWindowTarget",
            "popupSignal",
            "popupAbortOnClose"
        ]);
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt
        }, requestArgs), handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "silentRequestTimeoutInSeconds"
        ]);
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $ecf72800a9078842$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt
        }, requestArgs), handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken((0, $b62be182d8770687$export$71511d61b312f219)({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
        }, args));
        const user = new $ecf72800a9078842$var$User((0, $b62be182d8770687$export$71511d61b312f219)({}, args.state, response));
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "silentRequestTimeoutInSeconds"
        ]);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true
        }, requestArgs), handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $ecf72800a9078842$var$ErrorResponse) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $ecf72800a9078842$var$User(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $ecf72800a9078842$var$ErrorResponse((0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, signinResponse), {
                    error: "login_required"
                }));
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "redirectMethod"
        ]);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri
        }, requestArgs), handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "popupWindowFeatures",
            "popupWindowTarget",
            "popupSignal"
        ]);
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {}
        }, requestArgs), handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds } = args, requestArgs = (0, $ea8150e9c5ee7fe1$export$71511d61b312f219)(args, [
            "silentRequestTimeoutInSeconds"
        ]);
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout((0, $b62be182d8770687$export$71511d61b312f219)({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint
        }, requestArgs), handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $ecf72800a9078842$var$User.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $ecf72800a9078842$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $ecf72800a9078842$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $ecf72800a9078842$var$DPoPState(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $ecf72800a9078842$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $ecf72800a9078842$var$Logger("UserManager");
        this.settings = new $ecf72800a9078842$var$UserManagerSettingsStore(settings);
        this._client = new $ecf72800a9078842$var$OidcClient(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $ecf72800a9078842$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $ecf72800a9078842$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $ecf72800a9078842$var$IFrameNavigator(this.settings);
        this._events = new $ecf72800a9078842$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $ecf72800a9078842$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $ecf72800a9078842$var$SessionMonitor(this);
    }
};
// package.json
var $ecf72800a9078842$var$version = "3.5.0";
// src/Version.ts
var $ecf72800a9078842$var$Version = $ecf72800a9078842$var$version;
// src/IndexedDbDPoPStore.ts
var $ecf72800a9078842$var$IndexedDbDPoPStore = class {
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
};


function $989f7b1225ded021$export$6d49e18df3744366() {
    return Object.keys(localStorage).some((key)=>key.includes('@@auth0spajs@@'));
}
function $989f7b1225ded021$export$85ab35758b70cb9() {
    const prefix = `oidc.user:${"https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_dypi6ozB1"}:`;
    return Object.keys(localStorage).some((key)=>key.startsWith(prefix));
}
function $989f7b1225ded021$var$clearMatchingStorage(matcher) {
    for (const key of Object.keys(localStorage))if (matcher(key)) localStorage.removeItem(key);
    for (const key of Object.keys(sessionStorage))if (matcher(key)) sessionStorage.removeItem(key);
}
function $989f7b1225ded021$var$clearAuth0Storage() {
    $989f7b1225ded021$var$clearMatchingStorage((key)=>key.includes('@@auth0spajs@@'));
}
function $989f7b1225ded021$var$clearCognitoStorage() {
    const prefix = `oidc.user:${"https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_dypi6ozB1"}:`;
    $989f7b1225ded021$var$clearMatchingStorage((key)=>key.startsWith(prefix));
}
function $989f7b1225ded021$export$e03294987260fdd8() {
    var _params_get;
    const params = new URLSearchParams(window.location.search);
    const provider = (_params_get = params.get('auth_provider')) === null || _params_get === void 0 ? void 0 : _params_get.toLowerCase();
    if (provider === 'auth0') {
        $989f7b1225ded021$var$clearCognitoStorage();
        return 'auth0';
    }
    if (provider === 'cognito') {
        $989f7b1225ded021$var$clearAuth0Storage();
        return 'cognito';
    }
    // Existing session continuity
    if ($989f7b1225ded021$export$85ab35758b70cb9()) return 'cognito';
    return null;
}
function $989f7b1225ded021$var$hasCognitoSessionForClient(clientId) {
    const key = `oidc.user:${"https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_dypi6ozB1"}:${clientId}`;
    return localStorage.getItem(key) !== null;
}
function $989f7b1225ded021$export$98f1f7ad30be6cb9() {
    var _params_get;
    const params = new URLSearchParams(window.location.search);
    const flow = (_params_get = params.get('flow')) === null || _params_get === void 0 ? void 0 : _params_get.toLowerCase();
    if (flow === 'internal' || flow === 'external') return flow;
    // Existing Cognito session
    if ($989f7b1225ded021$var$hasCognitoSessionForClient("48p0kb4o842tqb2dpeu4hd2ii3")) return 'internal';
    if ($989f7b1225ded021$var$hasCognitoSessionForClient("646c5skmh3j67v8v3hf440sjrc")) return 'external';
    return 'external';
}
function $989f7b1225ded021$export$c418196cecf912ed() {
    const provider = $989f7b1225ded021$export$e03294987260fdd8();
    if (provider === 'auth0') return "msoezlY6p3gfsQiblyBxiSXUmfl74JqK";
    const flow = $989f7b1225ded021$export$98f1f7ad30be6cb9();
    if (flow === 'internal') return "48p0kb4o842tqb2dpeu4hd2ii3";
    return "646c5skmh3j67v8v3hf440sjrc";
}
function $989f7b1225ded021$export$3ca1530a76305b39() {
    const currentUrl = new URL(window.location.href);
    const discoveryUrl = new URL('/login/discover', "https://identity.web.uk.csp.nccgroup.com");
    discoveryUrl.searchParams.set('post_discovery_url', currentUrl.toString());
    window.location.replace(discoveryUrl.toString());
}
function $989f7b1225ded021$export$129240df1699ece5() {
    const url = new URL(window.location.href);
    const authParams = [
        'auth_provider',
        'flow',
        'hint',
        'code',
        'state',
        'session_state',
        'iss'
    ];
    authParams.forEach((param)=>url.searchParams.delete(param));
    window.history.replaceState({}, document.title, url.toString());
}
async function $989f7b1225ded021$export$50d18071e107d264() {
    const authnStateUrl = new URL('/auth/state', "https://identity.web.uk.csp.nccgroup.com");
    return fetch(authnStateUrl, {
        method: "DELETE",
        credentials: "include"
    });
}


var $a6280279a1924076$exports = {};
$a6280279a1924076$exports = $parcel$resolve("ctuFy");


var $11b1fac2bd9222d5$exports = {};
$11b1fac2bd9222d5$exports = $parcel$resolve("9s4Us");


var $2e734691224d6cf7$exports = {};
$2e734691224d6cf7$exports = $parcel$resolve("h32ee");


const $886b5a4de40a20ea$export$923909f881c657c5 = {
    'app:sfe': {
        title: 'Secure File Exchange',
        description: 'Create repositories and share files',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($2e734691224d6cf7$exports))),
        href: "https://sfe.web.uk.csp.nccgroup.com",
        app_id: 'SFE',
        notif_href: `${"https://identity.web.uk.csp.nccgroup.com"}/notifications/sfe`
    },
    'app:pentest': {
        title: 'Pentest Service',
        description: 'Upload reports and manage findings',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($11b1fac2bd9222d5$exports))),
        href: "https://pentest.csp.nccgroup.com",
        app_id: 'Pentest',
        notif_href: `${"https://identity.web.uk.csp.nccgroup.com"}/notifications/pentest`
    },
    'app:catalogue': {
        title: 'Service Requests',
        description: 'Submit and track service requests',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($a6280279a1924076$exports))),
        href: "https://catalogue.web.uk.csp.nccgroup.com",
        app_id: 'Catalogue',
        notif_href: `${"https://identity.web.uk.csp.nccgroup.com"}/notifications/catalogue`
    }
};
const $886b5a4de40a20ea$export$22dda3d8b3f3edef = 'app:identity_admin';
const $886b5a4de40a20ea$export$16beef9fca2a07d = {
    [$886b5a4de40a20ea$export$22dda3d8b3f3edef]: {
        title: 'Identity Admin Portal',
        href: "https://identity.admin.uk.csp.nccgroup.com",
        app_id: 'identity_admin'
    }
};
const $886b5a4de40a20ea$export$c002bdf777e79ff4 = {
    insufficientPermissions: {
        type: 'info',
        message: "You don't have permissions to view this page."
    },
    serverError: {
        type: 'error',
        message: 'An error occurred. Please try again.'
    }
};
const $886b5a4de40a20ea$export$d6a5c11f04f75862 = {
    showOnlyEnabledApps: JSON.parse("true")
};


var $28109877f04b86a3$exports = {};
$28109877f04b86a3$exports = $parcel$resolve("3Ag3a");


var $fdfa8834ab2c5aac$exports = {};
$fdfa8834ab2c5aac$exports = $parcel$resolve("1pAQF");



function $287652999a7e798f$export$9a62e6c0a30e00bc(token) {
    // Split the token into its parts
    const parts = token.split('.');
    // Ensure the token has three parts
    if (parts.length !== 3) throw new Error('Invalid token');
    // Decode the payload
    const payload = parts[1];
    const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decodedPayload;
}
const $287652999a7e798f$var$COGNITO_GROUP_MAP = {
    catalogue: 'app:catalogue',
    catalogue_admin: 'app:catalogue_admin',
    identity: 'app:identity',
    identity_admin: 'app:identity_admin',
    pentest: 'app:pentest',
    pentest_admin: 'app:pentest_admin',
    sfe: 'app:sfe',
    sfe_admin: 'app:sfe_admin'
};
function $287652999a7e798f$export$10eb4f54a3859f60(jwt) {
    const permissions = new Set();
    // Auth0 permissions
    // Cognito custom permissions claim
    if (Array.isArray(jwt.permissions)) jwt.permissions.filter((p)=>p.startsWith('app:')).forEach((p)=>permissions.add(p));
    // Cognito groups
    const groups = jwt['cognito:groups'];
    if (Array.isArray(groups)) groups.map((group)=>$287652999a7e798f$var$COGNITO_GROUP_MAP[group]).filter(Boolean).forEach((permission)=>permissions.add(permission));
    return [
        ...permissions
    ];
}
function $287652999a7e798f$export$ff064696321480cc(thumbnail) {
    if (typeof thumbnail === 'string') return thumbnail;
    if (thumbnail && typeof thumbnail === 'object') {
        const d = thumbnail.default;
        if (typeof d === 'string') return d;
    }
    return '';
}
async function $287652999a7e798f$var$buildCard({ title: title, description: description = '', thumbnail: thumbnail = '', href: href, app_id: app_id, notif_href: notif_href }, token) {
    const content = document.getElementById('content');
    if (!content) throw new Error('#content not found');
    const tile = document.createElement('div');
    tile.className = 'box-bg rounded-lg shadow-lg overflow-hidden text-center w-[300px] h-[300px] flex flex-col items-center space-between cursor-pointer relative';
    tile.id = `tile_${app_id}`;
    // Link
    const link = document.createElement('a');
    link.className = 'box flex flex-col items-center';
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    // Title
    const cardTitle = document.createElement('h2');
    cardTitle.className = 'text-lg font-semibold p-4';
    cardTitle.textContent = title;
    // Description
    const cardDescription = document.createElement('p');
    cardDescription.className = 'text-xs text-grey-50 mt-2 mb-4';
    cardDescription.textContent = description;
    // Thumbnail
    const cardThumbnail = document.createElement('img');
    cardThumbnail.src = $287652999a7e798f$export$ff064696321480cc(thumbnail);
    cardThumbnail.className = 'w-60 h-60';
    cardThumbnail.alt = `${title} icon`;
    link.append(cardTitle, cardDescription, cardThumbnail);
    // Bell (outside the <a>)
    const bell = document.createElement('div');
    bell.className = 'absolute right-0 top-0 p-3 cursor-not-allowed';
    bell.id = `bell_${app_id}`;
    const bellIcon = document.createElement('img');
    bellIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($28109877f04b86a3$exports)));
    bellIcon.width = 20;
    bellIcon.height = 20;
    bellIcon.className = 'light-mode';
    const bellIconDark = document.createElement('img');
    bellIconDark.src = (0, (/*@__PURE__*/$parcel$interopDefault($fdfa8834ab2c5aac$exports)));
    bellIconDark.width = 20;
    bellIconDark.height = 20;
    bellIconDark.className = 'dark-mode';
    bell.append(bellIcon, bellIconDark);
    tile.append(link, bell);
    content.appendChild(tile);
    let count = 0;
    try {
        var _notification_json_items;
        const response = await fetch(`${"https://prod.notifications.api.uk.csp.nccgroup.com"}/v2/notification?app_id=${app_id}&read_value=unread`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const notification_json = await response.json();
        var _notification_json_items_length;
        count = (_notification_json_items_length = (_notification_json_items = notification_json.items) === null || _notification_json_items === void 0 ? void 0 : _notification_json_items.length) !== null && _notification_json_items_length !== void 0 ? _notification_json_items_length : 0;
    } catch (error) {
        console.error('Error fetching notifications:', error);
    }
    if (count > 0) {
        const countEl = document.createElement('span');
        countEl.className = 'w-5 h-5 rounded-full bg-red text-white font-medium absolute top-1 right-1 border-white border-2 text-[11px] flex justify-center items-center transition duration-200 hover:scale-125 hover:-translate-y-0.5';
        countEl.textContent = String(count);
        bell.appendChild(countEl);
        bell.classList.remove('cursor-not-allowed');
    }
    bell.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (count <= 0) return;
        window.open(notif_href, '_blank', 'noopener,noreferrer');
    });
}
async function $287652999a7e798f$export$c9c3ddb0a02ba2c1(token) {
    /* Decode JWT Token and extract apps */ let permissions;
    if ((0, $886b5a4de40a20ea$export$d6a5c11f04f75862).showOnlyEnabledApps) permissions = $287652999a7e798f$export$10eb4f54a3859f60($287652999a7e798f$export$9a62e6c0a30e00bc(token));
    else permissions = Object.keys((0, $886b5a4de40a20ea$export$923909f881c657c5));
    document.getElementById('loader').classList.remove('hidden');
    /* Create a tile for each app and append it to content */ permissions.forEach(async (element)=>{
        if ((0, $886b5a4de40a20ea$export$923909f881c657c5)[element] !== undefined) $287652999a7e798f$var$buildCard((0, $886b5a4de40a20ea$export$923909f881c657c5)[element], token);
    });
    document.getElementById('content').classList.remove('hidden');
    document.getElementById('loader').classList.add('hidden');
    if (permissions.includes((0, $886b5a4de40a20ea$export$22dda3d8b3f3edef))) {
        const userAdminLink = document.getElementById('user-admin-link');
        userAdminLink.setAttribute('href', (0, $886b5a4de40a20ea$export$16beef9fca2a07d)[0, $886b5a4de40a20ea$export$22dda3d8b3f3edef]['href']);
        userAdminLink.classList.remove('hidden');
        userAdminLink.classList.add('flex');
    }
    if (!permissions.length) $287652999a7e798f$export$16eaafd857012361((0, $886b5a4de40a20ea$export$c002bdf777e79ff4).insufficientPermissions.message);
}
function $287652999a7e798f$export$16eaafd857012361(message) {
    document.getElementById('statusMessage').classList.remove('hidden');
    document.getElementById('loader').classList.add('hidden');
    document.getElementById('customMessage').innerHTML = message;
}
function $287652999a7e798f$export$49e16ec648d05eb2(darkMode) {
    document.documentElement.dataset.theme = darkMode ? 'dark' : '';
    if (darkMode) {
        document.getElementById('toggle-dot').classList.remove('-translate-x-2.5');
        document.getElementById('toggle-dot').classList.add('translate-x-2.5');
    } else {
        document.getElementById('toggle-dot').classList.remove('translate-x-2.5');
        document.getElementById('toggle-dot').classList.add('-translate-x-2.5');
    }
    $287652999a7e798f$export$faf76607d863714d(darkMode);
}
function $287652999a7e798f$export$4b4862dca5a492a6() {
    if (typeof window !== 'undefined') {
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) return JSON.parse(saved);
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
}
function $287652999a7e798f$export$faf76607d863714d(darkMode) {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
}
function $287652999a7e798f$export$968c68bd88b425a3() {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = `${"https://static.csp.nccgroup.com"}/favicon.ico`;
    document.head.appendChild(link);
}


let $779aff4ca2352db9$export$8e63ac101d9492c0 = undefined;
let $779aff4ca2352db9$export$895f4acbad86ef19 = undefined;
async function $779aff4ca2352db9$export$a1ab8907eb6951c7() {
    const authProvider = (0, $989f7b1225ded021$export$e03294987260fdd8)();
    if (authProvider === 'cognito') {
        $779aff4ca2352db9$export$895f4acbad86ef19 = new (0, $ecf72800a9078842$exports.UserManager)({
            authority: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_dypi6ozB1",
            client_id: (0, $989f7b1225ded021$export$c418196cecf912ed)(),
            redirect_uri: `${window.location.origin}?auth_provider=cognito&flow=${(0, $989f7b1225ded021$export$98f1f7ad30be6cb9)()}`,
            response_type: 'code',
            scope: 'openid profile email',
            userStore: new (0, $ecf72800a9078842$exports.WebStorageStateStore)({
                store: window.localStorage
            })
        });
        return;
    }
    $779aff4ca2352db9$export$8e63ac101d9492c0 = await (0, $06484a9711eaa5fc$export$9fa2cfec0168886e)({
        cacheLocation: 'localstorage',
        authorizationParams: {
            audience: "https://csp.nccgroup.com",
            redirect_uri: `${window.location.origin}?auth_provider=auth0&flow=external`,
            scope: 'openid profile email offline_access'
        },
        domain: "nccgroup-prod.eu.auth0.com",
        clientId: "msoezlY6p3gfsQiblyBxiSXUmfl74JqK",
        useRefreshTokens: true
    });
}
async function $779aff4ca2352db9$var$getToken() {
    const authProvider = (0, $989f7b1225ded021$export$e03294987260fdd8)();
    if (authProvider === 'cognito') {
        const user = await ($779aff4ca2352db9$export$895f4acbad86ef19 === null || $779aff4ca2352db9$export$895f4acbad86ef19 === void 0 ? void 0 : $779aff4ca2352db9$export$895f4acbad86ef19.getUser());
        if (!user || user.expired) throw new Error('Expired token!');
        return user.access_token;
    }
    try {
        return await $779aff4ca2352db9$export$8e63ac101d9492c0.getTokenSilently();
    } catch (e) {
        throw new Error('Expired token!');
    }
}
async function $779aff4ca2352db9$export$596d806903d1f59e() {
    const authProvider = (0, $989f7b1225ded021$export$e03294987260fdd8)();
    if (!authProvider) {
        (0, $989f7b1225ded021$export$3ca1530a76305b39)();
        return;
    }
    let isAuthenticated = false;
    if (authProvider === 'cognito') {
        const user = await ($779aff4ca2352db9$export$895f4acbad86ef19 === null || $779aff4ca2352db9$export$895f4acbad86ef19 === void 0 ? void 0 : $779aff4ca2352db9$export$895f4acbad86ef19.getUser());
        isAuthenticated = Boolean(user && !user.expired);
    } else isAuthenticated = await $779aff4ca2352db9$export$8e63ac101d9492c0.isAuthenticated();
    console.debug(isAuthenticated, 'isAuthenticated');
    if (isAuthenticated) try {
        const token = await $779aff4ca2352db9$var$getToken();
        (0, $989f7b1225ded021$export$129240df1699ece5)();
        (0, $287652999a7e798f$export$c9c3ddb0a02ba2c1)(token);
        return;
    } catch (e) {
        console.debug(e, 'Authenticated failed due to stale token.');
        isAuthenticated = false;
        console.debug('isAuthentication set to ', isAuthenticated);
    }
    if (!isAuthenticated) {
        console.debug('Initiating handleRedirectCallback');
        const params = new URLSearchParams(window.location.search);
        if (params.get('code')) {
            if (authProvider === 'cognito') await $779aff4ca2352db9$export$895f4acbad86ef19.signinRedirectCallback();
            else await $779aff4ca2352db9$export$8e63ac101d9492c0.handleRedirectCallback();
            (0, $989f7b1225ded021$export$129240df1699ece5)();
            try {
                const token = await $779aff4ca2352db9$var$getToken();
                (0, $287652999a7e798f$export$c9c3ddb0a02ba2c1)(token);
            } catch (e) {
                console.debug('Error while handleRedirectCallback', e);
                (0, $287652999a7e798f$export$16eaafd857012361)((0, $886b5a4de40a20ea$export$c002bdf777e79ff4).serverError.message);
            }
        } else if (params.get('auth_provider')) await $779aff4ca2352db9$export$f7e25c24c3de1df7(params);
        else (0, $989f7b1225ded021$export$3ca1530a76305b39)();
    }
}
async function $779aff4ca2352db9$export$a0973bcfe11b05c9() {
    const authProvider = (0, $989f7b1225ded021$export$e03294987260fdd8)();
    let isAuthenticated = false;
    if (authProvider === 'cognito') {
        const user = await ($779aff4ca2352db9$export$895f4acbad86ef19 === null || $779aff4ca2352db9$export$895f4acbad86ef19 === void 0 ? void 0 : $779aff4ca2352db9$export$895f4acbad86ef19.getUser());
        isAuthenticated = Boolean(user && !user.expired);
    } else isAuthenticated = await $779aff4ca2352db9$export$8e63ac101d9492c0.isAuthenticated();
    await (0, $989f7b1225ded021$export$50d18071e107d264)();
    if (isAuthenticated) {
        if (authProvider === 'cognito') {
            await $779aff4ca2352db9$export$895f4acbad86ef19.signoutRedirect({
                extraQueryParams: {
                    client_id: (0, $989f7b1225ded021$export$c418196cecf912ed)(),
                    logout_uri: window.location.origin
                }
            });
            return;
        }
        $779aff4ca2352db9$export$8e63ac101d9492c0.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    } else {
        const params = new URLSearchParams(window.location.search);
        await $779aff4ca2352db9$export$f7e25c24c3de1df7(params);
    }
}
async function $779aff4ca2352db9$export$f7e25c24c3de1df7(params) {
    console.debug('loginWithRedirect');
    const authProvider = (0, $989f7b1225ded021$export$e03294987260fdd8)();
    const hint = params.get('hint');
    if (authProvider === 'cognito') {
        await $779aff4ca2352db9$export$895f4acbad86ef19.signinRedirect((0, $f7cf469f0d5164c0$export$71511d61b312f219)((0, $b62be182d8770687$export$71511d61b312f219)({}, hint && {
            extraQueryParams: {
                login_hint: hint
            }
        }), {
            state: {
                returnTo: window.location.pathname + window.location.search + window.location.hash
            }
        }));
        return;
    }
    const options = {
        authorizationParams: {}
    };
    const connection = params.get('connection');
    if (connection && options.authorizationParams) options.authorizationParams.connection = connection;
    if (hint && options.authorizationParams) options.authorizationParams.login_hint = hint;
    options.appState = {
        returnTo: window.location.pathname + window.location.search + window.location.hash
    };
    await $779aff4ca2352db9$export$8e63ac101d9492c0.loginWithRedirect(options);
}




window.onload = async ()=>{
    const logoutButton = document.querySelectorAll('.logout-button');
    (0, $287652999a7e798f$export$968c68bd88b425a3)();
    try {
        if ((0, $886b5a4de40a20ea$export$d6a5c11f04f75862).showOnlyEnabledApps) {
            await (0, $779aff4ca2352db9$export$a1ab8907eb6951c7)();
            (0, $779aff4ca2352db9$export$596d806903d1f59e)();
        } else (0, $287652999a7e798f$export$c9c3ddb0a02ba2c1)();
    } catch (e) {
        (0, $287652999a7e798f$export$16eaafd857012361)((0, $886b5a4de40a20ea$export$c002bdf777e79ff4).serverError.message);
    }
    if (logoutButton) logoutButton.forEach((instance)=>{
        instance.addEventListener('click', ()=>{
            (0, $779aff4ca2352db9$export$a0973bcfe11b05c9)();
        });
    });
    //Dark mode behaviour
    let isDarkmode = (0, $287652999a7e798f$export$4b4862dca5a492a6)();
    (0, $287652999a7e798f$export$49e16ec648d05eb2)(isDarkmode);
    document.getElementById('darkModeToggle').addEventListener('click', function() {
        isDarkmode = !isDarkmode;
        (0, $287652999a7e798f$export$49e16ec648d05eb2)(isDarkmode);
        (0, $287652999a7e798f$export$faf76607d863714d)(isDarkmode);
    });
};


//# sourceMappingURL=app.2a20da5a.js.map
